//React core packages
import React, { useState, useEffect, memo, useRef } from "react";
import moment from "moment";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//Third party packages
import { InputSchedule } from "./../setting/NotificationSettings/styled.js";
import { Modal, Form } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import RoomOutlined from "@material-ui/icons/RoomOutlined";
import LocalHospitalOutlined from "@material-ui/icons/LocalHospitalOutlined";
import PersonOutline from "@material-ui/icons/PersonOutline";
import { Select } from "antd";

import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Dropdown as Dropdownant } from "react-bootstrap";
import doctorLogo from "../../assets/images/fontisto_doctor.png";
import errorIcon from "../../assets/images/error-icon.png";
import {
  RepeatBtnConfirm,
  RepeatFooter,
  RepeatPopupBlock,
  RepeatPopupHeader,
} from "../schedule/styles";
import {
  Spinner,
  Button,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import axios from "axios";
import { DatePicker, Radio } from "antd";
import { IoCloseSharp, IoFlagOutline } from "react-icons/io5";
import { Switch } from "antd";
import { Popup } from "semantic-ui-react";
import { PhoneNumberUtil } from "google-libphonenumber";
// Internal Components
import {
  setBookingData,
  SetPatientBool,
} from "./../../StateManagement/Reducers/ScheduleState";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { AccessMailUrl } from "../../axios/url.js";
import "./Popups.css";
import axiosInstance from "../../axios/axios";
import {
  Image,
  SpinnerDiv,
  StyledSvg,
  StyledButton,
  StyledDiv,
} from "../../StyledComponents";
import { Div, Span } from "../billing/CardTransactions/styles";
import { BsFillCaretDownFill } from "react-icons/bs";
import {
  FiAlertCircle,
  FiAlertTriangle,
  FiChevronDown,
  FiChevronUp,
  FiMail,
  FiMessageSquare,
  FiPhoneCall,
  FiEdit2,
  FiCheck,
  FiX,
} from "react-icons/fi";
import UpgradeRequired from "../popups/UpgradeRequired";
import CreateClient from "./CreateClient";
import { BsCheckCircle } from "react-icons/bs";
import { Tabs } from "antd";
import AddAppTemplate from "./AddAppTemplate";
//utils
import { fileurl } from "../../axios/url.js";
import GetStartedPopup from "./GetStartedPopup.js";
import TwilioRingIntegrationModal from "../setting/Integrations/TwilioRingIntegrationModal";
import EmailIntegrationModal from "../setting/Integrations/EmailIntegrationModal";
import { clearReturnPath } from "../../StateManagement/Reducers/AccountSetupState.js";
import waitListIcon from "../../assets/images/waitlist-blue.svg";
import CreateGroupClients from "../popups/CreateGroupClients.js";
import IntakeForms from "../../components/patient/IntakeForms";
const { Option } = Select;
const { TabPane } = Tabs;

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export const specialityList = [
  "Plastic Surgery",
  "Dermatology",
  "Sleep Medicine",
  "Allergy & Immunology",
  "Concierge Medicine",
  "Oncology",
  "Palliative Care",
  "Endocrinology",
  "Sports Medicine",
  "Hospice",
  "Podiatry",
  "Pediatrics",
  "Pathology",
  "Obstetrics and Gynecology",
  "Hand Surgery",
  "Hematology",
  "Emergency Medicine",
  "Surgery",
  "Cardiology",
  "Vascular Surgery",
  "Pulmonology",
  "Austism",
  "Radiology",
  "ECG Management",
  "Physical Medicine & Rehabilitation",
  "Opthalmology",
  "Geriatric Medicine",
  "Neurology",
  "Infectious Disease",
  "Nephrology",
  "Ambulatory Care & Surgery",
  "Otolaryngology (ENT)",
  "Rheumatology",
  "Dental Health",
  "Chiropractic",
  "Psychiatry",
  "Urology",
  "Wound Care",
  "Orthopedic Surgery",
  "Behaviour Health",
  "Gastroenterology",
  "Anesthesiology",
  "Family Medicine",
  "Behavioral health therapy",
  "Acupuncture",
  "Lactation consulting",
  "Massage therapy",
  "Counseling",
  "Marriage and family therapy",
  "Psychology",
  "Social work",
  "Dietetics or nutrition counseling",
  "Applied behavior analysis",
  "Occupational therapy",
  "Physical therapy",
  "Speech-language pathology",
  "Substance use counseling",
  "Primary Care",
  "Other",
];

// const formatAppointmentOverlapMessage = (backendMsg) => {
//   if (!backendMsg) return "";

//   const match = backendMsg.match(/at (.+?) on ([0-9\-]+)/i);
//   let facility = "this facility";
//   let date = "";

//   if (match) {
//     facility = match[1].trim();
//     date = match[2].trim();
//   }

//   const formattedDate = date
//     ? moment(date, "YYYY-MM-DD").format("MMMM DD, YYYY")
//     : "";

//   return `There is an Existing Appointment Scheduled at ${facility} on ${formattedDate}. Kindly choose an alternative date or time`;
// };

//------------------------------------------------Billing facility validation--------------------------------------------------------//
const NO_BILLING_FACILITY_APPOINTMENT_WARNING =
  "Appointments cannot be scheduled because no Billing Facility is enabled in the Facility Information. - After scheduling appointments";

const getFilteredAndSortedProfiles = (profiles, isGroupAppointment = false) => {
  if (!profiles || !Array.isArray(profiles)) return [];
  let filtered = profiles.filter((profile) => {
    const name = profile.text || profile.pc_catname || "";
    if (isGroupAppointment) {
      if (name === "Individual Therapy") return false;
    } else {
      if (name === "Group Therapy") return false;
    }
    return true;
  });
  return filtered;
};

const sourcestatusphonecall = [
  { value: "call_scheduled", text: "Call Scheduled" },
  { value: "call_not_answered", text: "Call Not Answered" },
  { value: "call_completed", text: "Call Completed" },
  { value: "call_rescheduled", text: "Call Rescheduled" },
  { value: "call_cancelled", text: "Call Cancelled" },
];

const NewAppointment = (props) => {
  // ---------------------------------------- State and Variables Start--------------------------------------------------- //
  const { Option } = Select;
  const dispatch = useDispatch();
  const initialRender = useRef(true);
  const warningBannerRef = useRef(null);
  const scheduleBodyRef = useRef(null);
  const emailReminderRef = useRef(null);
  const step1Ref = useRef(null);
  const [step1PopupStyle, setStep1PopupStyle] = useState({ display: "none" });
  const [step2PopupStyle, setStep2PopupStyle] = useState({ display: "none" });
  const [saveButtonNode, setSaveButtonNode] = useState(null);
  const saveButtonRef = (node) => {
    if (node !== null) {
      setSaveButtonNode(node);
    }
  };
  const [patientNameSelectNode, setPatientNameSelectNode] = useState(null);
  const patientNameSelectRef = (node) => {
    if (node !== null) {
      setPatientNameSelectNode(node);
    }
  };
  const [selectFromWaitlistNode, setSelectFromWaitlistNode] = useState(null);
  const selectFromWaitlistRef = (node) => {
    if (node !== null) {
      setSelectFromWaitlistNode(node);
    }
  };

  const [showTwilioModal, setShowTwilioModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  var start = "";
  var end = "";
  const classes = useStyles();
  const phoneUtil = PhoneNumberUtil.getInstance();

  var currentDate = new Date();

  const roundDownToNearest5Minutes = (date) => {
    const ms = 1000 * 60 * 5;
    return new Date(Math.floor(date.getTime() / ms) * ms);
  };

  var roundedDate = roundDownToNearest5Minutes(currentDate);

  props.start ? (start = props.start.start) : (start = roundedDate);

  props.start
    ? (end = props.start.end)
    : (end = new Date(roundedDate.getTime() + 15 * 60000).toString());

  // Decrypt and Retrieve User Role and Account Information
  var accountType = Decrypt_Value(localStorage.getItem("account_type"), "vozo");
  var trial = Decrypt_Value(localStorage.getItem("trial_period"), "vozo");
  const bill_facility_id = useSelector(
    (state) => state.Schedule.BillingFacility,
  );
  const bookingData = useSelector((state) => state.Schedule.bookingData);
  const teleFlag = Decrypt_Value(
    localStorage.getItem("telehealth_flag"),
    "vozo",
  );

  const [showPopup, setShowPopup] = useState(false);
  const [onConfirm, setOnConfirm] = useState(null);

  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
  let DBHost =
    localStorage.getItem("DBHost") &&
    Decrypt_Value(localStorage.getItem("DBHost"), "vozo");

  const ENABLE_REASON_DROPDOWN = DBHost?.toLowerCase() === "laibonhealth";

  // const ENABLE_REASON_DROPDOWN = true;

  const reasonOptions = [
    "Acute Care",
    "Focused Care",
    "Primary Care",
    "Occupational Health",
    "Membership Services",
    "New Patient Visit",
    "Established Patient Visit",
    "Urgent Care Visit",
    "Follow-Up Visit",
    "Focused Care Visit",
    "Wellness & Weight Management",
    "Occupational Health Visit",
    "Membership Visit",
  ];

  //States
  const [reason, setReason] = useState("");
  // const [serviceCode, setServiceCode] = useState();
  const [serviceCode, setServiceCode] = useState([]);
  const [serviceCodeOptions, setServiceCodeOptions] = useState([]);
  const serviceCodeCacheRef = useRef({});
  const [serviceCodeSearch, setServiceCodeSearch] = useState("");
  const [serviceDuration, setServiceDuration] = useState("15 mins");

  const [individualServiceCode, setIndividualServiceCode] = useState([]);
  const [groupServiceCode, setGroupServiceCode] = useState([]);

  const [individualSearch, setIndividualSearch] = useState("");
  const [groupSearch, setGroupSearch] = useState("");

  const [individualDuration, setIndividualDuration] = useState("15 mins");
  const [groupDuration, setGroupDuration] = useState("15 mins");

  const [timeMismatch, setTimeMismatch] = useState(false);
  const [swict_check, setswict_check] = useState(false);
  const [Week_and_every, setWeek_and_every] = useState(false);
  const [Month_and_every, setMonth_and_every] = useState(false);
  const [Month_and_every_Interval, setMonth_and_every_Interval] = useState("");
  const [source, setSource] = useState([]);
  const [patientid, setpatientid] = useState("");
  const [popupWidth, setPopupWidth] = useState("500px");
  const [searchInput, setSearchInput] = useState("");

  const [searchInputValue, setSearchInputValue] = useState("");

  const [sourceroom, setSourceRoom] = useState([]);
  const [roomval, setRoomVal] = useState("");
  const [sourceprofile, setSourceprofile] = useState([]);
  console.log(
    "Profile names:",
    sourceprofile.map((p) => p.text || p.pc_catname),
  );
  const [profileid, setprofileid] = useState("");
  const [billingid, setbillingid] = useState("");
  const [sourceprovider, setSourceprovider] = useState([]);

  const [providerid, setproviderid] = useState("");
  const [sourceoffice, setSourceoffice] = useState([]);
  const [officeid, setofficeid] = useState("");
  const [sourcestatus, setSourcestatus] = useState([]);
  const [sourcestatustele, setSourcestatustele] = useState([]);

  const [statusid, setstatusid] = useState("");
  const dtFormat = localStorage.getItem("dateFormat");
  var dtFormatsec = `${dtFormat} hh:mm a`;
  const [aptdate, setaptdate] = useState("");
  const [dayswise, setdayswise] = useState(false);
  const [apttime, setapttime] = useState("");
  const [aptfromdate, setappfromdate] = useState("");
  const [apttodate, setapptodate] = useState("");
  const [SpinnerVal, setSpinnerVal] = useState(true);
  const [checking1, setchecking1] = useState(false);
  // const [telehealth, settelehealth] = useState([]);
  const [teleprofile, setteleprofile] = useState([]);
  const getInitialApptType = () => {
    const editApptId =
      props.start?.Id ?? props.start?.id ?? props.start?.pc_eid ?? null;
    if (
      editApptId !== null &&
      String(editApptId) !== "" &&
      String(editApptId) !== "0"
    ) {
      const pc_th = Number(
        props.start?.pc_telehealth ??
          props.start?.tele_health ??
          props.start?.is_telehealth ??
          props.start?.telehealth_flag ??
          props.start?.telehealth,
      );
      if (pc_th === 1) return 2;
      if (pc_th === 4) return 4;
    }
    return 1;
  };
  const getInitialVideoCheck = () => {
    const editApptId =
      props.start?.Id ?? props.start?.id ?? props.start?.pc_eid ?? null;
    if (
      editApptId !== null &&
      String(editApptId) !== "" &&
      String(editApptId) !== "0"
    ) {
      const pc_th = Number(
        props.start?.pc_telehealth ??
          props.start?.tele_health ??
          props.start?.is_telehealth ??
          props.start?.telehealth_flag ??
          props.start?.telehealth,
      );
      return pc_th === 1;
    }
    return false;
  };

  const [Appttype, setAppttype] = useState(getInitialApptType());
  const [forteleornor, setforteleornor] = useState(1);
  const [videochck, setvideochck] = useState(getInitialVideoCheck());
  const [patsrchvalue, setpatsrchvalue] = useState("");

  const patientSearchSelectRef = useRef(null);

  const clearSelectActiveFocus = () => {
    setTimeout(() => {
      if (
        document.activeElement &&
        typeof document.activeElement.blur === "function"
      ) {
        document.activeElement.blur();
      }
    }, 0);
  };

  const clearPatientSearchFocus = () => {
    setSearchInput("");
    setpatsrchvalue("");
    clearSelectActiveFocus();

    setTimeout(() => {
      patientSearchSelectRef.current?.blur?.();
    }, 0);
  };

  const [normalappointment, setnormalappointment] = useState(
    localStorage.getItem("normalapppopup") ? true : false,
  );

  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [teleappointment, setteleappointment] = useState(false);
  const [weekday, setweekday] = useState("");
  const [repeatselectnew, setrepeatselectnew] = useState("");
  const [repeatselect2new, setrepeatselect2new] = useState("0");
  const [timelimiterrorbox, settimelimiterrorbox] = useState(false);
  const [patError, setpatError] = useState(false);
  const [groupPatError, setGroupPatError] = useState(false);

  const [profileError, setprofileError] = useState(false);
  const [examroomError, setexamroomError] = useState(false);
  const [provError, setprovError] = useState(false);
  const [officeError, setofficeError] = useState(false);
  const [statusError, setstatusError] = useState(false);
  const [selectdayError, setselectdayError] = useState(false);
  const [notDisabledSpec, setNotDisabledSpec] = useState("");
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);
  const [ModalMsg1, setModalMsg1] = useState("");
  const [walkincheck, setwalkincheck] = useState(false);
  const [patFlag, setPatFlag] = useState([]);
  const [isInitialWaitlistLoad, setIsInitialWaitlistLoad] = useState(false);
  const [isWaitlistDataLoaded, setIsWaitlistDataLoaded] = useState(false);
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [fetchingOptions, setFetchingOptions] = useState(false);
  const returnPath = useSelector((state) => state.returnPath.path);
  const [emptyEmailWarning, setEmptyEmailWarning] = useState(false);
  //ReminderWorkFlow
  const [appointmentNotifyChecked, setAppointmentNotifyChecked] =
    useState(false);
  const [appointmentNotifyExpanded, setAppointmentNotifyExpanded] =
    useState(false);
  const [appointmentNotifyPatientWarning, setAppointmentNotifyPatientWarning] =
    useState(false);

  const [appointmentNotifyChannels, setAppointmentNotifyChannels] = useState({
    email: false,
    sms: false,
    voice: false,
  });

  const [appointmentNotifySchedule, setAppointmentNotifySchedule] = useState({
    before1Day: true,
    before2Day: false,
    before3Day: false,
    before4Day: false,
    before5Day: false,
    customDate: false,
  });

  const [appointmentNotifyCustomDate, setAppointmentNotifyCustomDate] =
    useState("");
  const [
    appointmentNotifyCustomDateWarning,
    setAppointmentNotifyCustomDateWarning,
  ] = useState(false);
  const [appointmentNotifyDefaultLoaded, setAppointmentNotifyDefaultLoaded] =
    useState(false);

  const [reminderIntegrationStatus, setReminderIntegrationStatus] = useState({
    email: false,
    twilio: false,
    loaded: false,
  });

  const [notifyIntegrationWarning, setNotifyIntegrationWarning] = useState("");
  const [scrollVersion, setScrollVersion] = useState(0);
  const [patientDefaultContact, setPatientDefaultContact] = useState({
    email: "",
    emailType: "work",
    phone: "",
    phoneCode: "",
    phoneCodeText: "",
    phoneType: "mobile",
  });
  const [contactEditType, setContactEditType] = useState("");
  const [contactEditValue, setContactEditValue] = useState("");
  const [contactEditCode, setContactEditCode] = useState("+91");
  const [contactEditCodeText, setContactEditCodeText] = useState("IN");
  const [contactEditDefaultType, setContactEditDefaultType] = useState("");
  const [contactEditError, setContactEditError] = useState("");
  const [contactEditSaving, setContactEditSaving] = useState(false);

  var startformat = moment(start, "YYYY-MM-DD HH:mm:ss").format(
    "YYYY-MM-DD HH:mm:ss",
  );
  var endformat = moment(end, "YYYY-MM-DD HH:mm:ss").format(
    "YYYY-MM-DD HH:mm:ss",
  );
  var duration = moment(endformat, "YYYY-MM-DD HH:mm:ss").diff(
    moment(startformat, "YYYY-MM-DD HH:mm:ss"),
    "minutes",
  );
  const [billFacId, setBillFacId] = useState("");
  const [editing, setEditing] = useState(duration);
  const [btnDis, setBtnDis] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);

  const [startTime, setStartTime] = useState(9);
  const [endTime, setEndTime] = useState(17);
  const [repvalue, setrepValue] = useState("");
  const [day, setDay] = useState("");
  // const [month, setMonth] = useState("");
  // const [date, setDate] = useState("");
  const [dyOfMont, setDyOfMont] = useState("");
  const [wkOfMont, setWkOfMont] = useState("");
  // const [aftDate, setAftDate] = useState("");
  // const [onDate, setOnDate] = useState("");
  // const [occurence, setOccurence] = useState("1");
  const [custChk, setcustChk] = useState("");
  const [tempOpen, setTempOpen] = useState(false);
  const [inTimeErr, setInTimeErr] = useState(false);
  // const [wkErr, setWkErr] = useState(false);
  const [repeatselectmonth, setRepeatSelectMonth] = useState("1");
  const [endErrTime, setEndErrTime] = useState("");
  const [startErrTime, setStartErrTime] = useState("");
  const [frtimeSlots, setFromTimeSlots] = useState([]);
  const [totimeSlots, setToTimeSlots] = useState([]);
  // const currentTime = moment().format("h:mm a").split(" ");
  // const chekDate = moment().format("YYYY-MM-DD");
  const [upgrade, setUpgrade] = useState(false);
  const [userAvail, setUserAvail] = useState([]);
  const [Telehealthplatform, setTelehealthplatform] = useState("zoom");
  const [speciality, setSpeciality] = useState("");
  const [specialError, setSpecialError] = useState(false);
  const [allowAppt, setAllowAppt] = useState(0);
  // const [occurenceday, setOccurenceday] = useState();
  // const [occurencedayErr, setOccurencedayErr] = useState(false);
  const [lastdate, setLastdate] = useState(false);
  const [lastdateApp, setLastdateApp] = useState("");
  const [sortSpeciality, setSortSpecility] = useState("");
  const [dateErr, setDateErr] = useState(false);
  // const [billFacility, setBillFacility] = useState([]);
  // const [billFacilityID, setBillFacilityID] = useState("");
  // const [billFacilityError, setBillFacilityError] = useState(false);
  // changes by sridar
  const location = useLocation();
  const { state } = location;
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const popupStep = searchParams.get("step");
  const isWaitlist = searchParams.get("accountSetupWaitlist") === "true";
  const isWaitlistStepFive = isWaitlist && popupStep === "waitlist5";
  const isAccountSetupReminderIntroOpen =
    props.showReminderIntro1 || props.showReminderIntro2;
  const handleSelectFromWaitlistClick = () => {
    if (isWaitlistStepFive) {
      history.push(
        "/schedule/waitlist?step=waitlist6&accountSetupWaitlist=true",
      );
      props.closepopup();
      return;
    }

    history.push("/schedule/waitlist");
    props.closepopup();
  };

  const [eid, setEid] = useState("");
  const [temShow, setTemShow] = useState(true);
  // const [clientAddIs, setClientAddIs] = useState(false);
  const [clientAddIs, setClientAddIs] = useState({ show: false, message: "" });
  const [showIntakeForm, setShowIntakeForm] = useState(false);
  const [intakeData, setIntakeData] = useState(null);
  const [show, setShow] = useState(false);
  const [id, setid] = useState(0);
  const [IdforDelete, setIdforDelete] = useState(0);
  const [singleRow, setSingleRow] = useState([]);
  const [showAvl, setShowAvl] = useState(true);
  const [switchvalue, setswitchvalue] = useState(false);
  const [WeeklyDisable, setWeeklyDisable] = useState("");
  const [changeTab, setChangeTag] = useState(
    props.ApptTab ? props.ApptTab : "1",
  );

  const selectedServiceCodesForSave =
    changeTab === "3" || props.isGroupAppointment
      ? groupServiceCode
      : individualServiceCode;
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [patientTimePreview, setPatientTimePreview] = useState(null);
  const patientTimePreviewRequestRef = useRef(0);
  const formatAppointmentOverlapMessage = (backendMsg) => {
    if (!backendMsg) return "";

    const dateMatch = backendMsg.match(/on\s+([0-9-]+)/i);

    const conflictDate = dateMatch?.[1] || aptdate;

    const formattedDate = conflictDate
      ? moment(conflictDate, ["YYYY-MM-DD", dtFormat], true).format(
          "MMMM DD, YYYY",
        )
      : "";

    const formattedStartTime = moment(
      inTime,
      ["h:mm A", "hh:mm A", "HH:mm:ss"],
      true,
    ).isValid()
      ? moment(inTime, ["h:mm A", "hh:mm A", "HH:mm:ss"]).format("h:mm A")
      : inTime;

    const formattedEndTime = moment(
      outTime,
      ["h:mm A", "hh:mm A", "HH:mm:ss"],
      true,
    ).isValid()
      ? moment(outTime, ["h:mm A", "hh:mm A", "HH:mm:ss"]).format("h:mm A")
      : outTime;

    return `Time slot already booked from ${formattedStartTime} to ${formattedEndTime} on ${formattedDate}. Select another time slot.`;
  };
  const formatProviderUnavailableMessage = () => {
    const formattedDate = aptdate
      ? moment(aptdate, dtFormat).format("MMMM DD, YYYY")
      : "";

    return `The provider is unavailable from ${inTime} to ${outTime} on ${formattedDate}. Select another time slot.`;
  };
  const isProviderUnavailableMessage = (message = "") => {
    return (
      message === "Provider Not Available" ||
      message.includes("The provider is unavailable on these dates") ||
      message.startsWith("The provider is unavailable from")
    );
  };
  const [fromShow, setFromShow] = useState(false);
  const [toShow, setToShow] = useState(false);
  const [fromId, setFromId] = useState("");
  const userid = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const [clientFail1, setClientFail1] = useState(false);
  const [groupPatients, setGroupPatients] = useState([]);
  const [groupId, setGroupId] = useState(
    props.isGroupAppointment || props.isEditGroupAppointment
      ? props.dataObj.groupId
      : null,
  );
  const [loading, setLoading] = useState(false);
  const [isWaitlistStep8Complete, setIsWaitlistStep8Complete] = useState(false);
  const [step8Loading, setStep8Loading] = useState(false);
  const [scrollTick, setScrollTick] = useState(0);

  const getWaitlistStep8Date = (value) => {
    if (!value) return "";

    const parsedDate = moment(value, [dtFormat, "YYYY-MM-DD"], true);

    return parsedDate.isValid()
      ? parsedDate.format("YYYY-MM-DD")
      : moment(value).format("YYYY-MM-DD");
  };

  const updateEndTimeFromDuration = (durationMinutes) => {
    if (!inTime || !durationMinutes || durationMinutes <= 0) return;

    const newOutTime = moment(inTime, "h:mm A")
      .add(durationMinutes, "minutes")
      .format("h:mm A");

    setOutTime(newOutTime);
    setEditing(durationMinutes);
    setInTimeErr(false);
    settimelimiterrorbox(false);
  };
  const getHighestSelectedServiceCodeDuration = (selectedCodes = []) => {
    return selectedCodes.reduce((highestDuration, selectedCode) => {
      const codeData =
        serviceCodeCacheRef.current[String(selectedCode)] ||
        serviceCodeOptions.find(
          (item) => String(item.code) === String(selectedCode),
        );

      const duration = Number(codeData?.duration || 0);

      return duration > highestDuration ? duration : highestDuration;
    }, 0);
  };

  const getServiceCodePayload = (selectedCodes = []) => {
    return selectedCodes.map((selectedCode) => {
      const codeData =
        serviceCodeCacheRef.current[String(selectedCode)] ||
        serviceCodeOptions.find(
          (item) => String(item.code) === String(selectedCode),
        );

      return {
        id: codeData?.id || null,
        code: selectedCode,
      };
    });
  };
  const getBaseAppointmentDuration = () => {
    const profiles = videochck ? teleprofile : sourceprofile;

    const selectedProfile = profiles.find(
      (item) => String(item.value) === String(profileid),
    );

    const profileDuration = Number(selectedProfile?.pc_duration || 0);

    return profileDuration > 0 ? profileDuration : 15;
  };

  const setDurationDisplayForCurrentFlow = (durationMinutes) => {
    const durationValue = `${durationMinutes} mins`;

    const isRecurring =
      repvalue &&
      repvalue !== "Does not repeat" &&
      repvalue !== "Does not repeat ";

    if (isRecurring) {
      setServiceDuration(durationValue);
    } else if (changeTab === "3" || props.isGroupAppointment) {
      setGroupDuration(durationValue);
    } else {
      setIndividualDuration(durationValue);
    }
  };

  const applyAppointmentDuration = (durationMinutes) => {
    const finalDuration =
      Number(durationMinutes) > 0 ? Number(durationMinutes) : 15;

    setDurationDisplayForCurrentFlow(finalDuration);
    setEditing(finalDuration);

    if (inTime) {
      updateEndTimeFromDuration(finalDuration);
    }
  };
  const getWaitlistStep8Time = (value) => {
    if (!value) return "";

    const parsedTime = moment(value, ["HH:mm:ss", "hh:mm A", "h:mm A"], true);

    return parsedTime.isValid() ? parsedTime.format("HH:mm:ss") : value;
  };

  const getWaitlistStep8AppointmentData = () => ({
    appointment_date: getWaitlistStep8Date(aptdate),
    start_time: getWaitlistStep8Time(inTime),
    end_time: getWaitlistStep8Time(outTime),
    provider_id: providerid,
    facility_id: officeid,
  });

  const getPatientTimePreviewText = () => {
    if (
      !patientTimePreview?.patient_start_display ||
      !patientTimePreview?.patient_end_display
    ) {
      return "";
    }

    const supportedFormats = [
      "MMM DD, YYYY, hh:mm A",
      "MMM D, YYYY, h:mm A",
      "MMM DD, YYYY, h:mm A",
      "MMM D, YYYY, hh:mm A",
    ];

    const patientStart = moment(
      patientTimePreview.patient_start_display,
      supportedFormats,
      true,
    );

    const patientEnd = moment(
      patientTimePreview.patient_end_display,
      supportedFormats,
      true,
    );
    if (!patientStart.isValid() || !patientEnd.isValid()) {
      return `${patientTimePreview.patient_start_display} - ${patientTimePreview.patient_end_display} for client`;
    }

    const providerAppointmentDate = moment(
      aptdate,
      [dtFormat, "YYYY-MM-DD"],
      true,
    );

    const patientSpansDifferentDate =
      patientStart.format("YYYY-MM-DD") !== patientEnd.format("YYYY-MM-DD");

    const patientDateDiffersFromProvider =
      providerAppointmentDate.isValid() &&
      patientStart.format("YYYY-MM-DD") !==
      providerAppointmentDate.format("YYYY-MM-DD");
    if (patientSpansDifferentDate || patientDateDiffersFromProvider) {
      return `${patientStart.format("MMM D, h:mm a")} - ${patientEnd.format(
        "MMM D, h:mm a",
      )} for client`;
    }
    return `${patientStart.format("h:mm a")} - ${patientEnd.format(
      "h:mm a",
    )} for client`;
  };

  useEffect(() => {
    const requestId = ++patientTimePreviewRequestRef.current;

    let isCancelled = false;

    const isGroupFlow =
      changeTab === "3" ||
      props.isGroupAppointment ||
      props.isEditGroupAppointment;

    const isBookAgainFlow = props.type === "book again";

    const isWaitlistFlow = Boolean(props.fromWaitList);

    const editAppointmentId =
      props.start?.Id ?? props.start?.id ?? props.start?.pc_eid ?? null;

    const isExistingEditFlow =
      !isBookAgainFlow &&
      !isWaitlistFlow &&
      editAppointmentId !== null &&
      String(editAppointmentId) !== "" &&
      String(editAppointmentId) !== "0";

    let fallbackPatientId = "";

    if (isBookAgainFlow) {
      fallbackPatientId = bookingData?.pc_pid || props.dataObj?.pc_pid || "";
    } else if (isWaitlistFlow) {
      fallbackPatientId = props.waitlistData?.patient_id || "";
    } else {
      fallbackPatientId = props.pid || props.start?.pc_pid || "";
    }

    const effectivePatientId = patientid || fallbackPatientId;

    let fallbackProviderId = "";

    if (isBookAgainFlow) {
      fallbackProviderId = bookingData?.pc_aid || props.dataObj?.pc_aid || "";
    } else if (isWaitlistFlow) {
      fallbackProviderId = props.waitlistData?.provider_id || "";
    } else {
      fallbackProviderId =
        props.start?.pc_aid ||
        props.start?.resourceId ||
        props.provider ||
        props.providerSelect?.[0] ||
        "";
    }

    const effectiveProviderId = providerid || fallbackProviderId;
    let fallbackAppointmentDate = "";

    if (isWaitlistFlow) {
      fallbackAppointmentDate = props.waitlistData?.appointment_date || "";
    } else if (isExistingEditFlow) {
      fallbackAppointmentDate =
        props.start?.pc_eventDate || props.start?.StartTime || "";
    }

    const effectiveAppointmentDate = aptdate || fallbackAppointmentDate;
    let fallbackStartTime = "";

    if (isBookAgainFlow) {
      fallbackStartTime =
        bookingData?.pc_startTime || props.dataObj?.pc_startTime || "";
    } else if (isWaitlistFlow) {
      fallbackStartTime = props.waitlistData?.start_time || "";
    } else if (isExistingEditFlow) {
      fallbackStartTime =
        props.start?.pc_startTime || props.start?.StartTime || "";
    }

    const effectiveStartTime = inTime || fallbackStartTime;
    let fallbackEndTime = "";

    if (isBookAgainFlow) {
      fallbackEndTime =
        bookingData?.pc_endTime || props.dataObj?.pc_endTime || "";
    } else if (isWaitlistFlow) {
      fallbackEndTime = props.waitlistData?.end_time || "";
    } else if (isExistingEditFlow) {
      fallbackEndTime = props.start?.pc_endTime || props.start?.EndTime || "";
    }

    const effectiveEndTime = outTime || fallbackEndTime;
    if (
      isGroupFlow ||
      !effectivePatientId ||
      !effectiveProviderId ||
      !effectiveAppointmentDate ||
      !effectiveStartTime ||
      !effectiveEndTime
    ) {
      setPatientTimePreview(null);

      return () => {
        isCancelled = true;
      };
    }

    const parsedAppointmentDate = moment(
      effectiveAppointmentDate,
      [dtFormat, "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"],
      true,
    );

    const parsedStartTime = moment(
      effectiveStartTime,
      ["HH:mm:ss", "hh:mm A", "h:mm A", "YYYY-MM-DD HH:mm:ss"],
      true,
    );

    const parsedEndTime = moment(
      effectiveEndTime,
      ["HH:mm:ss", "hh:mm A", "h:mm A", "YYYY-MM-DD HH:mm:ss"],
      true,
    );

    if (
      !parsedAppointmentDate.isValid() ||
      !parsedStartTime.isValid() ||
      !parsedEndTime.isValid()
    ) {
      setPatientTimePreview(null);

      return () => {
        isCancelled = true;
      };
    }
    const previewAppointmentId = isExistingEditFlow ? editAppointmentId : null;
    setPatientTimePreview(null);

    const previewTimer = setTimeout(async () => {
      try {
        const previewPayload = {
          pc_pid: effectivePatientId,
          pc_aid: effectiveProviderId,

          pc_eid: previewAppointmentId,

          pc_eventDate: parsedAppointmentDate.format("YYYY-MM-DD"),

          pc_endDate: parsedAppointmentDate.format("YYYY-MM-DD"),

          pc_startTime: parsedStartTime.format("HH:mm:ss"),

          pc_endTime: parsedEndTime.format("HH:mm:ss"),
        };

        const encryptedPreviewPayload = Encrypt_Value(previewPayload, "vozo");

        const response = await axiosInstance.post(
          "/vozo/appointmenttimezonepreview",
          encryptedPreviewPayload,
        );

        const previewResponse = Decrypt_Value(response.data, "vozo");

        if (isCancelled || requestId !== patientTimePreviewRequestRef.current) {
          return;
        }

        const patientTimezoneSource = String(
          previewResponse?.patient_timezone_source || "",
        )
          .trim()
          .toLowerCase();

        if (
          previewResponse?.success === true &&
          patientTimezoneSource === "patient" &&
          previewResponse?.patient_start_display &&
          previewResponse?.patient_end_display
        ) {
          setPatientTimePreview(previewResponse);
        } else {
          setPatientTimePreview(null);
        }
      } catch (error) {
        if (
          !isCancelled &&
          requestId === patientTimePreviewRequestRef.current
        ) {
          setPatientTimePreview(null);
        }
        console.error("Patient timezone preview failed:", error);
      }
    }, 300);

    return () => {
      isCancelled = true;
      clearTimeout(previewTimer);
    };
  }, [
    patientid,
    providerid,
    aptdate,
    inTime,
    outTime,
    changeTab,

    props.isGroupAppointment,
    props.isEditGroupAppointment,

    props.type,
    props.fromWaitList,
    props.pid,

    props.start?.Id,
    props.start?.id,
    props.start?.pc_eid,
    props.start?.pc_pid,
    props.start?.pc_aid,
    props.start?.resourceId,
    props.start?.pc_eventDate,
    props.start?.pc_startTime,
    props.start?.pc_endTime,
    props.start?.StartTime,
    props.start?.EndTime,

    props.dataObj?.pc_pid,
    props.dataObj?.pc_aid,
    props.dataObj?.pc_startTime,
    props.dataObj?.pc_endTime,

    bookingData?.pc_pid,
    bookingData?.pc_aid,
    bookingData?.pc_startTime,
    bookingData?.pc_endTime,

    props.waitlistData?.patient_id,
    props.waitlistData?.provider_id,
    props.waitlistData?.appointment_date,
    props.waitlistData?.start_time,
    props.waitlistData?.end_time,

    props.provider,
    props.providerSelect,
    dtFormat,
  ]);

  useEffect(() => {
    if (popupStep) {
      const handleUpdate = () => {
        setScrollTick((tick) => tick + 1);
      };
      window.addEventListener("scroll", handleUpdate, true);
      window.addEventListener("resize", handleUpdate);
      return () => {
        window.removeEventListener("scroll", handleUpdate, true);
        window.removeEventListener("resize", handleUpdate);
      };
    }
  }, [popupStep]);
  // ==========================================

  // ---------------------------------------- State and Variables End--------------------------------------------------- //

  // ---------------------------------------- Functions Start----------------------------------------------------------- //
  const fetchGroupPatients = async ({ search = "", limit = 4 } = {}) => {
    setLoading(true);
    const payload = {
      group_name: search,
      limit: limit,
    };

    try {
      const response = await axiosInstance.get(`/vozo/grouppatientsearch`, {
        params: {
          search: JSON.stringify(payload),
        },
      });

      const res = Decrypt_Value(response.data, "vozo");

      setGroupPatients(res || []);
    } catch (error) {
      console.error("Group patient fetch error:", error);
      setGroupPatients([]);
    } finally {
      setLoading(false);
    }
  };

  // const handleClientCreateSuccess = (enablePortal, patientData) => {
  //   const msg = enablePortal
  //     ? "Client created successfully and portal access mail sent"
  //     : "Client created successfully";

  //   setSuccessMsg(msg);
  //   setShowSuccess(true);

  //   setTimeout(() => {
  //     setShowSuccess(false);
  //     setSuccessMsg("");

  //     if (enablePortal && patientData) {
  //       openIntake({
  //         id: patientData.id,
  //         name: patientData.name,
  //         email: patientData.email,
  //       });
  //     }
  //   }, 1800);
  // };

  const showAppointmentWarning = (message, duration = 5000) => {
    setBtnDis(false);
    setModalAlerShow1(false);
    setModalMsg1("");

    setTimeout(() => {
      setModalAlerShow1(true);
      setModalMsg1(message);
    }, 1);

    setTimeout(() => {
      setModalAlerShow1(false);
    }, duration);
  };

  const checkBillingFacilityEnabled = async () => {
    try {
      const response = await axiosInstance.get(
        `/vozo/facility/billing-count?t=${Date.now()}`,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo");
      const billingCount = Number(decryptedData?.billing_count || 0);

      if (billingCount === 0) {
        showAppointmentWarning(NO_BILLING_FACILITY_APPOINTMENT_WARNING);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Billing facility check failed:", error);

      showAppointmentWarning(
        "Unable to verify Billing Facility. Please try again.",
      );

      return false;
    }
  };

  const handleAppointmentNotifyCheck = async (e) => {
    const isChecked = e.target.checked;

    if (isChecked && !patientid) {
      setAppointmentNotifyChecked(false);
      setAppointmentNotifyExpanded(false);

      setAppointmentNotifyPatientWarning(true);
      setpatError(false);

      return;
    }

    setAppointmentNotifyPatientWarning(false);
    setNotifyIntegrationWarning("");

    if (isChecked) {
      setAppointmentNotifyChecked(true);
      setAppointmentNotifyExpanded(false);

      await fetchPatientDefaultContact(patientid, true, false);

      setAppointmentNotifyChecked(true);

      return;
    }

    setAppointmentNotifyChecked(false);
    setAppointmentNotifyExpanded(false);
    setNotifyIntegrationWarning("");
    setAppointmentNotifyCustomDateWarning(false);
  };

  const handleAppointmentNotifyExpand = () => {
    if (!appointmentNotifyChecked) return;
    setAppointmentNotifyExpanded((prev) => !prev);
  };

  const getReminderIntegrationStatus = async () => {
    try {
      const response = await axiosInstance.get(
        `/vozo/NotificationSetting?t=${Date.now()}`,
      );

      const data = Decrypt_Value(response.data, "vozo") || [];

      const getGlobalValue = (name) =>
        data.find((item) => item.gl_name === name)?.gl_value || "";

      const emailConnected =
        !!getGlobalValue("Notification_EMAIL") &&
        !!getGlobalValue("Notification_PASS");

      const twilioConnected =
        !!getGlobalValue("TWILIO_ACCOUNT_SID") &&
        !!getGlobalValue("TWILIO_AUTHTOKEN") &&
        !!getGlobalValue("TWILIO_FROM");

      const status = {
        email: emailConnected,
        twilio: twilioConnected,
        loaded: true,
      };

      setReminderIntegrationStatus(status);

      return status;
    } catch (error) {
      console.error("Reminder integration status check failed:", error);

      const status = {
        email: false,
        twilio: false,
        loaded: true,
      };

      setReminderIntegrationStatus(status);

      return status;
    }
  };

  const getIntegrationFilteredChannels = async (channels) => {
    let status = reminderIntegrationStatus;

    if (!status.loaded) {
      status = await getReminderIntegrationStatus();
    }

    return {
      email: Boolean(channels.email) && status.email,
      sms: Boolean(channels.sms) && status.twilio,
      voice: !Boolean(channels.sms) && Boolean(channels.voice) && status.twilio,
    };
  };

  const redirectToIntegrations = () => {
    if (props.showReminderIntro3) {
      handleReminderIntro3Next();
      return;
    }
    setNotifyIntegrationWarning("");
    setAppointmentNotifyExpanded(false);

    if (typeof props.setappshow === "function") {
      props.setappshow(false);
    }

    if (typeof props.closepopup === "function") {
      props.closepopup();
    }

    history.push("/settings/integrations");
  };

  const convertReminderHoursToDays = (value) => {
    const reminderValue = Number(value || 1);

    if (reminderValue > 5) {
      return String(Math.ceil(reminderValue / 24));
    }

    return String(reminderValue);
  };

  const setReminderScheduleByDays = (days) => {
    const reminderDays = String(days || "1");

    setAppointmentNotifySchedule({
      before1Day: reminderDays === "1",
      before2Day: reminderDays === "2",
      before3Day: reminderDays === "3",
      before4Day: reminderDays === "4",
      before5Day: reminderDays === "5",
      customDate: false,
    });

    setAppointmentNotifyCustomDate("");
    setAppointmentNotifyCustomDateWarning(false);
  };

  const fetchAppointmentReminderDefaults = async () => {
    try {
      const [emailResponse, smsResponse, voiceResponse] = await Promise.all([
        axiosInstance.get("/vozo/settingappointmentreminderemail/notification"),
        axiosInstance.get("/vozo/settingappointmentremindertext/notification"),
        axiosInstance.get("/vozo/settingappointmentremindervoice/notification"),
      ]);

      const emailData = Decrypt_Value(emailResponse.data, "vozo") || {};
      const smsData = Decrypt_Value(smsResponse.data, "vozo") || {};
      const voiceData = Decrypt_Value(voiceResponse.data, "vozo") || {};

      const emailActive = emailData.email_status_active === "1";
      const smsActive = smsData.sms_status_active === "1";
      const voiceActive = voiceData.voice_status_active === "1";

      const defaultReminderDays =
        emailActive && emailData.Send_Email_Before_Hours
          ? emailData.Send_Email_Before_Hours
          : smsActive && smsData.Send_SMS_Before_Hours
            ? smsData.Send_SMS_Before_Hours
            : voiceActive && voiceData.Send_Voice_Before_Hours
              ? voiceData.Send_Voice_Before_Hours
              : "1";

      setReminderScheduleByDays(
        convertReminderHoursToDays(defaultReminderDays),
      );

      setAppointmentNotifyDefaultLoaded(true);
    } catch (error) {
      console.error("Appointment reminder default fetch failed:", error);
      setReminderScheduleByDays("1");
      setAppointmentNotifyDefaultLoaded(true);
    }
  };

  const resetPatientDefaultContact = () => {
    setPatientDefaultContact({
      email: "",
      emailType: "work",
      phone: "",
      phoneCode: "",
      phoneCodeText: "",
      phoneType: "mobile",
    });

    setAppointmentNotifyChannels({
      email: false,
      sms: false,
      voice: false,
    });

    setAppointmentNotifyCustomDate("");
    setAppointmentNotifyCustomDateWarning(false);
  };

  const fetchPatientDefaultContact = async (
    pid,
    keepExpanded = false,
    syncMainCheckboxFromPreference = false,
  ) => {
    if (!pid) {
      resetPatientDefaultContact();
      setAppointmentNotifyChecked(false);
      setAppointmentNotifyExpanded(false);

      return {
        appointmentReminderPreference: false,
        hasReminderPreference: false,
      };
    }

    try {
      const response = await axiosInstance.get(
        `/vozo/patient/default-contact?pid=${pid}&t=${Date.now()}`,
      );

      const data = Decrypt_Value(response.data, "vozo") || {};

      setPatientDefaultContact({
        email: data.email || "",
        emailType: data.emailType || "work",
        phone: data.phone || "",
        phoneCode: data.phoneCode || "",
        phoneCodeText: data.phoneCodeText || "",
        phoneType: data.phoneType || "mobile",
      });

      const emailAllowed = data.emailReminder === "YES";
      const smsAllowed = data.smsReminder === "YES";
      const voiceAllowed = data.voiceReminder === "YES";

      const appointmentReminderPreference =
        Number(data.appointmentReminderPreference ?? 0) === 1;

      const patientPreferenceChannels = {
        email: emailAllowed,
        sms: smsAllowed,
        voice: !smsAllowed && voiceAllowed,
      };

      if (syncMainCheckboxFromPreference) {
        setAppointmentNotifyChecked(appointmentReminderPreference);
      }

      if (!keepExpanded) {
        setAppointmentNotifyExpanded(false);
      }

      setAppointmentNotifyChannels(patientPreferenceChannels);

      setAppointmentNotifyCustomDate("");
      setAppointmentNotifyCustomDateWarning(false);

      return {
        appointmentReminderPreference,
        hasReminderPreference: appointmentReminderPreference,
      };
    } catch (error) {
      console.error("Patient default contact fetch failed:", error);

      resetPatientDefaultContact();
      setAppointmentNotifyChecked(false);
      setAppointmentNotifyExpanded(false);

      return {
        appointmentReminderPreference: false,
        hasReminderPreference: false,
      };
    }
  };

  const normalizeReminderYesNo = (value) => {
    return (
      String(value || "NO")
        .trim()
        .toUpperCase() === "YES"
    );
  };

  const applyAppointmentReminderState = async (reminderData = {}) => {
    const notifyChecked = normalizeReminderYesNo(reminderData.notify);

    // setAppointmentNotifyChecked(notifyChecked);
    // setAppointmentNotifyExpanded(false);

    // setAppointmentNotifyChannels({
    //   email: notifyChecked && normalizeReminderYesNo(reminderData.email),
    //   sms: notifyChecked && normalizeReminderYesNo(reminderData.sms),
    //   voice:
    //     notifyChecked &&
    //     !normalizeReminderYesNo(reminderData.sms) &&
    //     normalizeReminderYesNo(reminderData.voice),
    // });

    const rawChannels = {
      email: notifyChecked && normalizeReminderYesNo(reminderData.email),

      sms: notifyChecked && normalizeReminderYesNo(reminderData.sms),

      voice:
        notifyChecked &&
        !normalizeReminderYesNo(reminderData.sms) &&
        normalizeReminderYesNo(reminderData.voice),
    };

    const validChannels = await getIntegrationFilteredChannels(rawChannels);

    const hasValidReminder =
      validChannels.email || validChannels.sms || validChannels.voice;

    setAppointmentNotifyChecked(notifyChecked && hasValidReminder);

    setAppointmentNotifyExpanded(false);

    setAppointmentNotifyChannels(validChannels);

    if (notifyChecked && reminderData.custom_date) {
      setAppointmentNotifySchedule({
        before1Day: false,
        before2Day: false,
        before3Day: false,
        before4Day: false,
        before5Day: false,
        customDate: true,
      });

      setAppointmentNotifyCustomDate(
        moment(reminderData.custom_date, "YYYY-MM-DD").format(dtFormat),
      );
    } else {
      const reminderDays = reminderData.reminder_hours
        ? String(Math.ceil(Number(reminderData.reminder_hours) / 24))
        : reminderData.reminder_days || "1";

      setReminderScheduleByDays(reminderDays);
    }

    setAppointmentNotifyCustomDateWarning(false);
  };

  const fetchLastAppointmentNotificationStatus = async (
    pid,
    fallbackChecked = false,
  ) => {
    if (!pid) {
      setAppointmentNotifyChecked(false);
      setAppointmentNotifyExpanded(false);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `/vozo/patient/last-appointment-notification?pid=${pid}&t=${Date.now()}`,
      );

      const decryptedData = Decrypt_Value(response.data, "vozo") || {};
      const data = Array.isArray(decryptedData)
        ? decryptedData[0] || {}
        : decryptedData;

      const notifyValue =
        data.notify || data.pc_reminder_notify || data.reminder_notify || "NO";

      const hasAppointment =
        data.hasAppointment === true ||
        data.hasAppointment === 1 ||
        data.hasAppointment === "1" ||
        String(data.hasAppointment || "").toUpperCase() === "YES" ||
        String(data.hasAppointment || "").toUpperCase() === "TRUE" ||
        !!data.pc_eid ||
        !!data.Id ||
        !!data.id;

      if (hasAppointment) {
        await applyAppointmentReminderState({
          notify: notifyValue,
          email: data.email || data.pc_reminder_email || "NO",
          sms: data.sms || data.pc_reminder_sms || "NO",
          voice: data.voice || data.pc_reminder_voice || "NO",
          reminder_days: data.reminder_days,
          reminder_hours: data.reminder_hours || data.pc_reminder_hours,
          custom_date: data.custom_date || data.pc_reminder_custom_date || "",
        });
        return;
      }

      setAppointmentNotifyChecked(Boolean(fallbackChecked));
      setAppointmentNotifyExpanded(false);
      setAppointmentNotifyCustomDateWarning(false);
    } catch (error) {
      console.error("Last appointment notification fetch failed:", error);
      setAppointmentNotifyChecked(Boolean(fallbackChecked));
      setAppointmentNotifyExpanded(false);
      setAppointmentNotifyCustomDateWarning(false);
    }
  };
  // const updatePatientReminderPreference = async (channels) => {
  //   if (!patientid) return false;

  //   const payload = {
  //     type: "reminder",
  //     emailReminder: channels.email ? "YES" : "NO",
  //     smsReminder: channels.sms ? "YES" : "NO",
  //     voiceReminder: channels.voice ? "YES" : "NO",
  //   };

  //   try {
  //     const encrypted = Encrypt_Value(payload, "vozo");

  //     const response = await axiosInstance.put(
  //       `/vozo/patient/default-contact?pid=${patientid}`,
  //       encrypted,
  //     );

  //     const data = Decrypt_Value(response.data, "vozo") || {};

  //     return data.status !== "error";
  //   } catch (error) {
  //     console.error("Patient reminder preference update failed:", error);
  //     return false;
  //   }
  // };

  const savePatientAppointmentReminderPreference = async (pid) => {
    const isGroupFlow =
      changeTab === "3" ||
      props.isGroupAppointment ||
      props.isEditGroupAppointment;

    if (!pid || isGroupFlow) {
      return true;
    }

    const payload = {
      type: "reminder",
      appointmentReminderPreference: appointmentNotifyChecked ? 1 : 0,
    };

    try {
      const encryptedPayload = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.put(
        `/vozo/patient/default-contact?pid=${pid}`,
        encryptedPayload,
      );

      const data = Decrypt_Value(response.data, "vozo") || {};

      return data.status !== "error";
    } catch (error) {
      console.error(
        "Patient appointment reminder preference update failed:",
        error,
      );

      return false;
    }
  };

  const handleAppointmentNotifyChannelChange = async (key) => {
    let status = reminderIntegrationStatus;

    if (!status.loaded) {
      status = await getReminderIntegrationStatus();
    }

    if (key === "email" && !status.email) {
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
        email: false,
      }));

      setNotifyIntegrationWarning("email");
      return;
    }

    if ((key === "sms" || key === "voice") && !status.twilio) {
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
        sms: false,
        voice: false,
      }));

      setNotifyIntegrationWarning("twilio");
      return;
    }

    setNotifyIntegrationWarning("");

    setAppointmentNotifyChannels((prev) => {
      if (key === "email") {
        return {
          ...prev,
          email: !prev.email,
        };
      }

      if (key === "sms") {
        return {
          ...prev,
          sms: !prev.sms,
          voice: false,
        };
      }

      if (key === "voice") {
        return {
          ...prev,
          sms: false,
          voice: !prev.voice,
        };
      }

      return prev;
    });
  };

  const handleAppointmentNotifyScheduleChange = (key) => {
    const isBookAgain = props.type === "book again";

    setAppointmentNotifySchedule({
      before1Day: key === "before1Day",
      before2Day: key === "before2Day",
      before3Day: key === "before3Day",
      before4Day: key === "before4Day",
      before5Day: key === "before5Day",
      customDate: key === "customDate",
    });

    if (key !== "customDate") {
      setAppointmentNotifyCustomDate("");
      setAppointmentNotifyCustomDateWarning(false);
      return;
    }

    if (key === "customDate" && !aptdate && isBookAgain) {
      setAppointmentNotifyCustomDate("");
      setAppointmentNotifyCustomDateWarning(true);
      return;
    }

    setAppointmentNotifyCustomDateWarning(false);
  };

  const handleAppointmentNotifyCustomDateChange = (date) => {
    if (!aptdate) {
      setAppointmentNotifyCustomDate("");
      setAppointmentNotifyCustomDateWarning(true);
      return;
    }

    if (date) {
      setAppointmentNotifyCustomDate(moment(date).format(dtFormat));
      setAppointmentNotifyCustomDateWarning(false);
      return;
    }

    setAppointmentNotifyCustomDate("");
    setAppointmentNotifyCustomDateWarning(true);
  };

  const getAppointmentReminderPayload = () => {
    let reminderDays = "";

    if (appointmentNotifySchedule.before1Day) reminderDays = "1";
    if (appointmentNotifySchedule.before2Day) reminderDays = "2";
    if (appointmentNotifySchedule.before3Day) reminderDays = "3";
    if (appointmentNotifySchedule.before4Day) reminderDays = "4";
    if (appointmentNotifySchedule.before5Day) reminderDays = "5";

    const hasValidCustomDate =
      appointmentNotifySchedule.customDate && appointmentNotifyCustomDate;

    return {
      notify: appointmentNotifyChecked ? "YES" : "NO",
      email:
        appointmentNotifyChecked && appointmentNotifyChannels.email
          ? "YES"
          : "NO",
      sms:
        appointmentNotifyChecked && appointmentNotifyChannels.sms
          ? "YES"
          : "NO",
      voice:
        appointmentNotifyChecked && appointmentNotifyChannels.voice
          ? "YES"
          : "NO",
      reminder_days: hasValidCustomDate ? "" : reminderDays || "1",
      custom_date: hasValidCustomDate
        ? moment(appointmentNotifyCustomDate, dtFormat).format("YYYY-MM-DD")
        : "",
    };
  };

  const validateAppointmentReminderSetup = async () => {
    if (!appointmentNotifyChecked) {
      return true;
    }

    let status = reminderIntegrationStatus;

    if (!status.loaded) {
      status = await getReminderIntegrationStatus();
    }

    if (appointmentNotifyChannels.email && !status.email) {
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
        email: false,
      }));

      setAppointmentNotifyExpanded(true);
      setNotifyIntegrationWarning("email");
      return false;
    }

    if (
      (appointmentNotifyChannels.sms || appointmentNotifyChannels.voice) &&
      !status.twilio
    ) {
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
        sms: false,
        voice: false,
      }));

      setAppointmentNotifyExpanded(true);
      setNotifyIntegrationWarning("twilio");
      return false;
    }

    const isAnyChannelSelected =
      appointmentNotifyChannels.email ||
      appointmentNotifyChannels.sms ||
      appointmentNotifyChannels.voice;

    if (!isAnyChannelSelected) {
      showAppointmentWarning(
        "Reminder time has not been setup, please set a prior time to send reminders based on appointments to patients",
      );
      return false;
    }

    const hasEmailContact =
      patientDefaultContact.email && patientDefaultContact.email.trim() !== "";

    const hasPhoneContact =
      patientDefaultContact.phone && patientDefaultContact.phone.trim() !== "";

    // if (!isAnyChannelSelected) {
    //   showAppointmentWarning(
    //     "Reminder time has not been setup, please set a prior time to send reminders based on appointments to patients",
    //   );
    //   return false;
    // }

    if (appointmentNotifyChannels.email && !hasEmailContact) {
      showAppointmentWarning(
        "Please add an email address to send appointment email reminders",
      );
      return false;
    }

    if (
      appointmentNotifyChannels.email &&
      !validateReminderEmail(patientDefaultContact.email)
    ) {
      showAppointmentWarning("Enter a valid mail Id");
      return false;
    }

    if (
      (appointmentNotifyChannels.sms || appointmentNotifyChannels.voice) &&
      !hasPhoneContact
    ) {
      showAppointmentWarning(
        "Please add a phone number to send appointment SMS or voice reminders",
      );
      return false;
    }

    if (appointmentNotifyChannels.sms || appointmentNotifyChannels.voice) {
      const phoneValidationResult = validateReminderPhoneNumber(
        patientDefaultContact.phone,
        patientDefaultContact.phoneCode || contactEditCode || "+91",
        patientDefaultContact.phoneCodeText || contactEditCodeText || "IN",
      );

      if (!phoneValidationResult.valid) {
        showAppointmentWarning(phoneValidationResult.message);
        return false;
      }
    }

    return true;
  };

  const openDefaultContactEdit = (type) => {
    setContactEditType(type);
    setContactEditError("");

    if (type === "email") {
      const emailValue = patientDefaultContact.email || "";

      setContactEditValue(emailValue);
      setContactEditDefaultType(patientDefaultContact.emailType || "work");

      if (!emailValue.trim()) {
        setContactEditError("email-empty");
      }
    }

    if (type === "phone") {
      const phoneValue = sanitizeReminderPhoneInput(
        patientDefaultContact.phone || "",
      );

      setContactEditValue(phoneValue);
      setContactEditCode(patientDefaultContact.phoneCode || "+91");
      setContactEditCodeText(patientDefaultContact.phoneCodeText || "IN");
      setContactEditDefaultType(patientDefaultContact.phoneType || "mobile");

      if (!phoneValue.trim()) {
        setContactEditError("phone-empty");
      }
    }
  };

  const closeDefaultContactEdit = () => {
    setContactEditType("");
    setContactEditValue("");
    setContactEditError("");
    setContactEditSaving(false);
  };

  const sanitizeReminderPhoneInput = (value) => {
    return (value || "").replace(/\D/g, "");
  };

  const validateReminderEmail = (email) => {
    const trimmedEmail = (email || "").trim();

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

    return regex.test(trimmedEmail);
  };

  const validateReminderPhoneNumber = (phone, code, codeText) => {
    const phoneValue = (phone || "").trim();
    const phoneCodeValue = (code || "").trim();
    const phoneCodeTextValue = (codeText || "").trim();

    if (!phoneValue && phoneCodeValue) {
      return {
        valid: false,
        message: "Enter the Phone Number",
      };
    }

    if (phoneValue && !phoneCodeValue) {
      return {
        valid: false,
        message: "Select Country Code & Number",
      };
    }

    if (!phoneValue) {
      return {
        valid: false,
        message: "Enter the Phone Number",
      };
    }

    try {
      const phoneNumber = phoneUtil.parseAndKeepRawInput(
        `${phoneCodeValue} ${phoneValue}`,
        phoneCodeTextValue,
      );

      const isValid = phoneUtil.isValidNumber(phoneNumber);
      const isPossible = phoneUtil.isPossibleNumber(phoneNumber);

      if (!isValid || !isPossible) {
        return {
          valid: false,
          message: "Enter a valid Phone Number",
        };
      }

      return {
        valid: true,
        message: "",
      };
    } catch (error) {
      return {
        valid: false,
        message: "Enter a valid Phone Number",
      };
    }
  };

  const saveDefaultContactEdit = async () => {
    if (!patientid) {
      setContactEditError("Please select patient first");
      return;
    }

    const trimmedValue =
      contactEditType === "phone"
        ? sanitizeReminderPhoneInput(contactEditValue)
        : (contactEditValue || "").trim();

    if (!trimmedValue) {
      setContactEditError(
        contactEditType === "email" ? "email-empty" : "phone-empty",
      );
      return;
    }

    if (contactEditType === "email" && !validateReminderEmail(trimmedValue)) {
      setContactEditError("Enter a valid mail Id");
      return;
    }

    if (contactEditType === "phone") {
      const phoneValidationResult = validateReminderPhoneNumber(
        trimmedValue,
        contactEditCode,
        contactEditCodeText,
      );

      if (!phoneValidationResult.valid) {
        setContactEditError(phoneValidationResult.message);
        return;
      }
    }

    const payload =
      contactEditType === "email"
        ? {
          type: "email",
          email: trimmedValue,
          emailType: contactEditDefaultType || "work",
        }
        : {
          type: "phone",
          phone: trimmedValue,
          phoneCode: contactEditCode,
          phoneCodeText: contactEditCodeText,
          phoneType: contactEditDefaultType || "mobile",
        };

    try {
      setContactEditSaving(true);

      const encrypted = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.put(
        `/vozo/patient/default-contact?pid=${patientid}`,
        encrypted,
      );

      const data = Decrypt_Value(response.data, "vozo") || {};

      if (data.status === "email used" || data.status === "number used") {
        setContactEditError(data.message || "This contact already exists");
        setContactEditSaving(false);
        return;
      }

      setPatientDefaultContact({
        email: data.email || "",
        emailType: data.emailType || "work",
        phone: data.phone || "",
        phoneCode: data.phoneCode || "",
        phoneCodeText: data.phoneCodeText || "",
        phoneType: data.phoneType || "mobile",
      });

      window.dispatchEvent(new CustomEvent("reload-patient-data"));

      closeDefaultContactEdit();
    } catch (error) {
      console.error("Default contact update failed:", error);
      setContactEditError("Unable to update contact info. Please try again.");
    } finally {
      setContactEditSaving(false);
    }
  };
  const renderContactEmptyWarning = (type) => {
    const isEmail = type === "email";

    if (contactEditType !== type) return null;

    const isInputEmpty = !contactEditValue || !contactEditValue.trim();

    const isEmptyError =
      contactEditError === "email-empty" || contactEditError === "phone-empty";

    if (!isInputEmpty && !isEmptyError) return null;

    return (
      <div className="appt-contact-empty-warning-wrap">
        <div className="appt-contact-empty-warning-line">
          <FiAlertCircle className="appt-contact-empty-warning-icon" />
          <span>
            {isEmail
              ? "Changing the email here will update the patient demographics as well."
              : "Changing the number here will update the patient demographics as well."}
          </span>
        </div>

        <div className="appt-contact-empty-warning-card">
          <p>
            {isEmail
              ? "Without an email you might miss out functions like:"
              : "Without an phone number you might miss out functions like:"}
          </p>

          {isEmail ? (
            <ul>
              <li>Patient Portal</li>
              <li>In Person &amp; Telehealth Appointment Reminders</li>
              <li>Email Notifications</li>
              <li>Billing Documents</li>
            </ul>
          ) : (
            <ul>
              <li>In Person &amp; Telehealth Appointment Reminders</li>
            </ul>
          )}
        </div>
      </div>
    );
  };

  const renderContactApiError = (type) => {
    if (contactEditType !== type) return null;

    if (
      !contactEditError ||
      contactEditError === "email-empty" ||
      contactEditError === "phone-empty"
    ) {
      return null;
    }

    return (
      <div className="appt-contact-api-error">
        <FiAlertCircle className="appt-contact-empty-warning-icon" />
        <span>{contactEditError}</span>
      </div>
    );
  };

  const renderNotifyIntegrationWarning = () => {
    if (!notifyIntegrationWarning) return null;

    const warningMessage =
      notifyIntegrationWarning === "email"
        ? "Email Integration is not configured. Please verify your email settings and"
        : "SMS / Voice call integration is not configured. Please verify your email settings and";

    const warningContent = (
      <div
        ref={warningBannerRef}
        className="appt-notify-integration-warning"
        onClick={(e) => e.stopPropagation()}
      >
        <FiAlertCircle className="appt-notify-integration-warning-icon" />

        <span>
          {warningMessage}{" "}
          <button
            type="button"
            className="appt-notify-integration-link"
            onClick={redirectToIntegrations}
          >
            Click here
          </button>{" "}
          to complete the integration setup.
        </span>
      </div>
    );

    return (
      <div
        className="appt-notify-warning-overlay"
        onClick={() => {
          if (!props.showReminderIntro3) {
            setNotifyIntegrationWarning("");
          }
        }}
      >
        <Popup
          offset={[50, 10]}
          content={
            <GetStartedPopup
              title="Configure Appointment Reminder"
              bullets={[
                "If Email or Twilio configuration has not been done you will receive this popup.",
                'Click on the "Click Here" button to configure Email or Twilio in a popup.',
              ]}
              currentStep={3}
              totalSteps={6}
              onBack={handleReminderIntro3Back}
              onNext={handleReminderIntro3Next}
              onClose={() => {
                props.setShowReminderIntro3(false);
                setNotifyIntegrationWarning("");
              }}
              width={"320px"}
            />
          }
          open={!isWaitlist && !!props.showReminderIntro3}
          position="left center"
          trigger={warningContent}
        />
      </div>
    );
  };

  const renderAppointmentNotification = () => {
    return (
      <>
        {renderNotifyIntegrationWarning()}
        <Div className="appt-notify-wrapper">
          <div
            className={
              appointmentNotifyExpanded
                ? "appt-notify-box appt-notify-box-expanded"
                : "appt-notify-box"
            }
          >
            <div className="appt-notify-header">
              {props.showReminderIntro1 && !isWaitlist && (
                <div
                  className="ui left center popup visible"
                  style={step1PopupStyle}
                >
                  <GetStartedPopup
                    title="Configure Appointment Reminder"
                    bullets={[
                      "Navigate to Schedule > Calendar menu",
                      "Select a timeslot to schedule a appointment",
                      "Enable the Send Appointment Notification option in the appointment popup",
                    ]}
                    currentStep={1}
                    totalSteps={6}
                    onNext={handleReminderIntro1Next}
                    onClose={() => props.setShowReminderIntro1(false)}
                    width={"320px"}
                  />
                </div>
              )}
              <label className="appt-notify-main-label" ref={step1Ref}>
                <input
                  type="checkbox"
                  className="appt-notify-checkbox"
                  checked={appointmentNotifyChecked}
                  onChange={handleAppointmentNotifyCheck}
                />
                <span className="appt-notify-title">
                  Send Appointment Notification
                </span>
              </label>

              {appointmentNotifyChecked && (
                <button
                  type="button"
                  className="appt-notify-arrow-btn"
                  onClick={handleAppointmentNotifyExpand}
                >
                  {appointmentNotifyExpanded ? (
                    <FiChevronUp />
                  ) : (
                    <FiChevronDown />
                  )}
                </button>
              )}
            </div>

            <p className="appt-notify-sub-text">
              Reminders will be sent to the patient before the appointment.
            </p>

            {appointmentNotifyChecked && appointmentNotifyExpanded && (
              <div className="appt-notify-expanded-content">
                <div className="appt-notify-section">
                  <p className="appt-notify-section-title">Channels</p>

                  <div className="appt-notify-options-row">
                    {props.showReminderIntro2 && !isWaitlist && (
                      <div
                        className="ui left center popup visible"
                        style={step2PopupStyle}
                      >
                        <GetStartedPopup
                          title="Configure Appointment Reminder"
                          bullets={[
                            "Once enabled, select the Notification Channels like Email, SMS, & Voice.",
                            "If Email is not configured you will receive a alert mentioning to configure.",
                            "If SMS & Voice is not configured you will receive another alert mentioning to configure.",
                          ]}
                          currentStep={2}
                          totalSteps={6}
                          onBack={handleReminderIntro2Back}
                          onNext={handleReminderIntro2Next}
                          onClose={() => props.setShowReminderIntro2(false)}
                          width={"320px"}
                        />
                      </div>
                    )}
                    <label
                      className="appt-notify-option"
                      ref={emailReminderRef}
                    >
                      <input
                        type="checkbox"
                        checked={appointmentNotifyChannels.email}
                        onChange={() =>
                          handleAppointmentNotifyChannelChange("email")
                        }
                      />
                      <FiMail className="appt-notify-option-icon" />
                      <span>Email Reminder</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifyChannels.sms}
                        onChange={() =>
                          handleAppointmentNotifyChannelChange("sms")
                        }
                      />
                      <FiMessageSquare className="appt-notify-option-icon" />
                      <span>SMS Reminder</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifyChannels.voice}
                        onChange={() =>
                          handleAppointmentNotifyChannelChange("voice")
                        }
                      />
                      <FiPhoneCall className="appt-notify-option-icon" />
                      <span>Voice Reminder</span>
                    </label>
                  </div>
                </div>

                <div className="appt-notify-section">
                  <p className="appt-notify-section-title">Contact Info</p>

                  <div className="appt-notify-contact-row appt-contact-edit-inline-row">
                    <div className="appt-notify-contact-left appt-contact-edit-inline-left">
                      <FiMail className="appt-notify-contact-icon" />

                      {contactEditType === "email" ? (
                        <input
                          className="appt-contact-edit-inline-input"
                          value={contactEditValue}
                          onChange={(e) => {
                            const value = e.target.value.trimStart();

                            setContactEditValue(value);

                            if (!value.trim()) {
                              setContactEditError("email-empty");
                            } else {
                              setContactEditError("");
                            }
                          }}
                          placeholder="Add email address"
                          autoFocus
                        />
                      ) : (
                        <span>
                          {patientDefaultContact.email || "Add Email Address"}
                        </span>
                      )}
                    </div>

                    {contactEditType === "email" ? (
                      <div className="appt-contact-edit-inline-actions">
                        <button
                          type="button"
                          className="appt-contact-edit-inline-save"
                          disabled={contactEditSaving}
                          onClick={saveDefaultContactEdit}
                        >
                          <FiCheck />
                        </button>

                        <button
                          type="button"
                          className="appt-contact-edit-inline-cancel"
                          onClick={closeDefaultContactEdit}
                        >
                          <FiX />
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="appt-notify-edit-btn"
                        onClick={() => openDefaultContactEdit("email")}
                      >
                        <FiEdit2 />
                      </button>
                    )}

                    {renderContactEmptyWarning("email")}
                    {renderContactApiError("email")}
                  </div>

                  <div className="appt-notify-contact-row appt-contact-edit-inline-row">
                    <div className="appt-notify-contact-left appt-contact-edit-inline-left">
                      <FiPhoneCall className="appt-notify-contact-icon" />

                      {contactEditType === "phone" ? (
                        <input
                          className="appt-contact-edit-inline-input"
                          value={contactEditValue}
                          onChange={(e) => {
                            const value = sanitizeReminderPhoneInput(
                              e.target.value,
                            );

                            setContactEditValue(value);

                            if (!value.trim()) {
                              setContactEditError("phone-empty");
                            } else {
                              setContactEditError("");
                            }
                          }}
                          onPaste={(e) => {
                            e.preventDefault();

                            const pastedValue = e.clipboardData.getData("text");
                            const numericValue = sanitizeReminderPhoneInput(
                              `${contactEditValue || ""}${pastedValue}`,
                            ).slice(0, 15);

                            setContactEditValue(numericValue);

                            if (!numericValue.trim()) {
                              setContactEditError("phone-empty");
                            } else {
                              setContactEditError("");
                            }
                          }}
                          placeholder="Add Phone number"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength={15}
                          autoFocus
                        />
                      ) : (
                        <span>
                          {patientDefaultContact.phone
                            ? `${patientDefaultContact.phoneCode || ""} ${patientDefaultContact.phone}`.trim()
                            : "Add Phone Number"}
                        </span>
                      )}
                    </div>

                    {contactEditType === "phone" ? (
                      <div className="appt-contact-edit-inline-actions">
                        <button
                          type="button"
                          className="appt-contact-edit-inline-save"
                          disabled={contactEditSaving}
                          onClick={saveDefaultContactEdit}
                        >
                          <FiCheck />
                        </button>

                        <button
                          type="button"
                          className="appt-contact-edit-inline-cancel"
                          onClick={closeDefaultContactEdit}
                        >
                          <FiX />
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="appt-notify-edit-btn"
                        onClick={() => openDefaultContactEdit("phone")}
                      >
                        <FiEdit2 />
                      </button>
                    )}

                    {renderContactEmptyWarning("phone")}
                    {renderContactApiError("phone")}
                  </div>
                </div>

                <div className="appt-notify-section">
                  <p className="appt-notify-section-title">Reminder Schedule</p>
                  <p className="appt-notify-schedule-sub">
                    Send Appointment Reminder prior to the days listed below
                  </p>

                  <div className="appt-notify-schedule-grid">
                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifySchedule.before1Day}
                        onChange={() =>
                          handleAppointmentNotifyScheduleChange("before1Day")
                        }
                      />
                      <span>Before 1 Day</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifySchedule.before2Day}
                        onChange={() =>
                          handleAppointmentNotifyScheduleChange("before2Day")
                        }
                      />
                      <span>Before 2 Day</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifySchedule.before3Day}
                        onChange={() =>
                          handleAppointmentNotifyScheduleChange("before3Day")
                        }
                      />
                      <span>Before 3 Day</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifySchedule.before4Day}
                        onChange={() =>
                          handleAppointmentNotifyScheduleChange("before4Day")
                        }
                      />
                      <span>Before 4 Day</span>
                    </label>

                    <label className="appt-notify-option">
                      <input
                        type="checkbox"
                        checked={appointmentNotifySchedule.before5Day}
                        onChange={() =>
                          handleAppointmentNotifyScheduleChange("before5Day")
                        }
                      />
                      <span>Before 5 Day</span>
                    </label>

                    <div className="appt-notify-custom-date-row">
                      <label className="appt-notify-option appt-notify-custom-option">
                        <input
                          type="checkbox"
                          checked={appointmentNotifySchedule.customDate}
                          onChange={() =>
                            handleAppointmentNotifyScheduleChange("customDate")
                          }
                        />
                        <span>Custom Date</span>
                      </label>

                      {appointmentNotifySchedule.customDate && (
                        <div className="appt-notify-custom-date-field">
                          <DatePicker
                            getPopupContainer={(triggerNode) =>
                              (triggerNode &&
                                triggerNode.closest &&
                                triggerNode.closest(
                                  ".ant-tabs-content-holder",
                                )) ||
                              document.getElementById("new-appts") ||
                              document.body
                            }
                            placeholder={dtFormat || "MM-DD-YYYY"}
                            format={dtFormat}
                            value={
                              appointmentNotifyCustomDate
                                ? moment(appointmentNotifyCustomDate, dtFormat)
                                : null
                            }
                            onChange={handleAppointmentNotifyCustomDateChange}
                            disabled={!aptdate}
                            disabledDate={(current) => {
                              if (!current) return false;

                              const today = moment().startOf("day");

                              if (current.isBefore(today, "day")) {
                                return true;
                              }

                              if (!aptdate) {
                                return true;
                              }

                              const appointmentDate = moment(
                                aptdate,
                                dtFormat,
                              ).startOf("day");

                              if (!appointmentDate.isValid()) {
                                return true;
                              }

                              return current.isSameOrAfter(
                                appointmentDate,
                                "day",
                              );
                            }}
                            allowClear={false}
                          />

                          {appointmentNotifyCustomDateWarning && (
                            <div className="appt-notify-custom-date-warning">
                              <FiAlertCircle className="appt-notify-custom-warning-icon" />
                              <span>Select a Appointment Date first</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Div>
      </>
    );
  };

  const handleRefresh = () => {
    if (!storedNames.setProviderAvailability_viewOnly) {
      props.closepopup();
      props.FetchAppointments(
        props.provarray,
        props.facarray,
        props.appFromDate,
        props.apptoDate,
        props.pat_share,
        props.examroom,
      );
    } else {
      alert("You only have view-only access.");
    }
  };

  // changes by sridar
  const ClientAdd = (result) => {
    setClientAddIs(result);
  };
  const openIntake = (data) => {
    setShow(false);
    setIntakeData(data);
    setShowIntakeForm(true);

    const article = {
      mail: data.email,
      userID: userID,
      MailUrl: AccessMailUrl,
      pid: String(data.id),
    };

    let encrypted = Encrypt_Value(article, "vozo");
    axiosInstance
      .post("/vozo/patient/clientportalaccess/sendmail", encrypted)
      .catch((err) => {
        console.error("Portal mail sending failed", err);
      });
  };

  const enableSwitch = (checked) => {
    setswitchvalue(checked);
    const article = [
      {
        glname: "enable_availability_switch",
        glindex: "0",
        glvalue: checked === true ? "1" : "0",
      },
    ];
    let put_data_enc = Encrypt_Value(article, "vozo");
    axiosInstance
      .put("/vozo/settingdocument", put_data_enc)
      .then((response) => {});
  };

  //.....................

  const AddTemplate = () => {
    setShowAvl(!showAvl);
    setid(0);
    setEid("");
    setIdforDelete(0);
  };

  const handleShowuntildate = () => {
    setLastdate(true);
  };

  const handlerepSelect = (e) => {
    if (e === "Does not repeat") {
      setchecking1(false);
      setdayswise(false);
      setMonth_and_every(false);
      setrepeatselectnew("");
      setrepeatselect2new("");
      setRepeatSelectMonth("1");
      setweekday("");
      setcustChk("");
      setselectdayError(false);
    } else if (e === "Daily") {
      setstatusid("");
      setchecking1(true);
      setrepeatselectnew("1");
      setrepeatselect2new("0");
      setdayswise(false);
      setMonth_and_every(false);
      setselectdayError(false);
    } else if (e.includes("Week")) {
      setstatusid("");
      setchecking1(true);
      setdayswise(true);
      setMonth_and_every(false);
    }
    setrepValue(e);

    if (e !== "Does not repeat") {
      setServiceDuration(editing ? `${editing} mins` : "15 mins");
    }
  };

  const convertHMS = (value) => {
    return Math.floor(value * 60);
  };

  const disabledFromTimes = (time, meridiem, type) => {
    const now = moment();
    const currentTime = moment(`${time} ${meridiem}`, "h:mm A");
    const appointmentDate = moment(aptdate);
    if (appointmentDate.isSame(now, "day")) {
      if (type === 2 && currentTime.isBefore(now)) {
        return true;
      }
    }
    return false;
  };

  const disabledToTime = (time, meridiem, id, type) => {
    if (!inTime) return false;

    const fromTime = moment(inTime, "h:mm A");
    const toTime = moment(`${time} ${meridiem}`, "h:mm A");
    if (toTime.format("h:mm A") === "12:00 AM") {
      return false;
    }
    const appointmentDate = moment(aptdate);
    if (fromTime.isAfter(toTime) || fromTime.isSame(toTime)) {
      return true;
    }

    return false;
  };

  const handleModalScroll = () => {
    if (!props.showReminderIntro1 && !props.showReminderIntro2) {
      return;
    }

    setScrollVersion((prev) => prev + 1);
  };

  useEffect(() => {
    const isReminderIntroOpen =
      !!props.showReminderIntro1 || !!props.showReminderIntro2;

    if (!isReminderIntroOpen) return;

    const handleWindowScrollOrResize = () => {
      setScrollVersion((prev) => prev + 1);
    };

    window.addEventListener("scroll", handleWindowScrollOrResize, true);
    window.addEventListener("resize", handleWindowScrollOrResize);

    return () => {
      window.removeEventListener("scroll", handleWindowScrollOrResize, true);
      window.removeEventListener("resize", handleWindowScrollOrResize);
    };
  }, [props.showReminderIntro1, props.showReminderIntro2]);

  useEffect(() => {
    if (!props.showReminderIntro1) {
      setStep1PopupStyle({ display: "none" });
      return;
    }
    const updatePosition = () => {
      if (step1Ref.current) {
        const rect = step1Ref.current.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;
        const popupWidth = 320;
        const popupHeight = 175;
        const newTop = `${rect.top + rect.height / 2 - popupHeight / 2 + 43}px`;
        const newLeft = `${rect.left - popupWidth - 50}px`;

        setStep1PopupStyle((prev) => {
          if (
            prev.top === newTop &&
            prev.left === newLeft &&
            prev.display === "block"
          ) {
            return prev;
          }
          return {
            position: "fixed",
            top: newTop,
            left: newLeft,
            zIndex: 10001,
            display: "block",
          };
        });
      }
    };

    updatePosition();

    const intervalId = setInterval(updatePosition, 150);

    return () => {
      clearInterval(intervalId);
    };
  }, [props.showReminderIntro1, scrollVersion, appointmentNotifyExpanded]);

  useEffect(() => {
    if (!props.showReminderIntro2) {
      setStep2PopupStyle({ display: "none" });
      return;
    }
    if (emailReminderRef.current) {
      const rect = emailReminderRef.current.getBoundingClientRect();
      const popupWidth = 320;
      const popupHeight = 175;
      setStep2PopupStyle({
        position: "fixed",
        top: `${rect.top + rect.height / 2 - popupHeight / 2 + 35}px`,
        left: `${rect.left - popupWidth - 50}px`,
        zIndex: 10001,
        display: "block",
      });
    }
  }, [props.showReminderIntro2, appointmentNotifyExpanded, scrollVersion]);

  const handleReminderIntro1Next = () => {
    props.setShowReminderIntro1(false);
    setAppointmentNotifyChecked(true);
    setAppointmentNotifyExpanded(true);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.2",
    });
  };

  const handleReminderIntro2Next = () => {
    props.setShowReminderIntro2(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.3",
    });
  };

  const handleReminderIntro2Back = () => {
    props.setShowReminderIntro2(false);
    setAppointmentNotifyChecked(false);
    setAppointmentNotifyExpanded(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.1",
    });
  };

  const handleReminderIntro3Next = () => {
    props.setShowReminderIntro3(false);
    setNotifyIntegrationWarning("");
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.4",
    });
  };

  const handleReminderIntro3Back = () => {
    props.setShowReminderIntro3(false);
    setNotifyIntegrationWarning("");
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.2",
    });
  };

  const handleReminderIntro4Next = () => {
    props.setShowReminderIntro4(false);
    setShowTwilioModal(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.5",
    });
  };

  const handleReminderIntro4Back = () => {
    props.setShowReminderIntro4(false);
    setShowTwilioModal(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.3",
    });
  };

  const handleReminderIntro5Next = () => {
    props.setShowReminderIntro5(false);
    setShowEmailModal(false);

    if (typeof props.setappshow === "function") {
      props.setappshow(false);
    }
    if (typeof props.closepopup === "function") {
      props.closepopup();
    }

    if (typeof props.setShowDummyAppointment === "function") {
      props.setShowDummyAppointment(true);
    }
    if (typeof props.setShowReminderIntro7 === "function") {
      props.setShowReminderIntro7(true);
    }

    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.6",
    });
  };

  const handleReminderIntro5Back = () => {
    props.setShowReminderIntro5(false);
    setShowEmailModal(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.4",
    });
  };

  const handleIntroBack = () => {
    props.setShowStepSixIntro(false);
    props.setappshow(false);
    history.replace({
      pathname: "/schedule/nav/1",
      search: "?step=6.5",
    });
  };

  const handleIntroGotIt = async () => {
    props.setappshow(false);

    if (returnPath) {
      await axiosInstance.post(
        `/vozo/account-setup/complete-step?patient_id=${userid}&step_id=${"6.1"}`,
      );
      dispatch(clearReturnPath());
      history.push("/settings/accountsetup");
      return;
    }

    await axiosInstance
      .post(
        `/vozo/store/get-started?patient_id=${userid}&seen_intro=${"stepSix"}`,
      )
      .then((response) => {
        const patientAppointmentTourReturnTo = sessionStorage.getItem(
          "patientAppointmentTourReturnTo",
        );

        sessionStorage.removeItem("patientAppointmentTourReturnTo");

        props.setShowStepSixIntro(false);

        if (typeof props.closepopup === "function") {
          props.closepopup();
        }

        if (patientAppointmentTourReturnTo === "userGuide") {
          setTimeout(() => {
            window.dispatchEvent(new Event("openUserGuidePopup"));
          }, 300);
          return;
        }

        history.push("/settings/accountsetup");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function standardizeDate(inputDate) {
    let formats = [
      "YYYY-MM-DD", // 2023-01-15
      "YYYY/MM/DD", // 2023/01/15
      "MM-DD-YYYY", // 01-15-2023 (US format)
      "MM/DD/YYYY", // 01/15/2023 (US format)
      "DD-MM-YYYY", // 15-01-2023 (European format)
      "DD/MM/YYYY", // 15/01/2023 (European format)
    ];

    let date = moment(inputDate, formats, true); // strict mode
    if (!date.isValid()) {
      throw new Error(`Invalid date format: ${inputDate}`);
    }

    return date.format("YYYY-MM-DD");
  }

  const validateRepeatdate = () => {
    moment.locale("en");

    const validDays = weekday
      .filter((val) => val !== "" && !isNaN(val))
      .map(Number)
      .filter((d) => d >= 1 && d <= 7);

    if (validDays.length > 0) {
      const baseDate = moment(aptdate, dtFormat);
      const lastDate = moment(lastdateApp, dtFormat);

      if (!baseDate.isValid() || !lastDate.isValid()) {
        console.error("Invalid date formats for baseDate and lastDate");
        return "continue";
      } else {
        const baseWeekdayIndex = baseDate.day();
        const baseWeekdayVal =
          baseWeekdayIndex === 0 ? 1 : baseWeekdayIndex + 1;

        if (baseDate.isSame(lastDate) && validDays.includes(baseWeekdayVal)) {
          return "continue";
        }

        let nextOccur = baseDate.clone();
        let found = false;

        while (nextOccur.isSameOrBefore(lastDate)) {
          const weekdayIndex = nextOccur.day();
          const weekdayVal = weekdayIndex === 0 ? 1 : weekdayIndex + 1;

          if (validDays.includes(weekdayVal)) {
            found = true;
            break;
          }

          nextOccur.add(1, "day");
        }

        if (!found) {
          return "stop";
        }
      }
    }
    return "continue";
  };

  const hasWeekendOverlap = (startDateStr, endDateStr) => {
    let current = moment(startDateStr, "YYYY-MM-DD");
    const end = moment(endDateStr, "YYYY-MM-DD");

    while (current.isSameOrBefore(end, "day")) {
      const day = current.day();
      if (day === 0 || day === 6) {
        return true;
      }
      current.add(1, "day");
    }

    return false;
  };

  const buttonClickActions = async (e) => {
    e.preventDefault();

    if (
      Appttype === 4 && patientid &&
      (!patientDefaultContact.phone ||
        patientDefaultContact.phone.trim() === "")
    ) {
      return;
    }

    const isBillingFacilityEnabled = await checkBillingFacilityEnabled();

    if (!isBillingFacilityEnabled) {
      return;
    }

    const isIndividualAppointment = !(
      changeTab === "3" || props.isGroupAppointment
    );

    if (isIndividualAppointment && !patientid) {
      setpatError(true);
      setAppointmentNotifyPatientWarning(false);
      return;
    }

    if (
      isIndividualAppointment &&
      !(await validateAppointmentReminderSetup())
    ) {
      return;
    }

    if (
      isIndividualAppointment &&
      appointmentNotifyChecked &&
      appointmentNotifySchedule.customDate &&
      !appointmentNotifyCustomDate
    ) {
      if (props.type === "book again") {
        setAppointmentNotifyCustomDateWarning(true);
        return;
      }

      setReminderScheduleByDays("1");
    }

    if (repvalue === "Daily") {
      var overlapSatSun = hasWeekendOverlap(
        moment(aptdate, dtFormat).format("YYYY-MM-DD"),
        moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      );
      if (overlapSatSun) {
        setShowPopup(true);
        setOnConfirm(() => () => remainingButtonClick(e));
      } else {
        remainingButtonClick(e);
      }
    } else {
      remainingButtonClick(e);
    }
  };
  const handleOpenGroupModal = () => setShowGroupModal(true);
  const handleCloseGroupModal = () => setShowGroupModal(false);
  const remainingButtonClick = async (e) => {
    let MonthOccurences;
    e.preventDefault();

    const isGroupFlow = changeTab === "3" || props.isGroupAppointment;
    const activeServiceCodes = isGroupFlow
      ? groupServiceCode
      : individualServiceCode;

    const serviceCodePayload = getServiceCodePayload(activeServiceCodes);
    if (billFacId === undefined) {
      props.redirect();
      setBtnDis(false);
      return;
    }
    var statusid_temp;
    if (checking1 === true) {
      statusid_temp = "";
    } else {
      if (Appttype === 4) {
        statusid_temp = "call_scheduled";
      } else {
        statusid_temp = statusid;
      }
    }

    if (inTime === "") {
      setInTimeErr(true);
      setBtnDis(false);
      return;
    }

    let availcheckfilt = userAvail.filter((x) => {
      return x.pc_eventDate === aptdate;
    });

    if (availcheckfilt.length !== 0) {
      for (let appointment of availcheckfilt) {
        let intimeString = appointment.pc_eventDate + " " + inTime;
        let outtimeString = appointment.pc_eventDate + " " + outTime;

        let intimeDate = new Date(intimeString);
        let outtimeDate = new Date(outtimeString);
        let startTimeString =
          appointment.pc_eventDate + " " + appointment.pc_startTime;
        let endTimeString =
          appointment.pc_eventDate + " " + appointment.pc_endTime;
        let startTimeDate = new Date(startTimeString);
        let endTimeDate = new Date(endTimeString);

        if (outtimeDate.getTime() === startTimeDate.getTime()) {
          continue;
        }

        if (intimeDate.getTime() === endTimeDate.getTime()) {
          continue;
        }

        if (
          (startTimeDate <= outtimeDate && endTimeDate >= intimeDate) ||
          (endTimeDate >= intimeDate && startTimeDate <= outtimeDate) ||
          (startTimeDate <= intimeDate && endTimeDate >= outtimeDate)
        ) {
          setInTimeErr(true);
          setBtnDis(false);
          return;
        } else {
          setInTimeErr(false);
        }
      }
    }

    const timenew_alert = moment(outTime, ["h:mm A"]).format("HH:mm");
    const time = timenew_alert.split(":");
    const timeHour = time[0];

    const a = moment(timenew_alert, "hh:mm A").format("hh:mm A");

    const maintime = moment(a, "h:mma");

    var b;
    if (endTime !== "12") {
      b = moment(`0${endTime - 12}:00pm`, "h:mma");
    } else {
      b = moment(`${endTime - 12}:00pm`, "h:mma");
    }

    if (inTimeErr || timelimiterrorbox) {
      setBtnDis(false);
      return false;
    }
    if (
      Number(startTime) <= Number(timeHour) &&
      Number(timeHour) <= Number(endTime)
    ) {
      settimelimiterrorbox(false);
    } else {
      settimelimiterrorbox(true);
      setBtnDis(false);
      return false;
    }

    let splitTime = apttime.split(":");
    let splitMin = splitTime[1].split(" ");

    if (splitMin[1] === "PM" && Number(splitTime[0]) !== Number(12)) {
      let totTime = +splitTime[0] + +12;
      if (totTime >= outTime) {
        settimelimiterrorbox(true);
        setBtnDis(false);
        return false;
      } else if (totTime < startTime) {
        settimelimiterrorbox(true);
        setBtnDis(false);
        return false;
      }
    }

    let outSplitTime = outTime.split(":");
    let outSplitMin = outSplitTime[1].split("");

    if (outSplitMin[1] === "PM" && Number(outSplitTime[0]) !== Number(12)) {
      let totTime = +outSplitTime[0] + +12;
      if (totTime >= outTime) {
        setBtnDis(false);
        settimelimiterrorbox(true);
        return false;
      }
    }

    // const toMinutes = (timeStr) => {
    //   const [time, modifier] = timeStr.split(" ");
    //   let [hours, minutes] = time.split(":").map(Number);
    //   if (modifier === "PM" && hours !== 12) hours += 12;
    //   if (modifier === "AM" && hours === 12) hours = 0;
    //   return hours * 60 + minutes;
    // };

    // // Convert numeric hour (like "5" or "16") to formatted string (e.g., "05:00 AM" or "04:00 PM")
    // const convertToTimeString = (hour) => {
    //   const numHour = Number(hour);
    //   const ampm = numHour >= 12 ? "PM" : "AM";
    //   const displayHour = numHour % 12 === 0 ? 12 : numHour % 12;
    //   return `${displayHour.toString().padStart(2, "0")}:00 ${ampm}`;
    // };

    // // Convert all times to minutes
    // const aptMinutes = toMinutes(apttime);
    // const outMinutes = toMinutes(outTime);
    // const startMinutes = toMinutes(convertToTimeString(startTime));
    // const endMinutes = toMinutes(convertToTimeString(endTime));

    // // Check conditions:
    // if (
    //   aptMinutes >= startMinutes &&
    //   aptMinutes < endMinutes &&
    //   outMinutes > startMinutes &&
    //   outMinutes <= endMinutes
    // ) {
    //   settimelimiterrorbox(false);
    // } else {
    //   settimelimiterrorbox(true);
    //   setBtnDis(false);
    //   return false;
    // }
    var timenew = aptdate + " " + apttime;
    var dtFormatWithTime1 = `${dtFormat} hh:mm a`;

    var timedetnew = moment(timenew, dtFormatWithTime1).format(
      "YYYY-MM-DD HH:mm a",
    );
    var durationnew = editing;
    var appttypenew = Appttype;
    // var alldaynew = alldaydisable;
    var walkinnew = walkincheck;
    var select1, select2, untildate, fromdate, todate, days_wise, repeats;
    if (weekday != null) {
      if (weekday || swict_check) {
        if (swict_check && (weekday === "" || weekday.length == 1)) {
          // setWkErr(true);
          setBtnDis(false);
          return false;
        } else {
          // setWkErr(false);
          repeats = weekday;
        }
      } else {
        repeats = "";
      }
    } else {
      repeats = "";
    }

    if (weekday && weekday.length > 0) {
      const repeatResponse = validateRepeatdate();

      if (repeatResponse === "stop") {
        setModalAlerShow1(true);
        setModalMsg1(
          "Please select an end date that matches the recurring day you've chosen",
        );
        setTimeout(() => setModalAlerShow1(false), 4000);
        setBtnDis(false);
        return false;
      }
    }

    if (repeatselectnew) {
      select1 = repeatselectnew;
    } else {
      select1 = 0;
    }

    if (repeatselect2new) {
      select2 = repeatselect2new;
    } else {
      select2 = "";
    }
    var repeat_type;

    if (checking1) {
      untildate = "";
      repeat_type = "notCustom";
    } else {
      untildate = "";
      repeat_type = "norepeat";
    }
    if (aptfromdate) {
      fromdate = aptfromdate;
    } else {
      fromdate = "";
    }

    if (apttodate) {
      todate = apttodate;
    } else {
      todate = "";
    }

    if (dayswise != null) {
      if (dayswise) {
        days_wise = true;
      } else {
        days_wise = false;
      }
    } else {
      days_wise = false;
    }

    var tempdatenew = moment(timedetnew, moment.defaultFormat).toDate();
    var startTimenew = moment(tempdatenew).format("hh:mm a");

    var returned_endatenew = moment(tempdatenew, dtFormatWithTime1)
      .add(durationnew, "minutes")
      .format("YYYY-MM-DD hh:mm a");

    var startdatenew = moment(tempdatenew, dtFormat).format("YYYY-MM-DD");
    var secondsnew = convertHMS(durationnew);

    var endTimenew = moment(outTime, "h:mm A").format("hh:mm a");

    var endDatenew = moment(
      returned_endatenew,
      "YYYY-MM-DD hh:mm a",
      true,
    ).format("YYYY-MM-DD");

    var MeetMode = Telehealthplatform;

    const repeatsString =
      repeats &&
      repeats
        .filter((value) => {
          if (typeof value === "number") {
            return !isNaN(value);
          }
          if (typeof value === "string") {
            const num = Number(value.trim());
            return !isNaN(num) && num !== "";
          }
          return false;
        })
        .map((value) =>
          typeof value === "string" ? Number(value.trim()) : value,
        )
        .filter((num) => num !== 0)
        .sort((a, b) => a - b)
        .join(",");

    // return

    const eventDateTime = moment(
      `${startdatenew} ${startTimenew}`,
      "YYYY-MM-DD hh:mm a",
    );

    let now = moment();

    const nowMinutes = now.minutes();
    const nowHour = now.hours();

    if (nowHour === 0 && nowMinutes < 5) {
      now = now.subtract(nowMinutes, "minutes");
    } else {
      now = now.subtract(5, "minutes");
    }

    if (eventDateTime.isSameOrBefore(now) && appttypenew == 2) {
      setModalAlerShow1(true);
      setModalMsg1(
        "Your Telehealth appointments cannot be scheduled for past Telehealth availability dates",
      );
      setTimeout(() => setModalAlerShow1(false), 4000);
      setBtnDis(false);
      return false;
    }
    let groupStatusGenerated = [];

    if (changeTab === "3" || props.isGroupAppointment) {
      let groupStatus = appttypenew == 1 ? "EMAIL" : "doc_confirmed";
      const selectedGroup = groupPatients.find(
        (group) => String(group.value) === String(groupId),
      );

      if (selectedGroup && selectedGroup.pid) {
        groupStatusGenerated = selectedGroup.pid
          .split(",")
          .map((pid) => pid.trim())
          .filter((pid) => pid)
          .map((pid) => ({
            pid: Number(pid),
            status: groupStatus,
          }));
      }
    }

    var article = {
      pc_pid: patientid,
      pc_catid: profileid,
      pc_billid: billingid !== "" ? Number(billingid) : null,
      pc_aid: providerid,
      pc_title: statusid_temp,
      pc_duration: secondsnew,
      pc_hometext: "",
      pc_apptstatus: statusid_temp,
      pc_eventDate: startdatenew,
      pc_endDate: endDatenew,
      pc_startTime: startTimenew,
      pc_endTime: endTimenew,
      pc_facility: officeid,
      pc_informant: providerid,
      pc_billing_location: "10",
      pc_select1: select1,
      pc_select2: select2,
      pc_untildate:
        untildate !== ""
          ? moment(untildate).format("YYYY-MM-DD")
          : moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),

      pc_lastdate: moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      pc_fromdate: fromdate,
      pc_todate: todate,
      days_wise: days_wise,
      days_of_week: repeatsString,
      // allday: alldaynew,
      repeats: repeats,
      // appttype: appttypenew,
      appttype: walkincheck && allowAppt === 2 ? 2 : appttypenew,
      walkin: walkinnew,
      examRoom: roomval,
      id: authorized === "1" ? userID : main_pro,
      pc_repeat_type: repeat_type,
      week_and_every_day: Week_and_every,
      month_and_every_day: Month_and_every,
      Month_and_every_Interval: Month_and_every_Interval,

      on_never_after: custChk,
      repeat_select: repvalue,
      pc_repeatselectmonth: repeatselectmonth,
      selectMonthAlp:
        repeatselectmonth === 1 || repeatselectmonth === "1"
          ? `Monthly on day ${dyOfMont}`
          : `Monthly on the ${wkOfMont} ${day}`,
      repeatSelectMonthOccurenceDates: MonthOccurences,
      speciality,
      mode: MeetMode,
      reason: reason,
      isGroup: 0,
      pc_service_codes: serviceCodePayload,
      appointment_reminder: getAppointmentReminderPayload(),
      ...(props.fromEpisode && {
        from_episode: true,
        episode_id: props.episodeId,
      }),
      // billingFacilityId: billFacilityID,
    };

    const groupAppointmentArticle = {
      group_status: groupStatusGenerated,
      isGroup: 1,
      pc_service_codes: serviceCodePayload,
      pc_pid: groupId,
      pc_catid: profileid,
      pc_billid: billingid !== "" ? Number(billingid) : null,
      pc_aid: providerid,
      pc_title: statusid_temp,
      pc_duration: secondsnew,
      pc_hometext: "",
      pc_apptstatus: statusid_temp,
      pc_eventDate: startdatenew,
      pc_endDate: endDatenew,
      pc_startTime: startTimenew,
      pc_endTime: endTimenew,
      pc_facility: officeid,
      pc_informant: providerid,
      pc_billing_location: "10",
      pc_select1: select1,
      pc_select2: select2,
      pc_untildate:
        untildate !== ""
          ? moment(untildate).format("YYYY-MM-DD")
          : moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),

      pc_lastdate: moment(lastdateApp, dtFormat).format("YYYY-MM-DD"),
      pc_fromdate: fromdate,
      pc_todate: todate,
      days_wise: days_wise,
      days_of_week: repeatsString,
      // allday: alldaynew,
      repeats: repeats,
      // appttype: appttypenew,
      appttype: walkincheck && allowAppt === 2 ? 2 : appttypenew,
      walkin: walkinnew,
      examRoom: roomval,
      id: authorized === "1" ? userID : main_pro,
      pc_repeat_type: repeat_type,
      week_and_every_day: Week_and_every,
      month_and_every_day: Month_and_every,
      Month_and_every_Interval: Month_and_every_Interval,

      on_never_after: custChk,
      repeat_select: repvalue,
      pc_repeatselectmonth: repeatselectmonth,
      selectMonthAlp:
        repeatselectmonth === 1 || repeatselectmonth === "1"
          ? `Monthly on day ${dyOfMont}`
          : `Monthly on the ${wkOfMont} ${day}`,
      repeatSelectMonthOccurenceDates: MonthOccurences,
      speciality,
      mode: MeetMode,
      reason: reason,

      // billingFacilityId: billFacilityID,
    };

    const finalArticle =
      changeTab === "3" || props.isGroupAppointment
        ? groupAppointmentArticle
        : article;
    console.log("appointment payload shape : ", finalArticle);

    let encryptedData = Encrypt_Value(finalArticle, "vozo");

    const startTimeCheck = moment(startTimenew, "hh:mm A");
    const endTimeCheck = moment(endTimenew, "hh:mm A");
    if (select1 === 0) {
      let error = 1;
      if (
        (patientid === "" && groupId === null) ||
        profileid === "" ||
        providerid === "" ||
        providerid === null ||
        providerid === undefined ||
        endTimeCheck.isBefore(startTimeCheck) ||
        aptdate === "" ||
        officeid === "" ||
        speciality === "" ||
        (roomval === "" && !isSuffixEnabledSite) ||
        // billFacilityID === "" ||
        // billFacilityID === null ||
        (repvalue === "Week" && (weekday === "" || weekday.length == 0))
      ) {
        if (patientid === "" && groupId === null) {
          setpatError(true);
          setGroupPatError(true);
          error = 2;
        }
        if (aptdate === "") {
          setDateErr(true);
          error = 2;
        }
        if (profileid === "") {
          setprofileError(true);
          error = 2;
        }
        if (roomval === "" && !isSuffixEnabledSite) {
          setexamroomError(true);
          error = 2;
        }
        if (!endTimeCheck.isAfter(startTimeCheck)) {
          setTimeMismatch(true);
          error = 2;
        }

        if (repvalue === "Week" && (weekday === "" || weekday.length == 0)) {
          setselectdayError(true);
          error = 2;
        }
        if (
          providerid === "" ||
          providerid === null ||
          providerid === undefined
        ) {
          setprovError(true);
          error = 2;
        }
        if (officeid === "") {
          setofficeError(true);
          error = 2;
        }
        if (speciality === "") {
          setSpecialError(true);
          error = 2;
        }
        // if (billFacilityID === "" || billFacilityID === null) {
        //   setBillFacilityError(true);
        //   return;
        // }

        if (error > 1) {
          setBtnDis(false);
          return false;
        }
      } else {
        // setSpinnerVal(true);
        setBtnDis(true);
        if (statusid === "doc_confirmed" || statusid === "EMAIL") {
          axiosInstance
            .get("/vozo/pat_mail_check?pid=" + patientid)
            .then((response) => {
              if (response.data) {
                // props.setspinnerfornewapp();
                axiosInstance
                  .post("/vozo/appointment?pid=" + patientid, encryptedData)
                  .then(async (res) => {
                    // console.log("response data : ", res);

                    setBtnDis(true);
                    let apptAdded = res.data;
                    // return;
                    if (
                      MeetMode === "GMeet" &&
                      videochck &&
                      (statusid === "doc_confirmed" || statusid === "EMAIL")
                    ) {
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");

                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                            fac_id: res["pc_facility"],
                          };

                          if (props.fromWaitList) {
                            await deleteWaitlistEntry(props.waitlistData.id);
                          }

                          axios
                            .get(
                              fileurl +
                              "/interface/customized/g-meet/index.php?action=create",
                              { params: article },
                            )
                            .then(async (res) => {
                              // setBtnDis(false);

                              if (apptAdded === "out of both range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected Date & time should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (apptAdded === "out of time range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected time should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (apptAdded === "out of date range") {
                                setBtnDis(false);

                                setModalAlerShow1(true);
                                setModalMsg1(
                                  "Selected Date should be within the provider availability range.",
                                );
                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded === "Provider Not Available"
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1("Provider Not Available");
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded ===
                                "You Can't place the Appointment at this time"
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(
                                    "You Can't place the Appointment at this time",
                                  );
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  2000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "You are only allowed to add telehealth appointments",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(apptAdded);
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "Appointment already scheduled at",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(
                                    formatAppointmentOverlapMessage(apptAdded),
                                  );
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else if (
                                apptAdded.includes(
                                  "The provider is unavailable on these dates",
                                )
                              ) {
                                setBtnDis(false);

                                setTimeout(() => {
                                  setModalAlerShow1(true);
                                  setModalMsg1(apptAdded);
                                }, 1);

                                setTimeout(
                                  () => setModalAlerShow1(false),
                                  3000,
                                );
                                return;
                              } else {
                                await savePatientAppointmentReminderPreference(
                                  patientid,
                                );

                                setBtnDis(true);

                                props.savealertmsg(
                                  "New Appointment Added Successfully",
                                  true,
                                  getWaitlistStep8AppointmentData(),
                                );
                                setBtnDis(true);
                                axiosInstance
                                  .get("/vozo/tele/checkemailsent")
                                  .then((response) => {
                                    setBtnDis(true);
                                    setSpinnerVal(false);
                                    props.savealertmsg(response.data, true);
                                    // props.onBookAppointment(startdatenew);
                                    setTimeout(() => {
                                      props.popuphide();
                                      props.closepopup();
                                      if (
                                        props.showStepSixIntro ||
                                        returnPath
                                      ) {
                                        handleIntroGotIt();
                                      }
                                    }, 4000);
                                  })
                                  .catch((err) => {
                                    setSpinnerVal(false);
                                    console.error(err);
                                    setBtnDis(false);
                                    props.closepopup();
                                  });

                                // props.setBookAgain(false);
                              }
                              setBtnDis(true);
                              setTimeout(() => props.popuphide(), 4000);
                              props.FetchAppointments(
                                props.provarray,
                                props.facarray,
                                props.appFromDate,
                                props.apptoDate,
                                props.pat_share,
                                props.examroom,
                                [],
                                aptdate,
                              );

                              if (
                                typeof props.onBookAppointment === "function"
                              ) {
                                props.onBookAppointment(aptdate);
                              }
                            })
                            .catch((err) => {
                              console.log("failed");
                            });
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    } else {
                      // setBtnDis(false);

                      if (apptAdded === "out of both range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected Date & time should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (apptAdded === "out of time range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected time should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (apptAdded === "out of date range") {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "Selected Date should be within the provider availability range.",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (
                        apptAdded ===
                        "You Can't place the Appointment at this time"
                      ) {
                        setBtnDis(false);

                        setModalAlerShow1(true);
                        setModalMsg1(
                          "You Can't place the Appointment at this time",
                        );
                        setTimeout(() => setModalAlerShow1(false), 4000);
                        return;
                      } else if (
                        apptAdded.includes(
                          "You are only allowed to add telehealth appointments",
                        )
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(apptAdded);
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else if (
                        apptAdded.includes(
                          "The provider is unavailable on these dates",
                        )
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(apptAdded);
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else if (
                        apptAdded.includes("Appointment already scheduled at")
                      ) {
                        setBtnDis(false);

                        setTimeout(() => {
                          setModalAlerShow1(true);
                          setModalMsg1(
                            formatAppointmentOverlapMessage(apptAdded),
                          );
                        }, 1);

                        setTimeout(() => setModalAlerShow1(false), 3000);
                        return;
                      } else {
                        await savePatientAppointmentReminderPreference(
                          patientid,
                        );

                        setBtnDis(true);

                        props.savealertmsg(
                          "New Appointment Added Successfully",
                          true,
                          getWaitlistStep8AppointmentData(),
                        );

                        axiosInstance
                          .get("/vozo/getGMeet/data")
                          .then(async (response) => {
                            var res = Decrypt_Value(response.data, "vozo");
                            let article = {
                              start_time: res["start_time"],
                              end_time: res["end_time"],
                              attendees: res["attendees"],
                              start: res["pc_startTime"],
                              end: res["pc_endTime"],
                              eventdate: res["pc_eventDate"],
                              eid: res["pc_eid"],
                              aid: res["pc_aid"],
                              pid: res["pc_pid"],
                              fac_id: res["pc_facility"],
                              name: res["pat_name"],
                              geventid: res["gevent"],
                              google_appt_sync: res["google_appt_sync"],
                              google_availability_sync:
                                res["google_availability_sync"],
                              uid: userID,
                              tenant_id: DBHost,
                              outlook_appt_sync: res["outlook_appt_sync"],
                              outlook_availability_sync:
                                res["outlook_availability_sync"],
                              user_id: userID,
                              is_telehealth: res["pc_telehealth"],
                            };
                            if (res["google_appt_sync"] === 1) {
                              axios
                                .get(
                                  fileurl +
                                  "/interface/customized/g-meet/index.php?action=create",
                                  { params: article },
                                )
                                .then((res) => {
                                  // setBtnDis(false);
                                })
                                .catch((err) => {
                                  console.log("failed");
                                });
                            }
                            if (res["outlook_appt_sync"] === 1) {
                              axios.post(
                                fileurl +
                                "/interface/customized/outlook/create_event.php",
                                { params: article },
                              );
                            }
                          })
                          .catch((err) => {
                            console.error(err);
                          });

                        if (
                          statusid === "doc_confirmed" ||
                          statusid === "EMAIL"
                        ) {
                          axiosInstance
                            .get("/vozo/tele/checkemailsent")
                            .then((response) => {
                              setSpinnerVal(false);
                              props.savealertmsg(response.data, true);
                              // props.onBookAppointment(startdatenew);
                              setTimeout(() => {
                                props.popuphide();
                                props.closepopup();
                                if (props.showStepSixIntro || returnPath) {
                                  handleIntroGotIt();
                                }
                              }, 4000);
                            })
                            .catch((err) => {
                              setSpinnerVal(false);
                              console.error(err);
                              props.closepopup();
                            });
                        } else {
                          if (props.showStepSixIntro || returnPath) {
                            props.savealertmsg(
                              "New Appointment Added Successfully",
                              true,
                            );
                            setTimeout(() => {
                              props.closepopup();
                              handleIntroGotIt();
                            }, 4000);
                          } else {
                            props.closepopup();
                          }
                        }

                        // props.setBookAgain(false);
                      }
                      setTimeout(() => props.popuphide(), 4000);
                      props.FetchAppointments(
                        props.provarray,
                        props.facarray,
                        props.appFromDate,
                        props.apptoDate,
                        props.pat_share,
                        props.examroom,
                        [],
                        aptdate,
                      );
                      if (typeof props.onBookAppointment === "function") {
                        props.onBookAppointment(aptdate);
                      }
                    }
                  })
                  .catch((err) => console.error(err));
              }
              // else {
              //   alert("Please update a valid Email in Patient Demographics");
              //   props.closepopup();
              // }
              // setBtnDis(false);
            })
            .catch((err) => {
              setSpinnerVal(false);
              setBtnDis(false);
              console.error(err);
            });
        } else {
          // props.setspinnerfornewapp();
          axiosInstance
            .post("/vozo/appointment?pid=" + patientid, encryptedData)
            .then(async (res) => {
              console.log("res data : ", res);

              setBtnDis(true);
              let apptAdded = res.data;
              // return;
              // props.setNewShow(false);
              // props.setBookAgain(false);

              // setBtnDis(false);

              if (apptAdded === "out of both range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date & time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of time range") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    "Selected time should be within the provider availability range.",
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "Provider Not Available") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    `The provider is unavailable from ${inTime} to ${outTime} on ${
                      aptdate
                      ? moment(aptdate, dtFormat).format("MMMM DD, YYYY")
                      : ""
                    }. Select another time slot.`,
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded === "You Can't place the Appointment at this time"
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("You Can't place the Appointment at this time");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of date range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded.includes(
                  "You are only allowed to add telehealth appointments",
                )
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("The provider is unavailable on these dates")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    `The provider is unavailable from ${inTime} to ${outTime} on ${
                      aptdate
                      ? moment(aptdate, dtFormat).format("MMMM DD, YYYY")
                      : ""
                    }. Select another time slot.`,
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("Appointment already scheduled at")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(formatAppointmentOverlapMessage(apptAdded));
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else {
                await savePatientAppointmentReminderPreference(patientid);

                setBtnDis(true);

                props.savealertmsg(
                  "New Appointment Added Successfully",
                  true,
                  getWaitlistStep8AppointmentData(),
                );

                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");

                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                      fac_id: res["pc_facility"],
                      name: res["pat_name"],
                      geventid: res["gevent"],
                      google_appt_sync: res["google_appt_sync"],
                      google_availability_sync: res["google_availability_sync"],
                      uid: userID,
                      tenant_id: DBHost,
                      outlook_appt_sync: res["outlook_appt_sync"],
                      outlook_availability_sync:
                        res["outlook_availability_sync"],
                      user_id: userID,
                      is_telehealth: res["pc_telehealth"],
                    };
                    if (res["google_appt_sync"] === 1) {
                      axios
                        .get(
                          fileurl +
                          "/interface/customized/g-meet/index.php?action=create",
                          { params: article },
                        )
                        .then((res) => {})
                        .catch((err) => {
                          console.log("failed");
                        });
                    }
                    if (res["outlook_appt_sync"] === 1) {
                      axios.post(
                        fileurl +
                        "/interface/customized/outlook/create_event.php",
                        { params: article },
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  });

                if (statusid === "doc_confirmed") {
                  axiosInstance
                    .get("/vozo/getGMeet/data")
                    .then((response) => {
                      // console.log(response);
                    })
                    .catch((err) => {
                      setSpinnerVal(false);
                      console.error(err);
                    });

                  axiosInstance
                    .get("/vozo/tele/checkemailsent")
                    .then((response) => {
                      setSpinnerVal(false);
                      props.savealertmsg(response.data, true);
                      // props.onBookAppointment(startdatenew);
                      setTimeout(() => {
                        props.popuphide();
                        props.closepopup();
                        if (
                          (props.showStepSixIntro || returnPath) &&
                          typeof props.onGroupAppointmentSavedForTour !==
                          "function"
                        ) {
                          handleIntroGotIt();
                        }
                      }, 4000);
                    })
                    .catch((err) => {
                      props.closepopup();
                      setSpinnerVal(false);
                      console.error(err);
                    });
                } else {
                  if (props.showStepSixIntro || returnPath) {
                    props.savealertmsg(
                      "New Appointment Added Successfully",
                      true,
                    );
                    setTimeout(() => {
                      props.closepopup();
                      if (
                        typeof props.onGroupAppointmentSavedForTour !==
                        "function"
                      ) {
                        handleIntroGotIt();
                      }
                    }, 4000);
                  } else {
                    props.savealertmsg(
                      "New Appointment Added Successfully",
                      true,
                    );
                    setTimeout(() => {
                      props.closepopup();
                    }, 2000);
                  }
                }
                // props.setBookAgain(false);
              }
              setTimeout(() => props.popuphide(), 4000);
              setSpinnerVal(false);

              props.FetchAppointments(
                props.provarray,
                props.facarray,
                props.appFromDate,
                props.apptoDate,
                props.pat_share,
                props.examroom,
                [],
                aptdate,
              );
              if (typeof props.onBookAppointment === "function") {
                props.onBookAppointment(aptdate);
              }

              if (
                (changeTab === "3" || props.isGroupAppointment) &&
                typeof props.onGroupAppointmentSavedForTour === "function"
              ) {
                setTimeout(() => {
                  props.onGroupAppointmentSavedForTour();
                }, 500);
              }

              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              props.closepopup();
              setBtnDis(false);
            });
        }
      }
    } else if (select1 > 0) {
      let error = 1;
      if (
        patientid === "" ||
        profileid === "" ||
        providerid === "" ||
        providerid === null ||
        !endTimeCheck.isAfter(startTimeCheck) ||
        providerid === undefined ||
        aptdate === "" ||
        // statusid === "" ||
        officeid === "" ||
        (roomval === "" && !isSuffixEnabledSite) ||
        speciality === "" ||
        // billFacilityID === "" ||
        // billFacilityID === null ||
        (repvalue === "Week" && (weekday === "" || weekday.length == 0))
        // ||
        // untildate === ""
      ) {
        if (patientid === "" && groupId === null) {
          setpatError(true);
          setGroupPatError(true);
          error = 2;
        }
        if (aptdate === "") {
          setDateErr(true);
          error = 2;
        }
        if (profileid === "") {
          setprofileError(true);
          error = 2;
        }
        if (roomval === "" && !isSuffixEnabledSite) {
          setexamroomError(true);
          error = 2;
        }
        if (!endTimeCheck.isAfter(startTimeCheck)) {
          setTimeMismatch(true);
          error = 2;
        }
        // if (billFacilityID === "" || billFacilityID === null) {
        //   setBillFacilityError(true);
        //   error = 2;
        // }

        if (repvalue === "Week" && (weekday === "" || weekday.length == 0)) {
          setselectdayError(true);
          error = 2;
        }

        if (
          providerid === "" ||
          providerid === null ||
          providerid === undefined
        ) {
          setprovError(true);
          error = 2;
        }

        if (officeid === "") {
          setofficeError(true);
          error = 2;
        }

        if (speciality === "") {
          setSpecialError(true);
          error = 2;
        }

        // if (untildate === "") {
        //   setuntildateError(true);
        //   error = 2;
        // }

        if (error > 1) {
          setBtnDis(false);
          return false;
        }
      } else {
        setBtnDis(true);
        if (statusid === "doc_confirmed") {
          axiosInstance
            .get("/vozo/pat_mail_check?pid=" + patientid)
            .then((response) => {
              if (response.data) {
                // props.setspinnerfornewapp();
                setSpinnerVal(false);

                axiosInstance
                  .post("/vozo/appointment?pid=" + patientid, encryptedData)
                  .then(async (res) => {
                    console.log("res data : ", res);

                    setBtnDis(true);
                    let apptAdded = res.data;

                    if (
                      MeetMode === "GMeet" &&
                      videochck &&
                      (statusid === "doc_confirmed" || statusid === "EMAIL")
                    ) {
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");
                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                          };
                          if (props.fromWaitList) {
                            await deleteWaitlistEntry(props.waitlistData.id);
                          }
                          axios
                            .get(
                              fileurl +
                              "/interface/customized/g-meet/index.php?action=create",
                              { params: article },
                            )
                            .then((res) => {})
                            .catch((err) => {
                              console.log("failed");
                            });
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    }

                    // setBtnDis(false);

                    if (apptAdded === "out of both range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected Date & time should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "out of time range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected time should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "out of date range") {
                      setBtnDis(false);

                      setModalAlerShow1(true);
                      setModalMsg1(
                        "Selected Date should be within the provider availability range.",
                      );
                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (apptAdded === "Provider Not Available") {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(
                          `The provider is unavailable from ${inTime} to ${outTime} on ${
                            aptdate
                            ? moment(aptdate, dtFormat).format(
                              "MMMM DD, YYYY",
                            )
                            : ""
                          }. Select another time slot.`,
                        );
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (
                      apptAdded ===
                      "You Can't place the Appointment at this time"
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(
                          "You Can't place the Appointment at this time",
                        );
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 4000);
                      return;
                    } else if (
                      apptAdded.includes(
                        "You are only allowed to add telehealth appointments",
                      )
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(apptAdded);
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else if (
                      apptAdded.includes(
                        "The provider is unavailable on these dates",
                      )
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(apptAdded);
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else if (
                      apptAdded.includes("Appointment already scheduled at")
                    ) {
                      setBtnDis(false);

                      setTimeout(() => {
                        setModalAlerShow1(true);
                        setModalMsg1(
                          formatAppointmentOverlapMessage(apptAdded),
                        );
                      }, 1);

                      setTimeout(() => setModalAlerShow1(false), 3000);
                      return;
                    } else {
                      await savePatientAppointmentReminderPreference(patientid);

                      setBtnDis(true);

                      props.savealertmsg(
                        "New Appointment Added Successfully",
                        true,
                        getWaitlistStep8AppointmentData(),
                      );
                      axiosInstance
                        .get("/vozo/getGMeet/data")
                        .then(async (response) => {
                          var res = Decrypt_Value(response.data, "vozo");

                          let article = {
                            start_time: res["start_time"],
                            end_time: res["end_time"],
                            attendees: res["attendees"],
                            start: res["pc_startTime"],
                            end: res["pc_endTime"],
                            eventdate: res["pc_eventDate"],
                            enddate: res["pc_endDate"],
                            eid: res["pc_eid"],
                            aid: res["pc_aid"],
                            pid: res["pc_pid"],
                            fac_id: res["pc_facility"],
                            name: res["pat_name"],
                            geventid: res["gevent"],
                            google_appt_sync: res["google_appt_sync"],
                            google_availability_sync:
                              res["google_availability_sync"],
                            uid: userID,
                            tenant_id: DBHost,
                            outlook_appt_sync: res["outlook_appt_sync"],
                            outlook_availability_sync:
                              res["outlook_availability_sync"],
                            user_id: userID,
                          };
                          if (res["google_appt_sync"] === 1) {
                            axios
                              .get(
                                fileurl +
                                "/interface/customized/g-meet/index.php?action=create",
                                { params: article },
                              )
                              .then((res) => {
                                // setBtnDis(false);
                              })
                              .catch((err) => {
                                console.log("failed");
                              });
                          }
                          if (res["outlook_appt_sync"] === 1) {
                            axios.post(
                              fileurl +
                              "/interface/customized/outlook/create_event.php",
                              { params: article },
                            );
                          }
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                      if (statusid === "doc_confirmed") {
                        axiosInstance
                          .get("/vozo/tele/checkemailsent")
                          .then((response) => {
                            props.savealertmsg(response.data, true);
                            // props.onBookAppointment(startdatenew);
                            setTimeout(() => {
                              props.popuphide();
                              props.closepopup();
                              if (props.showStepSixIntro || returnPath) {
                                handleIntroGotIt();
                              }
                            }, 4000);
                          })
                          .catch((err) => {
                            console.error(err);
                            props.closepopup();
                          });
                      } else {
                        if (props.showStepSixIntro || returnPath) {
                          props.savealertmsg(
                            "New Appointment Added Successfully",
                            true,
                          );
                          setTimeout(() => {
                            props.closepopup();
                            handleIntroGotIt();
                          }, 3000);
                        } else {
                          props.closepopup();
                        }
                      }
                    }
                    setTimeout(() => props.popuphide(), 4000);
                    props.FetchAppointments(
                      props.provarray,
                      props.facarray,
                      props.appFromDate,
                      props.apptoDate,
                      props.pat_share,
                      props.examroom,
                      [],
                      aptdate,
                    );
                    if (typeof props.onBookAppointment === "function") {
                      props.onBookAppointment(aptdate);
                    }
                  })
                  .catch((err) => console.error(err));
              }

              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              setBtnDis(false);
            });
        } else {
          await axiosInstance
            .post("/vozo/appointment?pid=" + patientid, encryptedData)
            .then(async (res) => {
              console.log("res data : ", res);

              setBtnDis(true);
              let apptAdded = res.data;
              if (
                MeetMode === "GMeet" &&
                videochck &&
                (statusid === "doc_confirmed" || statusid === "EMAIL")
              ) {
                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");
                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                    };

                    if (props.fromWaitList) {
                      await deleteWaitlistEntry(props.waitlistData.id);
                    }
                    axios
                      .get(
                        fileurl +
                        "/interface/customized/g-meet/index.php?action=create",
                        { params: article },
                      )
                      .then((res) => {})
                      .catch((err) => {
                        console.log("failed");
                      });
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }

              // setBtnDis(false);

              if (apptAdded === "out of both range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date & time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of time range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected time should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "out of date range") {
                setBtnDis(false);

                setModalAlerShow1(true);
                setModalMsg1(
                  "Selected Date should be within the provider availability range.",
                );
                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (apptAdded === "Provider Not Available") {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    `The provider is unavailable from ${inTime} to ${outTime} on ${
                      aptdate
                      ? moment(aptdate, dtFormat).format("MMMM DD, YYYY")
                      : ""
                    }. Select another time slot.`,
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded === "You Can't place the Appointment at this time"
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1("You Can't place the Appointment at this time");
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 4000);
                return;
              } else if (
                apptAdded.includes(
                  "You are only allowed to add telehealth appointments",
                )
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(apptAdded);
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("The provider is unavailable on these dates")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(
                    `The provider is unavailable from ${inTime} to ${outTime} on ${
                      aptdate
                      ? moment(aptdate, dtFormat).format("MMMM DD, YYYY")
                      : ""
                    }. Select another time slot.`,
                  );
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else if (
                apptAdded.includes("Appointment already scheduled at")
              ) {
                setBtnDis(false);

                setTimeout(() => {
                  setModalAlerShow1(true);
                  setModalMsg1(formatAppointmentOverlapMessage(apptAdded));
                }, 1);

                setTimeout(() => setModalAlerShow1(false), 3000);
                return;
              } else {
                await savePatientAppointmentReminderPreference(patientid);

                setBtnDis(true);

                props.savealertmsg(
                  "New Appointment Added Successfully",
                  true,
                  getWaitlistStep8AppointmentData(),
                );
                axiosInstance
                  .get("/vozo/getGMeet/data")
                  .then(async (response) => {
                    var res = Decrypt_Value(response.data, "vozo");

                    let article = {
                      start_time: res["start_time"],
                      end_time: res["end_time"],
                      attendees: res["attendees"],
                      start: res["pc_startTime"],
                      end: res["pc_endTime"],
                      eventdate: res["pc_eventDate"],
                      enddate: res["pc_endDate"],
                      eid: res["pc_eid"],
                      aid: res["pc_aid"],
                      pid: res["pc_pid"],
                      fac_id: res["pc_facility"],
                      name: res["pat_name"],
                      geventid: res["gevent"],
                      google_appt_sync: res["google_appt_sync"],
                      google_availability_sync: res["google_availability_sync"],
                      uid: userID,
                      tenant_id: DBHost,
                      outlook_appt_sync: res["outlook_appt_sync"],
                      outlook_availability_sync:
                        res["outlook_availability_sync"],
                      user_id: userID,
                    };
                    if (res["google_appt_sync"] === 1) {
                      axios
                        .get(
                          fileurl +
                          "/interface/customized/g-meet/index.php?action=create",
                          { params: article },
                        )
                        .then((res) => {
                          // setBtnDis(false);
                        })
                        .catch((err) => {
                          console.log("failed");
                        });
                    }
                    if (res["outlook_appt_sync"] === 1) {
                      axios.post(
                        fileurl +
                        "/interface/customized/outlook/create_event.php",
                        { params: article },
                      );
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  });
                if (statusid === "doc_confirmed") {
                  axiosInstance
                    .get("/vozo/tele/checkemailsent")
                    .then((response) => {
                      props.savealertmsg(response.data, true);
                      // props.onBookAppointment(startdatenew);
                      setTimeout(() => {
                        props.popuphide();
                        props.closepopup();
                        if (props.showStepSixIntro || returnPath) {
                          handleIntroGotIt();
                        }
                      }, 4000);
                    })
                    .catch((err) => {
                      console.error(err);
                      props.closepopup();
                    });
                } else {
                  if (props.showStepSixIntro || returnPath) {
                    props.savealertmsg(
                      "New Appointment Added Successfully",
                      true,
                    );
                    setTimeout(() => {
                      props.closepopup();
                      handleIntroGotIt();
                    }, 4000);
                  } else {
                    props.closepopup();
                  }
                }
                // props.setBookAgain(false);
              }
              setTimeout(() => props.popuphide(), 4000);

              props.FetchAppointments(
                props.provarray,
                props.facarray,
                props.appFromDate,
                props.apptoDate,
                props.pat_share,
                props.examroom,
                [],
                aptdate,
              );
              if (typeof props.onBookAppointment === "function") {
                props.onBookAppointment(aptdate);
              }
              // setBtnDis(false);
            })
            .catch((err) => {
              console.error(err);
              props.closepopup();
              setBtnDis(false);
            });
        }
      }
    }
    // setAlertMessage("Checkin Progress for Availity");

    await axiosInstance
      .get(
        "vozonew/patient/eligibleCheck?pid=" + patientid + "&instype=primary",
      )
      .then((response) => {
        // setTimeout(() => {
        //   if (response.data === "Login Failed") {
        //     props.savealertmsg("Cant Verified", true);
        //     setAlertMessage("Cant Verified");
        //   } else if (response.data === "The result array is empty.") {
        //     props.savealertmsg(
        //       "Please fill the necessary fields of Insurance and Demographics before checking eligibility",
        //       true
        //     );
        //     setAlertMessage(
        //       "Please fill the necessary fields of Insurance and Demographics before checking eligibility"
        //     );
        //   }
        // }, 1);
        //else {
        //   props.savealertmsg("Datas has been sent for Eligibility Verification..", true);
        //   setAlertMessage("Datas has been sent for Eligibility Verification..");
        // }
        // setTimeout(() => {
        //   setAlertMessage("");
        // }, 4000);
      })
      // .then(() => {
      //   setBtnDisabled(false);
      // })
      .catch((err) => {
        console.log(err.message);
        // setBtnDisabled(false);
      });
  };

  const checkFacility = (type) => {
    if (type === "classname") {
      return sourceoffice && sourceoffice.length === 0 ? "hide-label" : "";
    } else if (type === "spinner") {
      return sourceoffice &&
        officeid &&
        sourceoffice.length === 0 &&
        officeid.length > 0 ? (
        <Spinner
          animation="border"
          size="sm"
          variant="primary"
          className="add-spinner-sty"
        />
      ) : (
        ""
      );
    }
  };

  const onChange = (timeStandard, typeTime) => {
    if (Appttype === 2 && timeStandard === "Invalid date") {
      return;
    }

    if (timeStandard === "Invalid date" && typeTime === "inTime") {
      const currentDuration =
        Number(editing) > 0 ? Number(editing) : getBaseAppointmentDuration();

      const fallbackStartTime = moment(start).format("h:mm A");

      const fallbackEndTime = moment(fallbackStartTime, "h:mm A")
        .add(currentDuration, "minutes")
        .format("h:mm A");

      setInTime(fallbackStartTime);
      setOutTime(fallbackEndTime);
      setEditing(currentDuration);
      setDurationDisplayForCurrentFlow(currentDuration);
      setInTimeErr(false);
    } else if (timeStandard === "Invalid date" && typeTime === "outTime") {
      const currentDuration =
        Number(editing) > 0 ? Number(editing) : getBaseAppointmentDuration();

      const fallbackEndTime = moment(inTime, "h:mm A")
        .add(currentDuration, "minutes")
        .format("h:mm A");

      setOutTime(fallbackEndTime);
      setEditing(currentDuration);
      setDurationDisplayForCurrentFlow(currentDuration);
      setInTimeErr(false);
    } else {
      let time = timeStandard.split(":");
      let timeMin = time[1].split(" ");

      if (typeTime === "inTime") {
        const currentDuration =
          Number(editing) > 0 ? Number(editing) : getBaseAppointmentDuration();

        let intim = moment(timeStandard, "h:mm A").format("h:mm A");

        let out = moment(timeStandard, "h:mm A")
          .add(currentDuration, "minutes")
          .format("h:mm A");

        setEditing(currentDuration);
        setDurationDisplayForCurrentFlow(currentDuration);

        setInTimeErr(false);
        setOutTime(out);
        if (timeMin[1] === "AM") {
          if (time[0] === "12") {
            time[0] = Number(time[0]) - 12;
          }
          if (time[0] < Number(startTime)) {
            settimelimiterrorbox(true);
            return false;
          } else {
            settimelimiterrorbox(false);
          }
        } else {
          if (time[0] !== "12") {
            time[0] = Number(time[0]) + 12;
          }
          if (time[0] >= Number(endTime)) {
            settimelimiterrorbox(true);
            return false;
          } else {
            settimelimiterrorbox(false);
          }
        }
        setapttime(timeStandard);
      } else {
        let inTimeNew = inTime.split(":");
        let inTimeMin = inTimeNew[1].split(" ");
        if (inTimeNew[0] === "12" && inTimeMin[1] === "AM") {
          inTimeNew[0] = "00";
        }

        let out = moment(timeStandard, "h:mm A").format("h:mm A");
        if (inTimeMin[1] === "PM") {
          if (
            moment(out, "h:mm A").isBetween(
              moment("12:00 AM", "h:mm A"),
              moment("1:00 AM", "h:mm A"),
              null,
              "[)",
            )
          ) {
            out = moment(out, "h:mm A").add(1, "day");
          }
        }
        let duration = moment(out, "hh:mm a").diff(
          moment(inTime, "hh:mm a"),
          "minutes",
        );
        setEditing(duration);

        if (duration > 0) {
          if (changeTab === "3" || props.isGroupAppointment) {
            setGroupDuration(`${duration} mins`);
          } else {
            setIndividualDuration(`${duration} mins`);
          }
        }

        if (inTime === timeStandard) {
          setInTimeErr(true);
        }
        if (inTime !== timeStandard) {
          setInTimeErr(false);
        }
        if (timeMin[1] === "AM") {
          if (inTimeMin[1] === "PM" && Number(inTimeNew[0]) !== 12) {
            inTimeNew[0] = Number(inTimeNew[0]) + 12;
          }
          if (time[0] > Number(endTime) || inTimeNew[0] < Number(startTime)) {
            setInTimeErr(true);
            return false;
          } else if (
            (inTimeMin[1] === "PM" && time[0] !== "12") ||
            (Number(inTimeNew[0]) > Number(time[0]) &&
              Number(time[0]) !== 12) ||
            (inTimeNew[0] === time[0] &&
              inTimeMin[0] >= timeMin[0] &&
              time[0] !== "12") ||
            (time[0] === inTimeNew[0] &&
              timeMin[0] <= inTimeMin[0] &&
              time[0] !== "12")
          ) {
            setInTimeErr(true);
            return false;
          } else if (
            (Number(inTimeNew[0]) > time[0] && time[0] !== "12") ||
            (Number(inTimeNew[0]) === time[0] && inTimeMin[0] > timeMin[0])
          ) {
            setInTimeErr(true);
            return false;
          } else {
            setInTimeErr(false);
            settimelimiterrorbox(false);
          }
        } else {
          if (Number(time[0]) !== 12) {
            time[0] = Number(time[0]) + 12;
          }
          if (inTimeMin[1] === "PM" && Number(inTimeNew[0]) !== 12) {
            inTimeNew[0] = Number(inTimeNew[0]) + 12;
          }
          if (inTimeMin[1] === "AM" && Number(inTimeNew[0]) === 12) {
            inTimeNew[0] = 0;
          }
          if (Number(time[0]) === Number(endTime) && Number(timeMin[0]) > 0) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(time[0]) === Number(endTime) && Number(timeMin[0]) == 0) {
            settimelimiterrorbox(false);
          }
          if (Number(time[0]) > Number(endTime)) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(time[0]) < Number(endTime)) {
            settimelimiterrorbox(false);
          }
          if (Number(inTimeNew[0]) > Number(time[0])) {
            settimelimiterrorbox(true);
            return false;
          }
          if (Number(inTimeNew[0]) < Number(time[0])) {
            settimelimiterrorbox(false);
          }
          if (
            Number(inTimeNew[0]) === Number(time[0]) &&
            Number(inTimeMin[0]) > Number(timeMin[0])
          ) {
            setInTimeErr(true);
            return false;
          }
          if (
            Number(inTimeNew[0]) === Number(time[0]) &&
            Number(inTimeMin[0]) < Number(timeMin[0])
          ) {
            setInTimeErr(false);
          }
          if (Number(inTimeNew[0]) < Number(startTime)) {
            settimelimiterrorbox(true);
          }
        }
      }
    }
  };

  const fornormalapp = () => {
    return (
      <>
        <div className="for-get-started-popup-for-res-2">
          <div className="dis-fl-just">
            <div className="get-st-billinfo-head">Add Appointment</div>
          </div>
          <div className="get-st-client-content-3">
            Schedule your medical appointment with your preferred doctor.
          </div>

          <div className="get-st-box-with-rad-but-2">
            <>
              <Radio.Group value={1}>
                <Radio value={1}></Radio>
                <Radio value={2}></Radio>
              </Radio.Group>
            </>

            <Button
              className="save_active get-st-next-btn"
              variant="primary"
              onClick={() => forexploreteleapp()}
            >
              Next
            </Button>
          </div>
        </div>
      </>
    );
  };

  const forteleapp = () => {
    return (
      <>
        <div className="for-get-started-popup-for-res-2">
          <div className="dis-fl-just">
            <div className="get-st-billinfo-head">Add Tele Appointment</div>
          </div>
          <div className="get-st-client-content-3">
            Select the facility and schedule a video visit on your own.
          </div>

          <div className="get-st-box-with-rad-but-2">
            <div className="m-t-10">
              <Radio.Group value={2}>
                <Radio value={1}></Radio>
                <Radio value={2}></Radio>
              </Radio.Group>
            </div>

            <Button
              className="save_active get-st-next-btn"
              variant="primary"
              onClick={() => forexploreteleappdone()}
            >
              Done
            </Button>
          </div>
        </div>
      </>
    );
  };
  const handleGroupSearch = (value) => {
    if (!value) {
      fetchGroupPatients({ limit: 4 });
    } else {
      fetchGroupPatients({ search: value });
    }
  };

  const dataForBookAgain = async (data) => {
    if (data.walkin) {
      setwalkincheck(true);
    }
    if (Number(props.dataObj.pc_telehealth) === 1) {
      setAppttype(2);
    } else if (Number(props.dataObj.pc_telehealth) === 4) {
      setAppttype(4);
    } else {
      setAppttype(1);
    }
    // setApptty
    setofficeid(data.pc_facility);
    setprofileid(data.pc_catid);
    setproviderid(data.pc_aid);
    setpatientid(data.pc_pid);
    setSearchInputValue(props.dataObj.pname);
    getRoom(data.pc_facility);
    setRoomVal(data.pc_room);
    if (String(data.pc_telehealth) === "1") {
      setvideochck(true);
    }

    if (data.pc_telehealth === "1") {
      setvideochck(true);
    }
    if (!props.isAptProfileBookAgain) {
      setstatusid(data.pc_apptstatus);
    }
    setSpeciality(data.speciality);
    setEditing(15);
    let options;
    if (Number(props.dataObj.pc_telehealth) === 1) {
      options = teleprofile;
    } else {
      options = sourceprofile;
    }
    for (var j = 0; j < options.length; j++) {
      if (String(options[j].value) === String(data.pc_catid)) {
        if (options[j].value == data.pc_catid) {
          if (Number(props.dataObj.pc_telehealth) === 1) {
            setbillingid("");
          } else {
            if (
              options[j].pc_bill_profile !== "DEFAULT" &&
              (options[j].pc_bill_profile ?? []).length > 0
            ) {
              setbillingid(options[j].pc_bill_profile);
            } else {
              setbillingid("");
            }
          }
          var filter_pc_duration = options[j].pc_duration;
          if (options[j].pc_duration !== "" || options[j].pc_duration !== "0") {
            let outTimeVal = moment(inTime, "h:mm A").add(
              options[j].pc_duration,
              "minutes",
            );
            setOutTime(moment(outTimeVal).format("h:mm A"));
          }
        }
      }
    }

    setrepeatselectnew(data.pc_select1);
    setrepeatselect2new(data.pc_select2);
    if (data.pc_select2 === "1") {
      setWeek_and_every(true);
    }
    setrepValue(data.pc_repeat_select);
    setLastdateApp(moment(data.pc_endDate).format(dtFormat));

    setRepeatSelectMonth(data.pc_repeatselectmonth);
    setcustChk(parseInt(data.pc_on_after_never));

    let d1 = moment(data.pc_startTime, "h:mm A");
    let d2 = moment(data.pc_endTime, "h:mm A");

    setInTime(d1.format("h:mm A"));

    setOutTime(d2.format("h:mm A"));

    setapttime(d1.format("h:mm A"));
    setReason(data.reason_for_appointment);

    if (data.pc_recurrtype > "0") {
      setchecking1(true);

      if (data.pc_recurrtype === "1" || data.pc_recurrtype === "2") {
        setrepeatselectnew(data.pc_recurrspec.event_repeat_freq);

        setrepeatselect2new(data.pc_recurrspec.event_repeat_freq_type);
      } else if (data.pc_recurrtype === "3") {
        let temp = data.pc_recurrspec.event_repeat_freq.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      } else if (data.pc_recurrtype === "4") {
        let temp = data.pc_recurrspec.event_repeat_freq_by_day.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      } else if (data.pc_recurrtype === "5") {
        let temp = data.pc_recurrspec.event_repeat_freq_by_day.split(",");
        var temp_a = [];
        for (let i = 0; i < temp.length; i++) {
          let text = Number(temp[i]);
          temp_a.push(text);
        }

        setweekday(temp_a);
      }
    } else {
      setchecking1(false);
    }
    if (props.type === "book again" && data.pc_pid) {
      await fetchPatientDefaultContact(data.pc_pid, false, true);
    }
  };

  const WeekdayChange = (val) => {
    const hasOnlyEmptyStrings =
      val.length > 0 && val.every((item) => item === "");
    if (hasOnlyEmptyStrings) {
      setweekday("");
    } else {
      setweekday(val);
    }
    setselectdayError(false);
  };

  const forexploreteleapp = () => {
    localStorage.removeItem("normalapppopup");
    setnormalappointment(false);
    setforteleornor(2);
    setteleappointment(true);
  };

  const forexploreteleappdone = () => {
    setforteleornor(1);
    setteleappointment(false);
  };
  const handleDropDownSelect = (event, data) => {
    const options = videochck ? teleprofile : sourceprofile;

    let profileDuration = 0;

    for (var j = 0; j < options.length; j++) {
      if (options[j].value.includes(data.value)) {
        if (options[j].value == data.value) {
          if (
            options[j].pc_bill_profile !== "DEFAULT" &&
            (options[j].pc_bill_profile ?? []).length > 0
          ) {
            setbillingid(options[j].pc_bill_profile);
          } else {
            setbillingid("");
          }

          profileDuration = Number(options[j].pc_duration || 0);
          break;
        }
      }
    }

    const selectedServiceCodes =
      changeTab === "3" || props.isGroupAppointment
        ? groupServiceCode
        : individualServiceCode;

    const highestServiceCodeDuration =
      getHighestSelectedServiceCodeDuration(selectedServiceCodes);
    const durationToApply = Math.max(
      profileDuration > 0 ? profileDuration : 15,
      highestServiceCodeDuration,
    );

    setDurationDisplayForCurrentFlow(durationToApply);
    setEditing(durationToApply);

    if (inTime) {
      updateEndTimeFromDuration(durationToApply);
    }

    settimelimiterrorbox(false);
    setInTimeErr(false);
    setprofileid(data.value);
    setprofileError(false);
  };

  const getRoom = async (id) => {
    await axiosInstance
      .get("/vozonew/facilityRoom?id=" + id)
      .then((res) => {
        let decode = Decrypt_Value(res.data, "vozo");
        setRoomList(decode.examRoom);
      })
      .catch((err) => {});
  };

  var i = 0;
  const setRoomList = (val) => {
    setSourceRoom([]);

    i = parseInt(val);
    for (let j = 1; j <= i; j++) {
      let obj = {
        id: "" + j,
        text: "Exam Room " + j,
        title: "Exam Room " + j,
        value: "" + j,
      };
      setSourceRoom((item) => [...item, obj]);
    }
    // setRoomVal("");
  };

  const handleDropDownSelectOffice = (event, data) => {
    setproviderid("");
    setSpeciality("");
    setofficeid(data.value);
    setofficeError(false);
    getRoom(data.value);
  };
  const isSuffixEnabledSite = [
    "laibonhealthllc",
    // "default",
    "laibonhealth",
  ].includes(DBHost);
  const changeSpeciality = (data, from = "") => {
    if (from === "" && !isInitialWaitlistLoad) {
      setproviderid("");
    }
    setSpeciality(data);
    setSpecialError(false);
    setInTimeErr(false);
  };

  const handleDropDownSelectStatus = (event, data) => {
    setstatusid(data.value);
    setstatusError(false);
  };

  const setSpecialityByusers = (value) => {
    if (value === undefined || value === null || value === "") {
      return;
    }

    axiosInstance
      .get("/vozo/getspeciality/users?id=" + value)
      .then((res) => {
        const temp_role_spec_user = Decrypt_Value(res.data, "vozo");
        const providerSpeciality = temp_role_spec_user?.specialty;

        if (providerSpeciality) {
          changeSpeciality(providerSpeciality, "fromProv");
        }
      })
      .catch(() => {});
  };

  const handleDropDownSelectProvider = (event, data) => {
    if (provError) {
      setprovError(false);
    }
    setproviderid(data.value);
    setprovError(false);
    setInTimeErr(false);
    setSpecialityByusers(data.value);
  };

  // const handleBillingFacility = (event, data) => {
  //   setBillFacilityID(data.value);
  //   setBillFacilityError(false);
  // };

  const handleDropDownSelectPatient = (event, data) => {
    // setsearch1(data.title);
    setSearchInputValue(data.title);

    if (!data.email || data.email.trim() === "" || data.email === undefined) {
      setEmptyEmailWarning(true);
    } else {
      setEmptyEmailWarning(false);
    }

    setpatientid(data.value);
    setpatError(false);
    if (accountType > "0" || (accountType === "0" && trial)) {
      axiosInstance
        .get("/vozo/getpatient/flags?pid=" + data.value)
        .then((res) => {
          let temp_role_pat_flag = Decrypt_Value(res.data, "vozo");
          setPatFlag(temp_role_pat_flag);
        })
        .catch(() => {
          setPatFlag([]);
        });
    }
  };

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  // const walkinclick = (e) => {
  //   e.preventDefault();
  //   setvideochck(false);
  //   setwalkincheck(!walkincheck);
  // };

  const walkinclick = (e) => {
    e.preventDefault();

    if (allowAppt === 2) {
      setAppttype(2);
      setvideochck(true);
    } else {
      setvideochck(false);
    }

    setwalkincheck(!walkincheck);
  };
  // const onChangeRadio = (e) => {
  //   if (e === 2) {
  //     e = { target: { value: 2 } };
  //   }

  //   setAppttype(e.target.value);
  //   if (e.target.value == 2) {
  //     setwalkincheck(false);
  //     setaptdate(moment(start).format(dtFormat));

  //     let t1 = inTime.split(" ");
  //     let t2 = outTime.split(" ");

  //     let from = disabledFromTimes(t1[0], t1[1], e.target.value);
  //     let to = disabledToTime(t2[0], t2[1], fromId, e.target.value);

  //     if (!from) {
  //       let intime = moment(roundedDate);
  //       let now = moment();
  //       let intimee = moment(roundedDate).format("h:mm A");

  //       setaptdate(moment(start).format(dtFormat));

  //       setInTime(intimee);

  //       let out = moment(intimee, "h:mm A").add(15, "minutes").format("h:mm A");
  //       setOutTime(out);
  //       let dur = moment(out, "hh:mm a").diff(
  //         moment(intimee, "hh:mm a"),
  //         "minutes"
  //       );
  //       setEditing(dur);

  //       setapttime(intimee);

  //       if (intime.isAfter(now)) {
  //         if (props.view === "month") {
  //           let intime = moment(props.startTime1, "H").format("h:mm A");
  //           setInTime(intime);

  //           let outtime = moment(intime, "h:mm A")
  //             .add(15, "minutes")
  //             .format("h:mm A");
  //           setOutTime(outtime);

  //           let dur = moment(outtime, "h:mm A").diff(
  //             moment(intime, "h:mm A"),
  //             "minutes"
  //           );
  //           setEditing(dur);
  //         } else {
  //           setaptdate(moment(start).format(dtFormat));

  //           let intime = moment(roundedDate).format("h:mm A");
  //           setInTime(intime);

  //           let out = moment(intime, "h:mm A")
  //             .add(15, "minutes")
  //             .format("h:mm A");
  //           setOutTime(out);
  //           let dur = moment(out, "hh:mm a").diff(
  //             moment(intime, "hh:mm a"),
  //             "minutes"
  //           );
  //           setEditing("");
  //         }
  //       }
  //     } else {
  //       let now = moment(roundedDate);

  //       let intime = now.format("h:mm A");

  //       let checktime = moment(aptdate, dtFormatsec);

  //       if (checktime.isBefore(now.format(dtFormat))) {
  //         // setInTime("");
  //         // setOutTime("");
  //         setEditing("");
  //       } else {
  //         let out = moment(
  //           moment(now.format("h:mm A"), "h:mm A").add(15, "minutes")
  //         ).format("h:mm A");

  //         setInTime(intime);
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(now, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(intime);
  //       }
  //     }
  //     setstatusid("");
  //     setbillingid("");
  //     setprofileid("");
  //   } else if (e.target.value == 1 || e.target.value == 3) {
  //     setwalkincheck(false);

  //     let now = moment();

  //     let intime = moment(start).format("h:mm A");
  //     setInTime(moment(start).format("h:mm A"));
  //     let out = moment(start).add(15, "minutes").format("h:mm A");
  //     setOutTime(out);
  //     let checktime = moment(aptdate, dtFormatsec);
  //     if (checktime.isBefore(now.format(dtFormat))) {
  //       // setInTime("");
  //       // setOutTime("");
  //       setEditing("");
  //     } else {
  //       if (props.view === "month") {
  //         let inmonth = moment(props.startTime1, "H").format("h:mm A");
  //         setInTime(moment(props.startTime1, "H").format("h:mm A"));

  //         let out = moment(
  //           moment(props.startTime1, "H").add(15, "minutes")
  //         ).format("h:mm A");
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(inmonth, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(inmonth);
  //       } else {
  //         let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
  //           "h:mm A"
  //         );
  //         setInTime(intime);
  //         setOutTime(out);
  //         let dur = moment(out, "hh:mm a").diff(
  //           moment(now, "hh:mm a"),
  //           "minutes"
  //         );
  //         setEditing(dur);
  //         setapttime(intime);
  //       }
  //     }
  //     let ofc_firstId = "";
  //     if (props.officeId) {
  //       const idArray = props.officeId.split(",");
  //       ofc_firstId = idArray[0];
  //     }
  //     setofficeid(ofc_firstId);
  //     setprofileid("");
  //     setstatusid("");
  //     setbillingid("");
  //   }
  //   // }
  // };

  // const checkvideovisit = () => {
  //   const currentTime = moment(start);
  //   if ((accountType === "1" && teleFlag === "0") || accountType === "-1") {
  //     setvideochck(false);
  //   } else {
  //     // if (Appttype !== 3) {
  //     //   setproviderid("");
  //     // }
  //     setvideochck(true);
  //     if (props.view === "month") {
  //       let intime = moment(props.startTime1, "H").format("h:mm A");
  //       setInTime(intime);

  //       let outtime = moment(intime, "h:mm A")
  //         .add(15, "minutes")
  //         .format("h:mm A");
  //       setOutTime(outtime);

  //       let dur = moment(outtime, "h:mm A").diff(
  //         moment(intime, "h:mm A"),
  //         "minutes"
  //       );
  //       setEditing(dur);
  //     } else {
  //       setInTime(currentTime.format("h:mm A"));
  //       setapttime(currentTime.format("h:mm A"));
  //       setOutTime(moment(currentTime.add(15, "minutes")).format("h:mm A"));
  //     }
  //   }
  // };

  const onChangeRadio = (e) => {
    if (e === 2) {
      e = { target: { value: 2 } };
    }

    setAppttype(e.target.value);

    if (e.target.value == 2) {
      // Telehealth
      setwalkincheck(false);
      setaptdate(moment(start).format(dtFormat));

      let t1 = inTime.split(" ");
      let t2 = outTime.split(" ");

      let from = disabledFromTimes(t1[0], t1[1], e.target.value);
      let to = disabledToTime(t2[0], t2[1], fromId, e.target.value);

      if (!from) {
        let intime = moment(roundedDate);
        let now = moment();
        let intimee = moment(roundedDate).format("h:mm A");

        setaptdate(moment(start).format(dtFormat));

        setInTime(intimee);

        let out = moment(intimee, "h:mm A").add(15, "minutes").format("h:mm A");
        setOutTime(out);
        let dur = moment(out, "hh:mm a").diff(
          moment(intimee, "hh:mm a"),
          "minutes",
        );
        setEditing(dur);

        setapttime(intimee);

        if (intime.isAfter(now)) {
          if (props.view === "month") {
            let intime = moment(props.startTime1, "H").format("h:mm A");
            setInTime(intime);

            let outtime = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(outtime);

            let dur = moment(outtime, "h:mm A").diff(
              moment(intime, "h:mm A"),
              "minutes",
            );
            setEditing(dur);
          } else {
            setaptdate(moment(start).format(dtFormat));

            let intime = moment(roundedDate).format("h:mm A");
            setInTime(intime);

            let out = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(out);
            let dur = moment(out, "hh:mm a").diff(
              moment(intime, "hh:mm a"),
              "minutes",
            );
            setEditing("");
          }
        }
      } else {
        let now = moment(roundedDate);

        let intime = now.format("h:mm A");

        let checktime = moment(aptdate, dtFormatsec);

        if (checktime.isBefore(now.format(dtFormat))) {
          setEditing("");
        } else {
          let out = moment(
            moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
          ).format("h:mm A");

          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }
      setstatusid("");
      setbillingid("");
      setprofileid("");
    } else if (e.target.value == 1 || e.target.value == 4) {
      // Regular Appointment or Phone Call
      setwalkincheck(false);

      let now = moment();

      let intime = moment(start).format("h:mm A");
      setInTime(moment(start).format("h:mm A"));
      let out = moment(start).add(15, "minutes").format("h:mm A");
      setOutTime(out);
      let checktime = moment(aptdate, dtFormatsec);
      if (checktime.isBefore(now.format(dtFormat))) {
        setEditing("");
      } else {
        if (props.view === "month") {
          let inmonth = moment(props.startTime1, "H").format("h:mm A");
          setInTime(moment(props.startTime1, "H").format("h:mm A"));

          let out = moment(
            moment(props.startTime1, "H").add(15, "minutes"),
          ).format("h:mm A");
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(inmonth, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(inmonth);
        } else {
          let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          );
          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }
      let ofc_firstId = "";
      if (props.officeId) {
        const idArray = props.officeId.split(",");
        ofc_firstId = idArray[0];
      }
      setofficeid(ofc_firstId);
      setprofileid("");
      setstatusid("");
      setbillingid("");
    } else if (e.target.value == 3) {
      if (allowAppt === 2) {
        setAppttype(2);
        setvideochck(true);
      } else {
        setvideochck(false);
      }

      setwalkincheck(true);

      let now = moment();

      let intime = moment(start).format("h:mm A");
      setInTime(moment(start).format("h:mm A"));
      let out = moment(start).add(15, "minutes").format("h:mm A");
      setOutTime(out);
      let checktime = moment(aptdate, dtFormatsec);

      if (checktime.isBefore(now.format(dtFormat))) {
        setEditing("");
      } else {
        if (props.view === "month") {
          let inmonth = moment(props.startTime1, "H").format("h:mm A");
          setInTime(moment(props.startTime1, "H").format("h:mm A"));

          let out = moment(
            moment(props.startTime1, "H").add(15, "minutes"),
          ).format("h:mm A");
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(inmonth, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(inmonth);
        } else {
          let out = moment(moment(intime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          );
          setInTime(intime);
          setOutTime(out);
          let dur = moment(out, "hh:mm a").diff(
            moment(now, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
          setapttime(intime);
        }
      }

      let ofc_firstId = "";
      if (props.officeId) {
        const idArray = props.officeId.split(",");
        ofc_firstId = idArray[0];
      }
      setofficeid(ofc_firstId);
      setprofileid("");
      setstatusid("");
      setbillingid("");
    }
  };
  const checkvideovisit = () => {
    const currentTime = moment(start);

    if ((accountType === "1" && teleFlag === "0") || accountType === "-1") {
      setvideochck(false);
    } else {
      setvideochck(true);

      if (!walkincheck) {
        setproviderid("");
      }

      if (walkincheck && allowAppt === 2) {
        return;
      }

      if (props.view === "month") {
        let intime = moment(props.startTime1, "H").format("h:mm A");
        setInTime(intime);

        let outtime = moment(intime, "h:mm A")
          .add(15, "minutes")
          .format("h:mm A");
        setOutTime(outtime);

        let dur = moment(outtime, "h:mm A").diff(
          moment(intime, "h:mm A"),
          "minutes",
        );
        setEditing(dur);
      } else {
        setInTime(currentTime.format("h:mm A"));
        setapttime(currentTime.format("h:mm A"));
        setOutTime(moment(currentTime.add(15, "minutes")).format("h:mm A"));
      }
    }
  };
  // const checkapt = () => {
  //   // if (Appttype !== 3) {
  //   //   setproviderid("");
  //   // }
  //   setvideochck(false);
  // };

  const checkapt = () => {
    if (walkincheck && allowAppt === 2) {
      return;
    }

    setvideochck(false);
  };

  const handleRoomVal = (data) => {
    setRoomVal(data);
    setexamroomError(false);
  };

  const handleSelect2 = (id, val) => {
    // setOccurence("1");
    if (id === "new-app-select1") {
      setrepeatselectnew(val);
    } else {
      setweekday("");
      if (val === "1") {
        setrepeatselect2new("1");
        if (
          repeatselectnew === "4" ||
          repeatselectnew === "5" ||
          repeatselectnew === "6"
        ) {
          setrepeatselectnew("");
        }

        setdayswise(true);
        setswict_check(true);

        setWeek_and_every(true);
      } else if (val === "2") {
        setrepeatselect2new("2");
        if (repeatselectnew === "5" || repeatselectnew === "6") {
          setrepeatselectnew("");
        }
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      } else if (val === "3") {
        setrepeatselect2new("3");
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      } else {
        setswict_check(false);

        setdayswise(false);
        setWeek_and_every(false);
      }
      setrepeatselect2new(val);
    }
  };

  const getDatas = async () => {
    let Data_frsh_doc =
      "authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&group_id=" +
      group_id;
    let Data_enc_doc = Encrypt_Value(Data_frsh_doc, "vozo");
    await axiosInstance
      .get("/vozonew/facility?search=" + Data_enc_doc)
      .then((response) => {
        let decryptval = Decrypt_Value(response.data, "vozo");
        setSourceoffice(decryptval);
      })
      .catch((err) => console.error(err));
    if (!props.pid) {
      let alle_data =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id +
        "&activepatlist=" +
        1;

      let alle_data_enc = Encrypt_Value(alle_data, "vozo");

      await axiosInstance
        .get("/vozo/patientsearch?search=" + alle_data_enc)
        .then((response) => {
          let temp_role = Decrypt_Value(response.data, "vozo");
          setSource(temp_role);
        })
        .catch(() => {
          setSource([]);
        });
    }

    await axiosInstance
      .get("/vozo/appstatus/category")
      .then((response) => {
        let temp_role_cat = Decrypt_Value(response.data, "vozo");
        setSourcestatus(temp_role_cat[0]);
        setSourcestatustele(temp_role_cat[1]);
        setSourceprofile(temp_role_cat[2]);
        setteleprofile(temp_role_cat[2]);
        if (!props.fromWaitList) {
          setSpinnerVal(false);
        }
      })
      .catch((err) => console.error(err));

    // await axiosInstance
    //   .get("/vozonew/facility/telehealth")
    //   .then((response) => {
    //     let temp_role_tele_cat = Decrypt_Value(response.data, "vozo");
    //     settelehealth(temp_role_tele_cat);
    //   })
    //   .catch((err) => console.error(err));

    if (props.pid !== undefined) {
      setpatientid(props.pid);

      await fetchPatientDefaultContact(props.pid, false, true);
    }
    if (props.pid !== undefined) {
      await axiosInstance
        .get("/vozonew/patient?pid=" + props.pid)
        .then((response) => {
          let temp_role_pat_flag = Decrypt_Value(response.data, "vozo");

          const searchFname = temp_role_pat_flag.patient_name.trim();

          let alle_data =
            "limit=40&fname=" +
            encodeURIComponent(searchFname.toLowerCase()) +
            "&authorized=" +
            authorized +
            "&main_pro=" +
            main_pro +
            "&userID=" +
            userID +
            "&pat_share=" +
            storedNames.pat_share +
            "&owner_id=" +
            owner_id +
            "&activepatlist=" +
            1;

          let alle_data_enc = Encrypt_Value(alle_data, "vozo");

          axiosInstance
            .get("/vozo/patientsearch?search=" + alle_data_enc)
            .then((response) => {
              let temp_role = Decrypt_Value(response.data, "vozo");

              const findName = temp_role.find(
                (item) => Number(item.pid) === Number(props.pid),
              );

              // setsearch1(findName.name);
              setSearchInputValue(findName.name);
              setSource(temp_role);
            })
            .catch(() => {
              setSource([]);
              // setsearch1("");
              setSearchInputValue("");
            });

          setpatientid(temp_role_pat_flag.pid);
        })
        .catch((err) => console.error(err));

      await axiosInstance
        .get("/vozo/getpatient/flags?pid=" + props.pid)
        .then((res) => {
          let temp_role_pat_flag = Decrypt_Value(res.data, "vozo");
          setPatFlag(temp_role_pat_flag);
        })
        .catch(() => {
          setPatFlag([]);
        });
    }
  };

  const handlecloseUpgrade = () => setUpgrade(false);

  const modalhide = () => {
    setModalAlerShow1(false);
    setModalMsg1("");
  };

  const generateDateArray = (startDate, endDate) => {
    const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
    const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay); // month is 0-based
    const end = new Date(endYear, endMonth - 1, endDay);

    const dateArray = [];

    while (start <= end) {
      const year = start.getFullYear();
      const month = String(start.getMonth() + 1).padStart(2, "0");
      const day = String(start.getDate()).padStart(2, "0");

      dateArray.push(`${year}-${month}-${day}`);
      start.setDate(start.getDate() + 1);
    }

    return dateArray;
  };

  const generateSpecificWeekdayArray = (startDate, endDate, weekdays) => {
    const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
    const [endYear, endMonth, endDay] = endDate.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);

    const dateArray = [];
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    weekdays = weekdays.map((day) => (parseInt(day, 10) - 1).toString());

    while (start <= end) {
      const dayIndex = start.getDay(); // 0 = Sunday, 1 = Monday, ...

      if (weekdays.includes(dayIndex.toString())) {
        const year = start.getFullYear();
        const month = String(start.getMonth() + 1).padStart(2, "0");
        const day = String(start.getDate()).padStart(2, "0");

        dateArray.push(`${year}-${month}-${day}`);
      }

      start.setDate(start.getDate() + 1);
    }

    return dateArray;
  };

  const handleFromTime = () => {
    if (fromShow === false) {
      setFromShow(true);
      setToShow(false);
      setTempOpen(true);
    } else {
      setFromShow(false);
    }
  };
  const handleToTime = () => {
    if (toShow === false) {
      setToShow(true);
      setFromShow(false);
      setTempOpen(true);
    } else {
      setToShow(false);
    }
  };
  const handleFromButton = (e, index) => {
    e.preventDefault();
    if (fromShow === true || toShow === true) {
      setFromShow(false);
      setToShow(false);
    }
  };
  const handleToButton = (e, index) => {
    e.preventDefault();
    if (fromShow === true || toShow === true) {
      setFromShow(false);
      setToShow(false);
    }
  };

  window.onclick = function (e) {
    if (fromShow && tempOpen === false) {
      setFromShow(false);
    } else if (toShow && tempOpen === false) {
      setToShow(false);
    }
  };
  var regexFirstNum = /^[a-zA-Z].*/;

  const handleAddPatient = (e) => {
    if (storedNames.demo) {
      setTemShow(false);
      setShow(true);
    }
  };

  const deleteWaitlistEntry = async (waitlistId) => {
    try {
      await axiosInstance.delete(
        `/vozo/appointment_waitlist/delete?id=${waitlistId}`,
      );
    } catch (error) {
      console.error("Error deleting waitlist entry:", error);
    }
  };

  const handleSubmit = (e) => {
    // setBtnDis(true);
    if (changeTab === "1" || changeTab === "3") {
      buttonClickActions(e);
    } else {
      if (!storedNames.setProviderAvailability_viewOnly) {
        dispatch(SetPatientBool(true));
      } else {
        alert("You only have view-only access.");
        // setBtnDis(false);
      }
    }

    // setTimeout(() => setBtnDis(false), 500);
  };

  const populateAppointmentData = (appointmentData) => {
    if (!appointmentData) return;

    try {
      if (appointmentData.patient_id) {
        setpatientid(appointmentData.patient_id);
        setpatError(false);
        fetchPatientDefaultContact(appointmentData.patient_id, false, true);
      }

      if (appointmentData.patient_name) {
        setSearchInputValue(appointmentData.patient_name);
      }

      if (appointmentData.appt_type) {
        const apptTypeNum = Number(appointmentData.appt_type);
        if (apptTypeNum === 1) {
          setAppttype(1);
          setvideochck(false);
          setwalkincheck(true);
        } else if (apptTypeNum === 2) {
          setAppttype(2);
          setvideochck(true);
          setwalkincheck(false);
        } else if (apptTypeNum === 4) {
          setAppttype(4);
          setvideochck(false);
          setwalkincheck(false);
        } else {
          setAppttype(1);
          setvideochck(false);
          setwalkincheck(false);
        }
      }

      if (appointmentData.facility_id) {
        const facilityId = String(appointmentData.facility_id);
        setofficeid(facilityId);
        setofficeError(false);
        getRoom(facilityId);
      }

      if (appointmentData.provider_id) {
        const providerId = String(appointmentData.provider_id);

        setproviderid(providerId);
        setprovError(false);
      }

      if (appointmentData.appointment_date) {
        setaptdate(moment(appointmentData.appointment_date).format(dtFormat));
        setDateErr(false);
      }

      if (appointmentData.start_time) {
        let formattedStartTime;
        if (
          appointmentData.start_time.includes("AM") ||
          appointmentData.start_time.includes("PM")
        ) {
          formattedStartTime = moment(
            appointmentData.start_time,
            "h:mm A",
          ).format("h:mm A");
        } else {
          formattedStartTime = moment(
            appointmentData.start_time,
            "HH:mm:ss",
          ).format("h:mm A");
        }
        setInTime(formattedStartTime);
        setapttime(formattedStartTime);
        setInTimeErr(false);
      }

      if (appointmentData.end_time) {
        let formattedEndTime;
        // Check if time is in HH:mm:ss format or h:mm A format
        if (
          appointmentData.end_time.includes("AM") ||
          appointmentData.end_time.includes("PM")
        ) {
          formattedEndTime = moment(appointmentData.end_time, "h:mm A").format(
            "h:mm A",
          );
        } else {
          formattedEndTime = moment(
            appointmentData.end_time,
            "HH:mm:ss",
          ).format("h:mm A");
        }
        setOutTime(formattedEndTime);
      }

      // Calculate duration
      if (appointmentData.start_time && appointmentData.end_time) {
        let start, end;
        if (
          appointmentData.start_time.includes("AM") ||
          appointmentData.start_time.includes("PM")
        ) {
          start = moment(appointmentData.start_time, "h:mm A");
          end = moment(appointmentData.end_time, "h:mm A");
        } else {
          start = moment(appointmentData.start_time, "HH:mm:ss");
          end = moment(appointmentData.end_time, "HH:mm:ss");
        }
        const duration = end.diff(start, "minutes");
        setEditing(duration);
      }

      // Set speciality
      if (appointmentData.speciality) {
        setSpeciality(appointmentData.speciality);
        setSpecialError(false);
      }

      // Set profile if available - Convert to string and verify it exists
      if (appointmentData.profile_id) {
        const profileId = String(appointmentData.profile_id);

        // Check if the profile exists in the available options
        const profileExists = sourceprofile.some(
          (p) => String(p.value) === profileId,
        );

        if (profileExists) {
          setprofileid(profileId);
          setprofileError(false);

          // Set billing ID based on profile
          const selectedProfile = sourceprofile.find(
            (p) => String(p.value) === profileId,
          );
          if (selectedProfile) {
            if (
              selectedProfile.pc_bill_profile !== "DEFAULT" &&
              (selectedProfile.pc_bill_profile ?? []).length > 0
            ) {
              setbillingid(selectedProfile.pc_bill_profile);
            } else {
              setbillingid("");
            }

            // Set duration if available
            if (
              selectedProfile.pc_duration &&
              selectedProfile.pc_duration !== "0"
            ) {
              const duration = end.diff(start, "minutes");
              setEditing(selectedProfile.pc_duration);
              let outTimeVal = moment(appointmentData.start_time, "h:mm A").add(
                duration,
                "minutes",
              );
              setOutTime(moment(outTimeVal).format("h:mm A"));
            }
          }
        } else {
          console.warn("Profile ID not found in available options:", profileId);
          // Don't set the profile if it doesn't exist in options
          setprofileid("");
        }
      }

      // Set reason if available
      if (appointmentData.reason) {
        setReason(appointmentData.reason);
      }

      // Reset recurrence settings (waitlist appointments are typically one-time)
      setchecking1(false);
      setrepeatselectnew("");
      setrepeatselect2new("");
      setWeek_and_every(false);
      setrepValue("Does not repeat");
      setweekday([]);
    } catch (error) {
      console.error("Error populating appointment form:", error);
    }
  };

  // ------------------------------ Functions End--------------------------------------------------- //

  // ------------------------------ useEffect Start--------------------------------------------------- //
  useEffect(() => {
    if (aptdate !== "" && repvalue !== "Week" && repvalue !== "Daily") {
      const formattedApptDate = moment(aptdate, dtFormat);

      setLastdateApp(formattedApptDate.format(dtFormat));
    }
  }, [aptdate]);

  useEffect(() => {
    const updateZoom = () => {
      const zoom = window.devicePixelRatio;
      if (zoom >= 1.25) {
        setPopupWidth("320px");
      } else {
        setPopupWidth("370px");
      }
    };

    updateZoom();

    window.addEventListener("resize", updateZoom);
    return () => window.removeEventListener("resize", updateZoom);
  }, []);

  useEffect(() => {
    if (props.defaultTele === true) {
      onChangeRadio(2);
      checkvideovisit();
      props.handlesetDefaultTele();
    }
  }, [props.defaultTele]);

  useEffect(() => {
    if (props.ApptTab === "2") {
      if (props.start.Id !== undefined && props.start.Id !== "0") {
        const pc_eventDateW = props.start.pc_eventDate;
        const pc_endDateW = props.start.pc_endDate;

        const id = props.start.Id;
        const recType = props.start.pc_recurrtype;
        let repDates;
        if (recType !== "0") {
          //for weekly START
          if (props.start.customDate && props.start.customDate.length > 0) {
            const weekdays = props.start.customDate; // Monday, Wednesday, Friday (1-based mapping)

            const resultDates = generateSpecificWeekdayArray(
              pc_eventDateW,
              pc_endDateW,
              weekdays,
            );
            repDates = resultDates;
          } else {
            const Fudates = generateDateArray(pc_eventDateW, pc_endDateW);
            repDates = Fudates;
          }
        }

        axiosInstance
          .get("/vozo/getappointmenttemplate?id=" + props.start.Id)
          .then((response) => {
            let temp_role = Decrypt_Value(response.data, "vozo");

            var currdate = moment().format("YYYY-MM-DD");
            const futureDates =
              repDates && repDates.length > 0
                ? repDates.filter((date) =>
                  moment(date).isSameOrAfter(currdate),
                )
                : [];

            temp_role.futureDates = futureDates[0];
            temp_role.futureDatesall = futureDates;
            temp_role.repDates = repDates;
            temp_role.recType = recType;

            setSingleRow(temp_role);
          });
      } else {
        setSingleRow([]);
      }
      props.handlesetDefaultTele();
    }
  }, [props.ApptTab]);

  useEffect(() => {
    fetchGroupPatients({ limit: 4 });

    axiosInstance
      .get("/vozo/telehealth/getPlatform")
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");
        setTelehealthplatform(decodingResponse);
      })
      .catch((err) => {
        setTelehealthplatform("zoom");
      });
  }, []);
  useEffect(() => {
    const getWeeklyData = async () => {
      await axiosInstance
        .get("/vozo/calendarsettingdata")
        .then((response) => {
          let decodingResponse = Decrypt_Value(response.data, "vozo");
          setWeeklyDisable(decodingResponse[1].gl_value);
        })
        .catch(() => {});
    };

    const getAvailability = async () => {
      await axiosInstance
        .get("/vozo/settingdocumentdataAvailability")
        .then((response) => {
          let temp_role_setng_doc_data = Decrypt_Value(response.data, "vozo");

          setswitchvalue(
            temp_role_setng_doc_data[0].gl_value === "1" ? true : false,
          );
        })
        .catch((err) => console.error(err));
    };
    getAvailability();
    getWeeklyData();
  }, []);

  useEffect(() => {
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    if (providerid !== "" && providerid !== null && providerid !== undefined) {
      axiosInstance.get("/sprovider?uid=" + providerid).then((response) => {
        const data = Decrypt_Value(response.data, "vozo");
        setAllowAppt(Number(data.appt_type));
        if (Number(data.appt_type) === 3 && Appttype !== 2 && Appttype !== 4) {
          setofficeid(ofc_firstId);
          setAppttype(1);
          setvideochck(false);
          // setprofileid("");
          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
          }
          // setbillingid("");
          let dur = moment(outTime, "hh:mm a").diff(
            moment(inTime, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
        } else if (Number(data.appt_type) === 2) {
          setAppttype(2);
          let t1 = inTime.split(" ");
          let t2 = outTime.split(" ");

          let from = disabledFromTimes(t1[0], t1[1], 2);

          if (!from) {
            let intime = moment(start);
            let now = moment();

            if (intime.isAfter(now)) {
              setInTime(moment(start).format("h:mm A"));
              let intime = moment(start).format("h:mm A");
              let out = moment(
                moment(start, "h:mm A").add(15, "minutes"),
              ).format("h:mm A");
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(intime, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
            }
          } else {
            let now = moment(start);

            let intime = now.format("h:mm A");

            let checktime = moment(aptdate, dtFormatsec);

            if (checktime.isBefore(now.format(dtFormat))) {
              // setOutTime("");
              setEditing("");
            } else {
              let out = moment(
                moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
              ).format("h:mm A");

              setInTime(intime);
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(now, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
              setapttime(intime);
            }
          }

          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
            setprofileid("");
          }
          setvideochck(true);
        } else if (Number(data.appt_type) === 1) {
          setofficeid(ofc_firstId);
          setAppttype(1);
          setvideochck(false);
          // setprofileid("");
          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
            setprofileid("");
          }
        }
      });
    }
  }, [officeid, teleprofile]);
  useEffect(() => {
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    if (providerid !== "" && providerid !== null && providerid !== undefined) {
      axiosInstance.get("/sprovider?uid=" + providerid).then((response) => {
        const data = Decrypt_Value(response.data, "vozo");
        setAllowAppt(Number(data.appt_type));
        if (Number(data.appt_type) === 3 && Appttype !== 2 && Appttype !== 4) {
          setAppttype(1);
          setvideochck(false);
          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
          }
          let dur = moment(outTime, "hh:mm a").diff(
            moment(inTime, "hh:mm a"),
            "minutes",
          );
          setEditing(dur);
        } else if (Number(data.appt_type) === 2) {
          setAppttype(2);
          let t1 = inTime.split(" ");
          let t2 = outTime.split(" ");

          let from = disabledFromTimes(t1[0], t1[1], 2);

          if (!from) {
            let intime = moment(start);
            let now = moment();

            if (intime.isAfter(now)) {
              setInTime(moment(start).format("h:mm A"));
              let intime = moment(start).format("h:mm A");
              let out = moment(
                moment(start, "h:mm A").add(15, "minutes"),
              ).format("h:mm A");
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(intime, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
            }
          } else {
            let now = moment();

            let intime = now.format("h:mm A");

            let checktime = moment(aptdate, dtFormatsec);

            if (checktime.isBefore(now.format(dtFormat))) {
              // setOutTime("");
              setEditing("");
            } else {
              let out = moment(
                moment(now.format("h:mm A"), "h:mm A").add(15, "minutes"),
              ).format("h:mm A");

              setInTime(intime);
              setOutTime(out);
              let dur = moment(out, "hh:mm a").diff(
                moment(now, "hh:mm a"),
                "minutes",
              );
              setEditing(dur);
              setapttime(intime);
            }
          }

          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
          }
          // setbillingid("");
          // setprofileid("");
          setvideochck(true);
        } else if (Number(data.appt_type) === 1) {
          setAppttype(1);
          setvideochck(false);
          // setprofileid("");
          if (props.type !== "book again" && !props.isGroupAppointment) {
            setstatusid("");
            setbillingid("");
          }
          // setbillingid("");
        }
      });
    }
  }, [providerid]);

  useEffect(() => {
    const tempIntime = moment(start).format("h:mm A");
    if (props.view === "month") {
      let intime = moment(props.startTime1, "H").format("h:mm A");
      setInTime(intime);
      setapttime(intime);

      let outtime = moment(intime, "h:mm A")
        .add(15, "minutes")
        .format("h:mm A");
      setOutTime(outtime);

      let dur = moment(outtime, "h:mm A").diff(
        moment(intime, "h:mm A"),
        "minutes",
      );
      setEditing(dur);
    } else {
      if (props.fromDashboard) {
        axiosInstance
          .get("vozo/calendarsettingdata/main")
          .then((response) => {
            let temp_role_cal = Decrypt_Value(response.data, "vozo");

            let intime = moment(temp_role_cal.schedule_start, "H").format(
              "h:mm A",
            );

            setInTime(intime);

            let outtime = moment(intime, "h:mm A")
              .add(15, "minutes")
              .format("h:mm A");
            setOutTime(outtime);
            setapttime(intime);
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        setInTime(moment(start).format("h:mm A"));
        const tempIntime = moment(start).format("h:mm A");
        setOutTime(
          moment(moment(tempIntime, "h:mm A").add(15, "minutes")).format(
            "h:mm A",
          ),
        );
        setapttime(moment(start).format("h:mm A"));
      }
    }

    const intimeSplit = tempIntime.split(" ");

    getRoom(props.officeId);
    if (props.type !== "book again" && !props.isGroupAppointment) {
      setaptdate(moment(start).format(dtFormat));
    }
    setLastdateApp(moment(start).format(dtFormat));

    setappfromdate(moment(start).format("YYYY-MM-DD"));
    setapptodate(moment(start).format("YYYY-MM-DD"));

    setRoomVal(
      props.view === "day"
        ? props.examroom === true
          ? props.start.resourceId || ""
          : ""
        : props.examroom === true
          ? props.examRoomValueRef &&
            props.examRoomValueRef.current &&
            props.examRoomValueRef.current.length === 1
            ? props.examRoomValueRef.current[0]
            : ""
          : "",
    );
    let ofc_firstId = "";
    if (props.officeId) {
      const idArray = props.officeId.split(",");
      ofc_firstId = idArray[0];
    }
    setofficeid(ofc_firstId);
    getDatas();
  }, [props.start]);

  // When opened from waitlist, initialize officeid early from waitlist data
  // so that the provider/speciality fetch useEffects fire with the correct facility
  useEffect(() => {
    if (
      props.fromWaitList &&
      props.waitlistData &&
      props.waitlistData.facility_id &&
      (!officeid || officeid === "")
    ) {
      const facilityId = String(props.waitlistData.facility_id);
      setofficeid(facilityId);
      getRoom(facilityId);

      // Also set speciality early so the provider fetch includes it
      if (props.waitlistData.speciality && speciality === "") {
        setSpeciality(props.waitlistData.speciality);
        setSpecialError(false);
      }

      // Ensure getDatas has been called for this flow
      getDatas();

      // Show spinner while waitlist data loads (covers the time for
      // providers/speciality/profiles to fetch and populate)
      setWaitlistLoading(true);
      const spinnerTimer = setTimeout(() => {
        setWaitlistLoading(false);
      }, 3000);

      return () => clearTimeout(spinnerTimer);
    }
  }, [props.fromWaitList, props.waitlistData]);

  // useEffect(() => {
  //   setproviderid(
  //     props.start === undefined
  //       ? props.examroom
  //         ? props.providerSelect[0]
  //         : props.provider
  //       : props.examroom !== true
  //         ? props.start.resourceId
  //         : props.providerSelect[0],
  //   );

  //   setSpecialityByusers(
  //     props.start === undefined
  //       ? props.examroom
  //         ? props.providerSelect[0]
  //         : props.provider
  //       : props.examroom !== true
  //         ? props.start.resourceId
  //         : props.providerSelect[0],
  //   );
  // }, [props.start, props.providerSelect]);

  useEffect(() => {
    const selectedProviderId =
      props.start === undefined
        ? props.examroom
          ? props.providerSelect?.[0]
          : props.provider
        : props.examroom !== true
          ? props.start?.resourceId
          : props.providerSelect?.[0];

    if (
      selectedProviderId === undefined ||
      selectedProviderId === null ||
      selectedProviderId === ""
    ) {
      return;
    }

    const normalizedProviderId = String(selectedProviderId);

    setproviderid((currentProviderId) =>
      String(currentProviderId || "") === normalizedProviderId
        ? currentProviderId
        : normalizedProviderId,
    );

    setSpecialityByusers(normalizedProviderId);
  }, [
    props.start?.resourceId,
    props.providerSelect?.[0],
    props.provider,
    props.examroom,
  ]);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      let data =
        "pat_share=" +
        encodeURIComponent(storedNames.appt_a) +
        "&main_pro=" +
        encodeURIComponent(main_pro) +
        "&owner_id=" +
        encodeURIComponent(owner_id) +
        "&userID=" +
        encodeURIComponent(userID) +
        "&authorized=" +
        encodeURIComponent(authorized) +
        "&facilityId=" +
        encodeURIComponent(officeid) +
        "&speciality=" +
        encodeURIComponent(speciality) +
        "&apttype=" +
        encodeURIComponent(
          Appttype == 1
            ? "Appointment"
            : Appttype == 2
              ? "Telehealth"
              : Appttype == 4
                ? "Phone Call"
                : "Appointment",
        );

      let data1 = Encrypt_Value(data, "vozo");

      let url;
      let user = authorized === "1" ? userID : main_pro;

      if (storedNames.appt_a) {
        url = "/vozonew/provider?search=" + data1;
      } else {
        url = "/vozonew/provider?uid=" + user;
      }

      axiosInstance
        .get(url)
        .then((response) => {
          let temp_role_prov = Decrypt_Value(response.data, "vozo");

          setSourceprovider(temp_role_prov);

          if (!storedNames.appt_a || authorized === "0") {
            setNotDisabledSpec(temp_role_prov[0].specialty);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [officeid, speciality, Appttype]);
  useEffect(() => {
    if (officeid !== "" && officeid !== undefined) {
      axiosInstance
        .get("vozo/speciality/getspeciality?officeid=" + officeid)
        .then((res) => {
          let decryptval = Decrypt_Value(res.data, "vozo");

          const countDict = decryptval.reduce((acc, item) => {
            acc[item.specialty] = item.count;
            return acc;
          }, {});

          const matchedSpecialties = specialityList.map((specialty) => ({
            specialty,
            count: countDict[specialty] || 0,
          }));
          matchedSpecialties.sort((a, b) => b.count - a.count);

          setSortSpecility(matchedSpecialties);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [
    officeid,
    // speciality
  ]);

  // useEffect(() => {
  //   axiosInstance
  //     .get("vozo/getBillingFacility")
  //     .then((res) => {
  //       setBillFacility(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    if (patsrchvalue !== "") {
      let isCancelled = false;
      const handlechange = async () => {
        await timeout(1000);

        if (!isCancelled) {
          const searchFname = patsrchvalue.trim();

          let alle_data =
            "limit=40&fname=" +
            encodeURIComponent(searchFname.toLowerCase()) +
            "&authorized=" +
            authorized +
            "&main_pro=" +
            main_pro +
            "&userID=" +
            userID +
            "&pat_share=" +
            storedNames.pat_share +
            "&owner_id=" +
            owner_id +
            "&activepatlist=" +
            1;

          let alle_data_enc = Encrypt_Value(alle_data, "vozo");

          axiosInstance
            .get("/vozo/patientsearch?search=" + alle_data_enc)
            .then((response) => {
              let temp_role = Decrypt_Value(response.data, "vozo");
              setFetchingOptions(false);
              setSource(temp_role); // get 10 datas from response.data main array
            })
            .catch(() => {
              setSource([]);
            });
        }
      };
      handlechange();
      return () => {
        isCancelled = true;
      };
    } else {
      let alle_data =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_share +
        "&owner_id=" +
        owner_id +
        "&activepatlist=" +
        1;

      let alle_data_enc = Encrypt_Value(alle_data, "vozo");

      axiosInstance
        .get("/vozo/patientsearch?search=" + alle_data_enc)
        .then((response) => {
          let temp_role = Decrypt_Value(response.data, "vozo");

          setSource(temp_role);
        })
        .catch(() => {
          setSource([]);
        });
    }
  }, [patsrchvalue]);

  useEffect(() => {
    setBillFacId(bill_facility_id);
    axiosInstance
      .get("vozo/calendarsettingdata/main")
      .then((response) => {
        let temp_role_cal = Decrypt_Value(response.data, "vozo");
        setStartTime(
          temp_role_cal.schedule_start === "0"
            ? "0"
            : temp_role_cal.schedule_start,
        );
        setEndTime(
          temp_role_cal.schedule_end === "0"
            ? "24"
            : temp_role_cal.schedule_end,
        );

        const timeSlots1 = [];
        const timeSlots2 = [];
        let i = 0;
        let j = 0;
        let skipFirstMidnight = true;
        if (
          temp_role_cal.schedule_start === "0" &&
          temp_role_cal.schedule_end === "24"
        ) {
          for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
              let ampm = hour < 12 ? "AM" : "PM";
              let hourFormatted = hour === 0 ? 0 : hour > 12 ? hour - 12 : hour;
              if (hour === 24 && minute === 0) {
                ampm = "AM";
                hourFormatted = 12;
              }
              if (hour === 0) {
                hourFormatted = 12;
              }

              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
              timeSlots1.push({ id: ++i, time: time, meridiem: ampm });
              if (time === "12:00" && ampm === "AM" && skipFirstMidnight) {
                skipFirstMidnight = false;
                continue;
              }
              if (time !== "00:00") {
                timeSlots2.push({ id: ++j, time: time, meridiem: ampm });
              }
              if (hour === 23 && minute === 45) {
                if (
                  timeSlots2[timeSlots2.length - 1].time === "11:45" &&
                  timeSlots2[timeSlots2.length - 1].meridiem === "PM"
                ) {
                  timeSlots2.push({ id: ++j, time: "11:59", meridiem: "PM" });
                }
              }
            }
          }
        } else {
          for (
            let hour = Number(temp_role_cal.schedule_start);
            hour < Number(temp_role_cal.schedule_end);
            hour++
          ) {
            for (let minute = 0; minute < 60; minute += 15) {
              const ampm = hour < 12 ? "AM" : "PM";
              const hourFormatted = hour > 12 ? hour - 12 : hour;
              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
              timeSlots1.push({ id: ++i, time: time, meridiem: ampm });
            }
          }
          const scheduleStart = Number(temp_role_cal.schedule_start);
          const scheduleEnd = Number(temp_role_cal.schedule_end);

          for (let hour = scheduleStart; hour <= scheduleEnd; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
              const isPM = hour >= 12;
              const ampm = isPM ? "PM" : "AM";
              let hourFormatted = hour % 12;
              if (hourFormatted === 0) hourFormatted = 12;
              const time = `${hourFormatted
                .toString()
                .padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

              timeSlots2.push({ id: ++j, time: time, meridiem: ampm });

              if (hour === scheduleEnd && minute === 0) break;
            }
          }
        }
        setFromTimeSlots(timeSlots1);
        var frSlotTmId = timeSlots1
          .filter((ele) => {
            return (
              moment(ele.time + ele.meridiem, "HH:mm A").format("HH:mm A") >=
              moment(start).format("HH:mm A")
            );
          })
          .map((ele) => {
            return ele.id;
          });

        setFromId(frSlotTmId.slice(0, 1));
        setToTimeSlots(timeSlots2);

        if (temp_role_cal.schedule_end >= 12) {
          if (temp_role_cal.schedule_end === "24") {
            setEndErrTime("12:00 AM");
          } else if (temp_role_cal.schedule_end !== "12")
            setEndErrTime(temp_role_cal.schedule_end - 12 + ":00 PM");
          else setEndErrTime("12:00 PM");
        } else {
          setEndErrTime(temp_role_cal.schedule_end + ":00 AM");
        }
        if (temp_role_cal.schedule_start >= 12) {
          if (temp_role_cal.schedule_start !== "12")
            setStartErrTime(temp_role_cal.schedule_start - 12 + ":00 PM");
          else setStartErrTime("12:00 PM");
        } else {
          setStartErrTime(temp_role_cal.schedule_start + ":00 AM");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [bill_facility_id, props.start]);

  useEffect(() => {
    const week_day = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const day = new Date(moment(aptdate, dtFormat).format("YYYY-MM-DD"));
    setDay(week_day[day.getDay()]);

    // setMonth(month[day.getMonth()]);

    setDyOfMont(day.getDate());

    const weekNum = Math.ceil(day.getDate() / 7);
    if (weekNum == 1) {
      setWkOfMont("First");
    } else if (weekNum == 2) {
      setWkOfMont("Second");
    } else if (weekNum == 3) {
      setWkOfMont("Third");
    } else if (weekNum == 4) {
      setWkOfMont("Fourth");
    } else {
      setWkOfMont("Fifth");
    }
  }, [aptdate, repeatselectmonth]);
  useEffect(() => {
    if (repeatselect2new === "0") {
      if (repeatselectnew === "1") {
        //setOccurenceday(365);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(182);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(120);
      } else if (repeatselectnew === "4") {
        //setOccurenceday(91);
      } else if (repeatselectnew === "5") {
        //setOccurenceday(73);
      }
    } else if (repeatselect2new === "1") {
      if (repeatselectnew === "1") {
        //setOccurenceday(52);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(26);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(13);
      }
    } else if (repeatselect2new === "2") {
      if (repeatselectnew === "1") {
        //setOccurenceday(12);
      } else if (repeatselectnew === "2") {
        //setOccurenceday(6);
      } else if (repeatselectnew === "3") {
        //setOccurenceday(4);
      } else if (repeatselectnew === "4") {
        //setOccurenceday(3);
      }
    }
  }, [handleSelect2]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.type === "book again" || props.isGroupAppointment) {
          const data = await props.getAppointmentData();
          dispatch(setBookingData(data));
        }
      } catch (error) {
        console.error("Error fetching data in useEffect:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.type === "book again" || props.isGroupAppointment) {
      dataForBookAgain(bookingData);
    }
  }, [teleprofile, sourceprofile, bookingData]);

  useEffect(() => {
    if (typeof props.getStartApptDate === "function") {
      props.getStartApptDate(aptdate);
    }
  }, [aptdate]);

  useEffect(() => {
    if (props?.patEmail) {
      setEmptyEmailWarning(props.patEmail);
    }
  }, [props?.patEmail]);

  useEffect(() => {
    if (props.fromWaitList && props.waitlistData && !isWaitlistDataLoaded) {
      setIsInitialWaitlistLoad(true);
      const timer = setTimeout(() => {
        if (
          sourceoffice.length > 0 &&
          sourceprovider.length > 0 &&
          sourceprofile.length > 0
        ) {
          populateAppointmentData(props.waitlistData);
          setIsWaitlistDataLoaded(true);
          setIsInitialWaitlistLoad(false);
        } else {
          const retryTimer = setTimeout(() => {
            populateAppointmentData(props.waitlistData);
            setIsWaitlistDataLoaded(true);
            setIsInitialWaitlistLoad(false);
          }, 1000);

          return () => clearTimeout(retryTimer);
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [
    props.waitlistData,
    props.fromWaitList,
    sourceoffice,
    sourceprovider,
    sourceprofile,
    speciality,
  ]);

  useEffect(() => {
    if (
      props.fromWaitList &&
      props.waitlistData &&
      officeid &&
      officeid !== "" &&
      !isWaitlistDataLoaded
    ) {
      setSpinnerVal(true);
      setTimeout(() => {
        if (props.waitlistData.speciality && speciality === "") {
          setSpeciality(props.waitlistData.speciality);
          setSpecialError(false);
        }

        setSpinnerVal(false);
      }, 3000);

      setSpinnerVal(false);
      // }, 3000);

      // return () => clearTimeout(timer);
    }
  }, [officeid, props.fromWaitList, props.waitlistData]);

  useEffect(() => {
    if (
      props.fromWaitList &&
      props.waitlistData &&
      officeid &&
      officeid !== ""
    ) {
      const timer = setTimeout(() => {
        if (props.waitlistData.appt_profile && sourceprofile.length > 0) {
          const profileId = String(props.waitlistData.appt_profile);
          const profileExists = sourceprofile.some(
            (p) => String(p.value) === profileId,
          );

          if (profileExists && profileid !== profileId) {
            setprofileid(profileId);
            setprofileError(false);
          }
        }

        if (props.waitlistData.speciality && speciality === "") {
          setSpeciality(props.waitlistData.speciality);
          setSpecialError(false);
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [officeid, sourceprofile, props.fromWaitList, props.waitlistData]);

  useEffect(() => {
    getReminderIntegrationStatus();
  }, []);
  useEffect(() => {
    fetchAppointmentReminderDefaults();
  }, []);

  useEffect(() => {
    if (props.showReminderIntro2) {
      setAppointmentNotifyChecked(true);
      setAppointmentNotifyExpanded(true);
    }
  }, [props.showReminderIntro2]);

  useEffect(() => {
    if (props.showReminderIntro3) {
      setAppointmentNotifyChecked(true);
      setAppointmentNotifyExpanded(true);
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
      }));
      setNotifyIntegrationWarning("email");
      setTimeout(() => {
        if (warningBannerRef.current) {
          warningBannerRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }
  }, [props.showReminderIntro3]);

  useEffect(() => {
    if (props.showReminderIntro4) {
      setAppointmentNotifyChecked(true);
      setAppointmentNotifyExpanded(true);
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
      }));
      setShowTwilioModal(true);
    }
  }, [props.showReminderIntro4]);

  useEffect(() => {
    if (props.showReminderIntro5) {
      setAppointmentNotifyChecked(true);
      setAppointmentNotifyExpanded(true);
      setAppointmentNotifyChannels((prev) => ({
        ...prev,
      }));
      setShowEmailModal(true);
    }
  }, [props.showReminderIntro5]);

  useEffect(() => {
    setIndividualServiceCode([]);
    setGroupServiceCode([]);

    setIndividualSearch("");
    setGroupSearch("");

    const defaultDuration = getBaseAppointmentDuration();

    setIndividualDuration(`${defaultDuration} mins`);
    setGroupDuration(`${defaultDuration} mins`);
    setServiceDuration(`${defaultDuration} mins`);

    setEditing(defaultDuration);

    if (inTime) {
      updateEndTimeFromDuration(defaultDuration);
    }
  }, [changeTab]);

  useEffect(() => {
    let isCancelled = false;

    const fetchServiceCodes = async () => {
      // const type = changeTab === "3" ? "group" : "individual";
      const isGroupFlow = changeTab === "3" || props.isGroupAppointment;
      const type = isGroupFlow ? "group" : "individual";

      const search = isGroupFlow ? groupSearch : individualSearch;

      const data = "type=" + type + "&code_name=" + encodeURIComponent(search);

      const encrypted = Encrypt_Value(data, "vozo");

      try {
        const response = await axiosInstance.get(
          "/vozo/servicecodedropdown?search=" + encrypted,
        );

        const result = Decrypt_Value(response.data, "vozo");
        console.log("Service code options fetched:", result);

        if (!isCancelled) {
          const options = Array.isArray(result) ? result : [];

          options.forEach((item) => {
            serviceCodeCacheRef.current[String(item.code)] = item;
          });

          setServiceCodeOptions(options);
        }
      } catch (err) {
        if (!isCancelled) {
          setServiceCodeOptions([]);
        }
      }
    };

    fetchServiceCodes();

    return () => {
      isCancelled = true;
    };
  }, [changeTab, individualSearch, groupSearch, props.isGroupAppointment]);

  // ------------------------------ useEffect----end---------------------------------------------------- //
  return (
    <>
      {/* changes by sridar */}

      <Modal
        className=" client-popup topcreate_popup_centre wid_562"
        centered
        show={show}
        onHide={() => {
          setShow(false);
          setTemShow(true);
        }}
      >
        <CreateClient
          setappshow={props.setappshow}
          setTemShow={setTemShow}
          clientShow={setShow}
          dataFetch={() => getDatas()}
          ClientAdd={ClientAdd}
          // ClientAdd={handleClientCreateSuccess}
          ClientFailed1={setClientFail1}
          openIntake={openIntake}
        />
      </Modal>
      <IntakeForms
        toShow={showIntakeForm}
        toHide={() => setShowIntakeForm(false)}
        patientName={intakeData?.name}
        patientMail={intakeData?.email}
        patientId={intakeData?.id}
        from="create_client"
      />

      {/* <Modal className="alert-popup-message" show={clientAddIs}>
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" /> Successfully added...
        </div>
      </Modal> */}

      {clientAddIs?.show && (
        <Modal
          className="alert-popup-message"
          show={true}
          backdrop="static"
          keyboard={false}
        >
          <div className="alert msg alert-success" role="alert">
            <BsCheckCircle className="icons-bs" />
            <span style={{ marginLeft: "8px" }}>{clientAddIs?.message}</span>
          </div>
        </Modal>
      )}

      {/* ...................... */}
      <div
        className={`new-appointment-modal-wrapper-relative ${
          !props.isGroupAppointment &&
          props.type !== "book again" &&
          changeTab !== "1"
          ? "new-appointment-auto-height"
          : ""
          }`}
        style={{
          display: temShow ? "flex" : "none",
        }}
      >
        {isWaitlistStepFive &&
          (() => {
            const waitlistBtn =
              document.getElementById("select-from-waitlist-btn") ||
              selectFromWaitlistNode;
            const targetRect = waitlistBtn
              ? waitlistBtn.getBoundingClientRect()
              : patientNameSelectNode
                ? patientNameSelectNode.getBoundingClientRect()
                : null;
            const popupWidth = 350;
            const popupMinHeight = 180;
            const leftGap = 20;
            const topPosition =
              waitlistBtn && targetRect
                ? `${targetRect.top - 50}px`
                : targetRect
                  ? `${targetRect.top + 90}px`
                  : "200px";

            return targetRect ? (
              <div
                className="waitlist-step5-popup-inline"
                style={{
                  position: "fixed",
                  left: `${targetRect.left - popupWidth - leftGap}px`,
                  top: topPosition,
                  zIndex: 1060,
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                  padding: "20px 18px 16px 18px",
                  width: `${popupWidth}px`,
                  minHeight: `${popupMinHeight}px`,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    right: "-10px",
                    top: waitlistBtn && targetRect ? "58px" : "60px",
                    width: 0,
                    height: 0,
                    borderTop: "10px solid transparent",
                    borderBottom: "10px solid transparent",
                    borderLeft: "10px solid #ffffff",
                    filter: "drop-shadow(2px 0px 1px rgba(0,0,0,0.1))",
                  }}
                />
                <GetStartedPopup
                  title="Accept Waitlisted Appointments"
                  bullets={[
                    'To accept Waitlisted Appointments into scheduled appointments, click on the "Select from Waitlist" button.',
                    "Or you can also navigate to Appointment Waitlist page.",
                  ]}
                  currentStep={5}
                  totalSteps={8}
                  onBack={() => {
                    history.push(
                      "/schedule/waitlist?step=waitlist4&accountSetupWaitlist=true",
                    );
                    props.closepopup();
                  }}
                  onNext={() => {
                    history.push(
                      "/schedule/waitlist?step=waitlist6&accountSetupWaitlist=true",
                    );
                    props.closepopup();
                  }}
                  onClose={() => history.push({ search: "" })}
                  width="310px"
                />
              </div>
            ) : null;
          })()}
        {/* )} */}

        {/* {isWaitlist && popupStep === "waitlist7" && (
          <div className="waitlist-step7-popup-container">
            <GetStartedPopup
              title="Schedule Appointment"
              bullets={[
                "The details from the Waitlist page will be automatically populated here.",
              ]}
              bullets2={[
                "Click on the \"Save\" button to schedule the appointment.",
              ]}
              currentStep={7}
              totalSteps={8}
              onBack={() => {
                history.push("/schedule/waitlist?step=waitlist6&accountSetupWaitlist=true");
                props.closepopup();
              }}
              onNext={() => {
                history.push({ search: "?step=waitlist8&accountSetupWaitlist=true" });
              }}
              onClose={() => history.push({ search: "" })}
            />
          </div>
        )} */}

        {/* {isWaitlist && popupStep === "waitlist7" && (
          <div className="waitlist-step7-popup-container waitlist-step7-patient-pointer">
            <GetStartedPopup
              title="Schedule Waitlisted Appointments"
              bullets={[
                "In the Schedule appointment popup, verify and adjust the Appt Date & Time to your preference appt date & time.",
                "Click on the 'Save' button to save the Waitlist Appointment",
              ]}
              currentStep={7}
              totalSteps={8}
              onBack={() => {
                history.push("/schedule/waitlist?step=waitlist6&accountSetupWaitlist=true");
                props.closepopup();
              }}
              onNext={() => {
                history.push("/schedule/calender?step=waitlist8&accountSetupWaitlist=true");
                props.closepopup();
              }}
            />
          </div>
        )} */}

        {isWaitlist &&
          popupStep === "waitlist7" &&
          (() => {
            const targetRect = patientNameSelectNode
              ? patientNameSelectNode.getBoundingClientRect()
              : null;
            const popupWidth = 320;
            const leftGap = 20;

            return targetRect ? (
              <div
                className="waitlist-step7-popup-inline"
                style={{
                  position: "fixed",
                  left: `${targetRect.left - popupWidth - leftGap}px`,
                  top: `${targetRect.top - 20}px`,
                  zIndex: 1060,
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                  padding: "16px 18px",
                  width: `${popupWidth}px`,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    right: "-10px",
                    top: "30px",
                    width: 0,
                    height: 0,
                    borderTop: "10px solid transparent",
                    borderBottom: "10px solid transparent",
                    borderLeft: "10px solid #ffffff",
                    filter: "drop-shadow(2px 0px 1px rgba(0,0,0,0.1))",
                  }}
                />

                <GetStartedPopup
                  title="Schedule Waitlisted Appointments"
                  bullets={[
                    "In the Schedule appointment popup, verify and adjust the Appt Date & Time to your preference appt date & time.",
                    "Click on the 'Save' button to save the Waitlist Appointment",
                  ]}
                  currentStep={7}
                  totalSteps={8}
                  onBack={() => {
                    history.push(
                      "/schedule/waitlist?step=waitlist6&accountSetupWaitlist=true",
                    );
                    props.closepopup();
                  }}
                  onNext={() => {
                    history.push(
                      "/schedule/calender?step=waitlist8&accountSetupWaitlist=true",
                    );
                    props.closepopup();
                  }}
                  onClose={() => history.push({ search: "" })}
                  width="280px"
                />
              </div>
            ) : null;
          })()}

        {/* )} */}

        {props.isGroupAppointment ? (
          <Modal.Header
            closeButton
            className={
              props.type == "book again"
                ? "bookAgain_bottom_border"
                : "new_appointment_pop_topHeading "
            }
          >
            <Modal.Title className="table-top ">Group Book Again</Modal.Title>
          </Modal.Header>
        ) : props.type !== "book again" ? (
          <Modal.Header
            closeButton
            className={
              props.type == "book again"
                ? "bookAgain_bottom_border"
                : "new_appointment_pop_topHeading "
            }
          >
            <Modal.Title className="table-top ">
              Schedule Appointment
            </Modal.Title>
          </Modal.Header>
        ) : (
          <div className="new_app_for_book">
            <Modal.Header
              closeButton
              className={
                props.type == "book again"
                  ? "bookAgain_bottom_border"
                  : "new_appointment_pop_topHeading "
              }
            >
              <Modal.Title className="table-top ">Book Again</Modal.Title>
            </Modal.Header>
          </div>
        )}

        <Modal.Body
          ref={scheduleBodyRef}
          onScroll={handleModalScroll}
          // onScrollCapture={handleModalScroll}
          className={`c-pop New-App_Mod-Body ref_app ${
            !props.isGroupAppointment && props.type !== "book again"
            ? "new-appt-tabbed-body"
            : "new-appt-direct-body"
            }`}
          id="new-appts"
        >
          {SpinnerVal || waitlistLoading ? (
            <SpinnerDiv height="247px">
              <Spinner animation="border" variant="primary" />
            </SpinnerDiv>
          ) : (
            <>
              {props.isGroupAppointment ? (
                <Div
                  className="c-pop-one "
                  margin={
                    props.isGroupAppointment
                      ? "20px 0px 0px 5px"
                      : props.type !== "book again"
                        ? "20px 0px 0px -20px"
                        : "20px 0px 0px 0px"
                  }
                >
                  <Form.Row className="app-block  antd-select-height1">
                    {accountType > "0" || (accountType === "0" && trial) ? (
                      <>
                        {patFlag.map((item, ind) => (
                          <Div
                            key={ind}
                            className="new_appt_flag pt-fg-app-new"
                            style={{ backgroundColor: item.flag_color }}
                          >
                            <IoFlagOutline className="new_appt_flag_icon" />
                            <span className="new_appt_flag_amt">{`${item.flag_name} : ${item.description}`}</span>
                          </Div>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                    <div className="d_flex">
                      <div className="m_l_10">
                        <Div
                          alignItems="center"
                          className="search-pat  wholediv patient_name_out"
                        >
                          <Div margin="-20px 0px 0px -2px">
                            <PeopleOutline className="people" />
                          </Div>
                          <Div className="dropdiv" id="GroupPatient">
                            <Select
                              className={
                                groupPatError
                                  ? "err_mess_border w-100 b1"
                                  : "w-100"
                              }
                              placeholder="Group Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              onSelect={clearSelectActiveFocus}
                              showSearch
                              filterOption={false} // IMPORTANT
                              loading={loading}
                              value={groupId}
                              onSearch={handleGroupSearch}
                              onChange={(value) => {
                                setGroupId(value);
                                setGroupPatError(false);
                                resetPatientDefaultContact();
                                setAppointmentNotifyChecked(false);
                                setAppointmentNotifyExpanded(false);
                                setNotifyIntegrationWarning("");
                                setAppointmentNotifyChannels({
                                  email: false,
                                  sms: false,
                                  voice: false,
                                });
                              }}
                              notFoundContent={
                                loading ? "Loading..." : "No Group Found"
                              }
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <div
                                    style={{
                                      borderTop: "1px solid #eaeaea",
                                      padding: "8px 12px",
                                      cursor: "pointer",
                                      color: "#1677ff",
                                      fontWeight: 500,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => handleOpenGroupModal()}
                                  >
                                    + Add Patient Group
                                  </div>
                                </>
                              )}
                            >
                              {groupPatients.map((group) => (
                                <Select.Option
                                  key={group.value}
                                  value={group.value}
                                >
                                  {group.label}
                                </Select.Option>
                              ))}
                            </Select>
                            {groupPatError && (
                              <p className="errormessage">
                                Please Select Group
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="appointment_poup_div appointment_poup_div_w"
                        >
                          <Div
                            id="new_appt_radio"
                            className="appt-spn-vdovis new_app_radio_group"
                          >
                            <Radio.Group
                              onChange={
                                accountType === "-1" ||
                                  (accountType === "1" && teleFlag === "0")
                                  ? (e) => {
                                    if (Number(e.target.value) === 2) {
                                      setUpgrade(true);
                                    } else {
                                      onChangeRadio(e);
                                    }
                                  }
                                  : onChangeRadio
                              }
                              value={
                                walkincheck
                                  ? 3
                                  : forteleornor === 2
                                    ? forteleornor
                                    : Appttype
                              }
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                rowGap: "10px",
                              }}
                            >
                              <Radio
                                className="radio_appt_btn"
                                value={1}
                                onChange={checkapt}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 2 || videochck)
                                }
                              >
                                Appointment
                              </Radio>

                              <Radio
                                className="app-dashboard-radioBut m-0"
                                onClick={walkinclick}
                                value={3}
                                // disabled={videochck}
                                id="new-app-walkin"
                              >
                                Walk-in
                              </Radio>

                              <Radio
                                value={2}
                                onChange={checkvideovisit}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 1 || !videochck)
                                }
                              >
                                Telehealth
                              </Radio>

                              <Radio value={4}>Phone Call</Radio>
                            </Radio.Group>
                            {Appttype === 4 && patientid &&
                              (!patientDefaultContact.phone ||
                                patientDefaultContact.phone.trim() === "") && (
                                <Div
                                  style={{
                                    color: "red",
                                    marginLeft: "10px",
                                    marginTop: "5px",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ErrorOutlineIcon
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  No Phone number found for this patient. Add an
                                  phone number to schedule the meeting
                                </Div>
                              )}
                          </Div>
                        </Div>

                        <Div margin="13px 0 0 0">
                          <Div
                            alignItems="center"
                            className=" alx wholediv new_app_facility"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <RoomOutlined />
                            </Div>
                            <Div className="dropdiv" id="officeId">
                              <Select
                                virtual={false}
                                showSearch
                                placeholder="Hospital Name"
                                id="new-app-facility_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  officeError
                                    ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                      "classname",
                                    )}`
                                    : `to-hide-ant-label w-100 ${checkFacility(
                                      "classname",
                                    )}`
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectOffice(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={officeid ? officeid : null}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: 1,
                                    adjustY: 0,
                                  },
                                }}
                              >
                                {sourceoffice.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {checkFacility("spinner")}
                              {officeError && (
                                <p className="errormessage">
                                  Please select Office
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="search-pat new_app_select_prov appointment_patient_div"
                        >
                          <Div margin="-2px 0px 0px -2px">
                            <PeopleOutline />
                          </Div>
                          <Div className="appointment_drop_div" id="provId">
                            <Select
                              // virtual={false}
                              showSearch
                              placeholder="Doctor Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              onSelect={clearSelectActiveFocus}
                              id="new-app-provider new-app-provider_1"
                              className={
                                provError ? "err_mess_border w-100 " : "w-100"
                              }
                              onChange={(e, data) =>
                                handleDropDownSelectProvider(e, data)
                              }
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.title ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              // value={providerid ? providerid : undefined}
                              value={
                                providerid ? String(providerid) : undefined
                              }
                              getPopupContainer={(triggerNode) =>
                                (triggerNode &&
                                  triggerNode.closest &&
                                  triggerNode.closest(
                                    ".ant-tabs-content-holder",
                                  )) ||
                                document.getElementById("new-appts") ||
                                document.body
                              }
                            // getPopupContainer={() =>
                            //   document.getElementById("provId")
                            // }
                            >
                              {sourceprovider.map((i) => (
                                <Option
                                  key={i.value}
                                  value={String(i.value)}
                                  title={i.text}
                                >
                                  {i.text}
                                </Option>
                              ))}
                            </Select>
                            {provError && (
                              <p className="errormessage">
                                Please select Provider
                              </p>
                            )}
                          </Div>
                        </Div>
                      </div>

                      <div>
                        <Div className=" w-100 m_b_12">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px">
                              <PersonOutline />
                            </Div>
                            <Div className="dropdiv" id="ProfId">
                              <Select
                                virtual={false}
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                className={
                                  profileError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                showSearch
                                placeholder="Appt Profile"
                                id="new-app-profile_1 appt-inp-profsrch"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                onChange={(e, data) =>
                                  handleDropDownSelect(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={profileid ? String(profileid) : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {getFilteredAndSortedProfiles(
                                  sourceprofile,
                                  changeTab === "3" || props.isGroupAppointment,
                                ).map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>

                              {profileError && (
                                <p className="errormessage">
                                  Please select Appointment Profile
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className="new_app_date_bookAgain">
                          <Div className="access_icon">
                            <AccessTimeIcon className="people" />
                          </Div>
                          <form
                            className={`${classes.container} frm-apoint`}
                            noValidate
                          >
                            <div
                              id="crt_appt-time-ok"
                              className="date-pick date-pick-parent app-datepick_bookAgain"
                            >
                              <DatePicker
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                style={{ width: "102px" }}
                                onChange={(date) => {
                                  if (date) {
                                    setaptdate(moment(date).format(dtFormat));

                                    if (appointmentNotifySchedule.customDate) {
                                      setAppointmentNotifyCustomDateWarning(
                                        false,
                                      );
                                    }
                                  } else {
                                    setaptdate("");

                                    if (
                                      props.type === "book again" &&
                                      appointmentNotifySchedule.customDate
                                    ) {
                                      setAppointmentNotifyCustomDateWarning(
                                        true,
                                      );
                                    }
                                  }
                                }}
                                className={dateErr ? "err-bdr-date" : ""}
                                placeholder="Select date"
                                format={dtFormat}
                                onSelect={clearSelectActiveFocus}
                                value={
                                  aptdate ? moment(aptdate, dtFormat) : null
                                }
                                allowClear={false}
                                disabledDate={
                                  Appttype == 2 &&
                                  ((current) => {
                                    // Disable dates before today
                                    return (
                                      current &&
                                      current < moment().startOf("day")
                                    );
                                  })
                                }
                              />

                              <div className="App-time ">
                                <div
                                  className="showTime"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "78px",
                                      marginRight: "2px",
                                    }}
                                  >
                                    <input
                                      className="fromTime-toTime-start"
                                      onClick={() => {
                                        handleFromTime();
                                      }}
                                      onMouseLeave={() => {
                                        setTempOpen(false);
                                      }}
                                      style={{
                                        border:
                                          timeMismatch || inTimeErr
                                            ? "1px solid red"
                                            : "",
                                        width: "64px",
                                        fontWeight: "400",
                                        paddingRight: "0px",
                                        paddingLeft: "0px",
                                      }}
                                      value={inTime}
                                      onChange={(e) => {
                                        if (
                                          !regexFirstNum.test(e.target.value)
                                        ) {
                                          setFromShow(false);
                                          setToShow(false);
                                          setInTime(e.target.value);
                                          setTimeMismatch(false);
                                          setTimeout(() => {
                                            setInTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );

                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "inTime",
                                            );
                                          }, 4000);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        setTimeMismatch(false);
                                        setInTime(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                        );
                                        onChange(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                          "inTime",
                                        );
                                      }}
                                    />
                                    {/* Inside Input Dropdown Arrow Icon */}
                                    {/* <FiChevronDown
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleFromTime();
                                      }}
                                      style={{
                                        marginLeft: "2px",
                                        color: "#808080",
                                        fontSize: "12px",
                                        flexShrink: 0,
                                        cursor: "pointer",
                                      }}
                                    /> */}
                                  </div>

                                  <p
                                    className="time--space"
                                    style={{ margin: "0 2px" }}
                                  >
                                    -
                                  </p>

                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "78px",
                                    }}
                                  >
                                    <input
                                      className="fromTime-toTime"
                                      onClick={() => {
                                        handleToTime();
                                      }}
                                      style={{
                                        border:
                                          timeMismatch || inTimeErr
                                            ? "1px solid red"
                                            : "",
                                        width: "64px",
                                        fontWeight: "400",
                                        paddingRight: "0px",
                                        paddingLeft: "0px",
                                      }}
                                      onChange={(e) => {
                                        if (
                                          !regexFirstNum.test(e.target.value)
                                        ) {
                                          setFromShow(false);
                                          setToShow(false);
                                          setOutTime(e.target.value);
                                          setTimeMismatch(false);
                                          setTimeout(() => {
                                            setOutTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );

                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "outTime",
                                            );
                                          }, 4000);
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        setTempOpen(false);
                                      }}
                                      onBlur={(e) => {
                                        setTimeMismatch(false);
                                        setOutTime(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                        );
                                        onChange(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                          "outTime",
                                        );
                                      }}
                                      value={outTime}
                                    />
                                    {/* Inside Input Dropdown Arrow Icon */}
                                    {/* <FiChevronDown
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleToTime();
                                      }}
                                      style={{
                                        marginLeft: "2px",
                                        color: "#808080",
                                        fontSize: "12px",
                                        flexShrink: 0,
                                        cursor: "pointer",
                                      }}
                                    /> */}
                                  </div>
                                </div>

                                <div
                                  className={
                                    fromShow
                                      ? "fromArray-toArray"
                                      : "fromArray_hide"
                                  }
                                >
                                  {frtimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        key={item.id}
                                        value={item.time + " " + item.meridiem}
                                        disabled={disabledFromTimes(
                                          item.time,
                                          item.meridiem,
                                          Appttype,
                                        )}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          await setFromId(item.id);
                                          handleFromButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>

                                <div
                                  className={
                                    toShow
                                      ? "fromArray-toArray"
                                      : "toArray_hide"
                                  }
                                  style={{ left: 70 }}
                                >
                                  {totimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        disabled={disabledToTime(
                                          item.time,
                                          item.meridiem,
                                          item.id,
                                          Appttype,
                                        )}
                                        key={index}
                                        value={item.time + " " + item.meridiem}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          handleToButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            {dateErr && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                // className="colour-red m-t-0-imp_editAppointment  "
                                className="colour-red book-again-date-warning-gap"
                              >
                                Please Select valid date
                              </Form.Text>
                            )}
                          </form>
                        </Div>
                        {(props.type !== "book again" ||
                          String(aptdate || "").trim() !== "") &&
                          (inTimeErr || timeMismatch) && (
                            <Form.Text
                              id="new-app-time-codetext appt-warn-time"
                              // className="colour-red p-l-66 m-t-0-imp m-b-3"
                              className="colour-red err-m-t p-l-40 m-b-6"
                            >
                              Please Select valid Time
                            </Form.Text>
                          )}
                        {(props.type !== "book again" ||
                          String(aptdate || "").trim() !== "") &&
                          timelimiterrorbox && (
                            <Form.Text
                              id="new-app-time-codetext appt-warn-time"
                              className="colour-red p-l-66 m-t-0-imp m-b-3"
                            >
                              Provider Only Available Between {startErrTime} to{" "}
                              {endErrTime}
                            </Form.Text>
                          )}

                        <Div style={{ textAlign: "left" }}>
                          <Popup
                            content={fornormalapp}
                            open={normalappointment}
                            trigger={
                              <Button
                                id="click_event_app_normal"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>
                        <Div>
                          <Popup
                            content={forteleapp}
                            open={teleappointment}
                            trigger={
                              <Button
                                id="click_event_app_tele"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>

                        <Div className=" w-100">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px" size="20px">
                              <Image
                                src={doctorLogo}
                                alt="speciality"
                                height="20px"
                                width="20px"
                              />
                            </Div>

                            <Div className="dropdiv">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                virtual={false}
                                showSearch
                                placeholder="Select Specialityyyy"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  specialError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(data) => changeSpeciality(data)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={speciality ? speciality : null}
                                optionLabelProp="label"
                                dropdownClassName="speciality-option"
                              >
                                {sortSpeciality &&
                                  sortSpeciality
                                    .filter(
                                      (item) =>
                                        (storedNames.appt_a ||
                                          item.specialty === notDisabledSpec) &&
                                        item.count > 0,
                                    ) // Filter disabled options
                                    .map((item) => (
                                      <Option
                                        key={item.specialty}
                                        value={item.specialty}
                                        title={item.specialty}
                                        disabled={
                                          (!storedNames.appt_a &&
                                            item.specialty !==
                                            notDisabledSpec) ||
                                          item.count === 0
                                        }
                                        id={
                                          !storedNames.appt_a &&
                                            item.specialty !== notDisabledSpec
                                            ? "clr-disable"
                                            : "" || item.count == 0
                                              ? "clr-disable"
                                              : ""
                                        }
                                        className={
                                          (!storedNames.appt_a &&
                                            item.speciality !==
                                            notDisabledSpec) ||
                                          item.count === 0
                                        }
                                      >
                                        {item.speciality}
                                      </Option>
                                    ))}
                              </Select>
                              {specialError && (
                                <p className="errormessage">
                                  Select a specialityyyy
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100">
                          <Div
                            className="wholediv"
                          // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <HomeOutlinedIcon />
                            </Div>
                            <Div className="dropdiv" id="ExaId">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                virtual={false}
                                showSearch
                                placeholder="Exam Room"
                                id="new-app-profile_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  examroomError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleRoomVal(data.value)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={roomval ? roomval : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                  maxHeight: "200px",
                                }}
                              >
                                {sourceroom.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {examroomError && (
                                <p className="errormessage">
                                  Please select Exam Room
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>
                        {repvalue !== "" &&
                          repvalue !== undefined &&
                          repvalue !== null &&
                          repvalue !== "Does not repeat" &&
                          repvalue !== "Does not repeat " && (
                            <div
                              style={{ marginTop: "10px", marginLeft: "43px" }}
                            >
                              <div style={{ width: "94px" }}>
                                <p
                                  className="remove-bor-mar"
                                  style={{ marginBottom: "4px" }}
                                >
                                  Duration
                                </p>
                                <div
                                  onClick={(e) => {
                                    const inp =
                                      e.currentTarget.querySelector("input");
                                    if (inp) inp.focus();
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: "38px",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    backgroundColor: "#fff",
                                    cursor: "text",
                                  }}
                                >
                                  <input
                                    value={
                                      serviceDuration
                                        ? String(serviceDuration).replace(
                                          /\D/g,
                                          "",
                                        )
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const raw = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      setServiceDuration(
                                        raw ? `${raw} mins` : "",
                                      );
                                    }}
                                    style={{
                                      border: "none",
                                      outline: "none",
                                      width: `${Math.max(2, serviceDuration ? String(serviceDuration).replace(/\D/g, "").length : 0)}ch`,
                                      padding: 0,
                                      color: "inherit",
                                      backgroundColor: "transparent",
                                      fontSize: "inherit",
                                      fontFamily: "inherit",
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: "inherit",
                                      fontSize: "inherit",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    mins
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {/* <Div display="flex" padding="0px 0px 10px 45px">
                      <p className="remove-bor-mar">Reason</p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          onSelect={clearSelectActiveFocus}
                          getPopupContainer={(triggerNode) => (triggerNode && triggerNode.closest && triggerNode.closest(".ant-tabs-content-holder")) || document.getElementById("new-appts") || document.body}
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}
                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                          }}
                        >
                          Maximum of 200 characters
                        </p>
                      )}
                    </Div> */}

                    <Div
                      display="flex"
                      flexDirection="column"
                      padding="0px 0px 10px 45px"
                    >
                      {(!repvalue ||
                        repvalue === "Does not repeat" ||
                        repvalue === "Does not repeat ") && (
                          <div
                            style={{
                              display: "flex",
                              padding: "0px 0px 15px 0px",
                              alignItems: "flex-end",
                              justifyContent: "flex-start",
                              width: "528px",
                            }}
                          >
                            <div style={{ width: "350px" }}>
                              <p
                                className="remove-bor-mar"
                                style={{ marginBottom: "6px" }}
                              >
                                Service Code
                              </p>
                              <Select
                                mode="multiple"
                                showArrow
                                showSearch
                                filterOption={false}
                                virtual={false}
                                value={groupServiceCode}
                                placeholder="Select a Service Code"
                                style={{
                                  width: "100%",
                                  minHeight: "40px",
                                  height: "auto",
                                }}
                                size="large"
                                listHeight={125}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                suffixIcon={
                                  <BsFillCaretDownFill
                                    size={12}
                                    color="#808080"
                                  />
                                }
                                onChange={(value) => {
                                  setGroupServiceCode(value);
                                  setGroupSearch("");

                                  const highestServiceCodeDuration =
                                    getHighestSelectedServiceCodeDuration(value);
                                  const defaultDuration =
                                    getBaseAppointmentDuration();
                                  const finalDuration = Math.max(
                                    highestServiceCodeDuration,
                                    defaultDuration,
                                  );

                                  setGroupDuration(`${finalDuration} mins`);
                                  updateEndTimeFromDuration(finalDuration);
                                }}
                                onSearch={(value) => {
                                  setGroupSearch(value);
                                }}
                              >
                                {serviceCodeOptions.map((item) => (
                                  <Option
                                    key={item.code}
                                    value={item.code}
                                    title={item.title}
                                  >
                                    {item.title}
                                  </Option>
                                ))}
                              </Select>
                            </div>

                            <div style={{ width: "94px", marginLeft: "34px" }}>
                              <p
                                className="remove-bor-mar"
                                style={{ marginBottom: "10px" }}
                              >
                                Duration
                              </p>
                              <input
                                value={groupDuration}
                                onChange={(e) => {
                                  const raw = e.target.value;
                                  setGroupDuration(raw);

                                  const parsedMinutes = parseInt(raw, 10);
                                  if (
                                    !isNaN(parsedMinutes) &&
                                    parsedMinutes > 0
                                  ) {
                                    updateEndTimeFromDuration(parsedMinutes); // 🔹 NEW
                                  }
                                }}
                                style={{
                                  width: "100%",
                                  height: "38px",
                                  lineHeight: "38px",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "4px",
                                  padding: "0 10px",
                                  backgroundColor: "#fff",
                                  outline: "none",
                                  color: "#000",
                                }}
                              />
                            </div>
                          </div>
                        )}

                      <p
                        className="remove-bor-mar"
                        style={{ marginBottom: "6px" }}
                      >
                        Reason
                      </p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          onSelect={clearSelectActiveFocus}
                          getPopupContainer={(triggerNode) =>
                            (triggerNode &&
                              triggerNode.closest &&
                              triggerNode.closest(
                                ".ant-tabs-content-holder",
                              )) ||
                            document.getElementById("new-appts") ||
                            document.body
                          }
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}

                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                            width: "528px",
                            margin: "4px 0 0 0",
                          }}
                        >
                          <div style={{ textAlign: "right" }}>
                            Maximum of 200 characters
                          </div>
                        </p>
                      )}
                    </Div>

                    {/* {renderAppointmentNotification()} */}
                  </Form.Row>
                </Div>
              ) : props.type !== "book again" ? (
                <Tabs
                  activeKey={changeTab}
                  className={`tabheader for_add_app_avail ${
                    changeTab !== "1" ? "non-scroll-tab" : ""
                    }`}
                  onChange={(val) => {
                    setChangeTag(val);
                    handlerepSelect("Does not repeat");

                    const isGroup = val === "3" || props.isGroupAppointment;
                    const validProfiles = getFilteredAndSortedProfiles(
                      sourceprofile,
                      isGroup,
                    );
                    if (
                      profileid &&
                      !validProfiles.some(
                        (p) => String(p.value) === String(profileid),
                      )
                    ) {
                      setprofileid("");
                    }
                    requestAnimationFrame(() => {
                      const contentHolder =
                        scheduleBodyRef.current?.querySelector(
                          ".for_add_app_avail > .ant-tabs-content-holder",
                        );

                      if (contentHolder) {
                        contentHolder.scrollTop = 0;
                      }
                    });
                  }}
                >
                  <Popup
                    offset={[-100, 10]}
                    content={
                      <GetStartedPopup
                        title="Schedule your first appointment"
                        bullets={[
                          "Select Patient",
                          "Select Type of Appointment",
                          "Select Appointment Profile",
                          "Select Facility",
                          "Select Specialty",
                          "Select Provider (based on Specialty)",
                          "Select Appointment Status",
                          "Select Exam Room",
                          "Click Save to save your appointment",
                        ]}
                        thanksnote="Thank you taking your time to finish the setup. With this your initial account setup is complete."
                        currentStep={6}
                        totalSteps={6}
                        onBack={handleIntroBack}
                        onGotIt={handleIntroGotIt}
                        onClose={() => {
                          props.setShowStepSixIntro(false);
                          props.closepopup();
                        }}
                        width={popupWidth}
                      />
                    }
                    open={!!props.showStepSixIntro}
                    className="m-t-5"
                    trigger={<div></div>}
                    position="left center"
                  />
                  <TabPane
                    tab="New Appointment"
                    key="1"
                    className="appt-dash-hed p_l_10"
                  >
                    <Div className="c-pop-one " margin="20px 0px 0px -20px">
                      <Form.Row className="app-block  antd-select-height1">
                        {accountType > "0" || (accountType === "0" && trial) ? (
                          <>
                            {patFlag.map((item, ind) => (
                              <Div
                                key={ind}
                                className="new_appt_flag pt-fg-app-new"
                                style={{ backgroundColor: item.flag_color }}
                              >
                                {/* <IoFlagOutline className="new_appt_flag_icon" />
                                <span className="new_appt_flag_amt">
                                  {`${item.flag_name} : ${item.description}`} */}
                                <div
                                  className="app_pro_text_wrap new_app_flag"
                                  title={item.flag_name}
                                >
                                  {" "}
                                  <IoFlagOutline
                                    className="new_appt_flag_icon"
                                    style={{ marginRight: "5px" }}
                                  />
                                  {item.flag_name}
                                </div>
                                {/* </span> */}
                              </Div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        <div className="d_flex">
                          <div className="m_l_10">
                            <Div
                              alignItems="center"
                              className="search-pat  wholediv patient_name_out patient_name_filter"
                            >
                              <Div margin="-20px 0px 0px -2px">
                                <PeopleOutline className="people" />
                              </Div>
                              <Div
                                ref={patientNameSelectRef}
                                className={`dropdiv ${isWaitlist && popupStep === "waitlist7" ? "waitlist-step7-active-patient-field" : ""}`}
                                id="PatId"
                              >
                                <Select
                                  ref={patientSearchSelectRef}
                                  virtual={false}
                                  getPopupContainer={(triggerNode) =>
                                    (triggerNode &&
                                      triggerNode.closest &&
                                      triggerNode.closest(
                                        ".ant-tabs-content-holder",
                                      )) ||
                                    document.getElementById("new-appts") ||
                                    document.body
                                  }
                                  open={isWaitlistStepFive ? true : undefined}
                                  // dropdownStyle={{
                                  //   maxHeight: "200px",
                                  // }}
                                  showSearch
                                  allowClear={false}
                                  placeholder="Patient Name"
                                  id="new-app-patient_1 appt-inp-patsrch "
                                  suffixIcon={<BsFillCaretDownFill />}
                                  disabled={props?.from === "patient_detail"}
                                  className={
                                    patError
                                      ? "err_mess_border w-100 b1"
                                      : "w-100"
                                  }
                                  // value={
                                  //   patientid || searchInput
                                  //     ? search1
                                  //     : undefined
                                  // } // control value
                                  value={
                                    searchInputValue || patientid
                                      ? searchInputValue
                                      : undefined
                                  }
                                  // searchInputValue || patientid
                                  //   ? searchInputValue
                                  //   : undefined
                                  searchValue={searchInput}
                                  onSearch={(value) => {
                                    setSearchInput(value);
                                    setpatsrchvalue(value);
                                    setFetchingOptions(true);
                                  }}
                                  onSelect={(value, option) => {
                                    handleDropDownSelectPatient(value, option);
                                    // setSearchInput(option.title);
                                    clearPatientSearchFocus();
                                  }}
                                  onChange={async (value, option) => {
                                    if (!value) {
                                      setSearchInput("");
                                      setSearchInputValue("");
                                      setpatientid(null);
                                      setpatsrchvalue("");

                                      setAppointmentNotifyPatientWarning(false);
                                      setAppointmentNotifyChecked(false);
                                      setAppointmentNotifyExpanded(false);
                                      resetPatientDefaultContact();

                                      return;
                                    }

                                    const selectedTitle = option?.title || "";

                                    setSearchInputValue(selectedTitle);
                                    // setSearchInput(selectedTitle);
                                    clearPatientSearchFocus();
                                    setpatientid(value);
                                    setAppointmentNotifyPatientWarning(false);

                                    setAppointmentNotifyChecked(false);
                                    setAppointmentNotifyExpanded(false);

                                    handleDropDownSelectPatient(value, option);

                                    await fetchPatientDefaultContact(
                                      value,
                                      false,
                                      true,
                                    );
                                  }}
                                  filterOption={false}
                                  notFoundContent={
                                    fetchingOptions
                                      ? "Loading..."
                                      : "No Data found"
                                  }
                                  // getPopupContainer={(triggerNode) =>
                                  //   triggerNode.parentNode
                                  // }
                                  // dropdownStyle={{
                                  //   maxHeight: "200px",
                                  // }}
                                  dropdownAlign={{
                                    points: ["tl", "bl"],
                                    offset: [0, 4],
                                    overflow: {
                                      adjustX: true,
                                      adjustY: false,
                                    },
                                  }}
                                  // dropdownStyle={{ zIndex: 1050 }}
                                  dropdownRender={(menu) => (
                                    <>
                                      {menu}
                                      <StyledDiv>
                                        <StyledButton
                                          disabled={
                                            storedNames.demo1_viewOnly ||
                                            storedNames.demo_v
                                          }
                                          onClick={() => {
                                            if (!storedNames.demo) {
                                              alert(
                                                "You don’t have access to add patients",
                                              );
                                            } else {
                                              setTemShow(false);
                                              setShow(true);
                                            }
                                          }}
                                          onMouseDown={(e) =>
                                            e.preventDefault()
                                          }
                                        >
                                          <StyledSvg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 448 512"
                                          >
                                            <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                          </StyledSvg>
                                          <span
                                            onClick={() => {
                                              if (
                                                storedNames.demo1_viewOnly ||
                                                storedNames.demo_v
                                              ) {
                                                alert(
                                                  "You only have view-only access.",
                                                );
                                              } else {
                                                handleAddPatient();
                                              }
                                            }}
                                          >
                                            Add Patient
                                          </span>
                                        </StyledButton>
                                      </StyledDiv>
                                      <StyledDiv ref={selectFromWaitlistRef}>
                                        <StyledButton
                                          id="select-from-waitlist-btn"
                                          onClick={
                                            handleSelectFromWaitlistClick
                                          }
                                        >
                                          <Image
                                            height="16px"
                                            width="16px"
                                            src={waitListIcon}
                                          // className="spin-img center-loading-image"
                                          />{" "}
                                          Select From Waitlist
                                        </StyledButton>
                                      </StyledDiv>
                                    </>
                                  )}
                                >
                                  {source.map((i) => {
                                    const titleLength = i.text.length;

                                    return (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                        phone_cell={i.phone_cell}
                                        dob={i.dob}
                                        ss={i.ss}
                                        email={i.email}
                                      >
                                        <div>
                                          {titleLength < 15 ? (
                                            <>
                                              {i.text} -{" "}
                                              {i.dob
                                                ? moment(i.dob).format(dtFormat)
                                                : " "}
                                            </>
                                          ) : (
                                            <>
                                              <div>{i.text} -</div>
                                              <div>
                                                {i.dob
                                                  ? moment(i.dob).format(
                                                    dtFormat,
                                                  )
                                                  : " "}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                        <div>{i.phone_cell}</div>
                                      </Option>
                                    );
                                  })}
                                </Select>

                                {patError && (
                                  <p className="errormessage">
                                    Please select Patient
                                  </p>
                                )}

                                {appointmentNotifyPatientWarning && (
                                  <p className="appt-notify-patient-warning">
                                    <FiAlertCircle className="appt-notify-warning-icon" />
                                    Select a patient first
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="appointment_poup_div appointment_poup_div_w"
                            >
                              <Div
                                id="new_appt_radio"
                                className="appt-spn-vdovis new_app_radio_group"
                              >
                                <Radio.Group
                                  onChange={
                                    accountType === "-1" ||
                                      (accountType === "1" && teleFlag === "0")
                                      ? (e) => {
                                        if (Number(e.target.value) === 2) {
                                          setUpgrade(true);
                                        } else {
                                          onChangeRadio(e);
                                        }
                                      }
                                      : onChangeRadio
                                  }
                                  value={
                                    walkincheck
                                      ? 3
                                      : forteleornor === 2
                                        ? forteleornor
                                        : Appttype
                                  }
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    rowGap: "10px",
                                  }}
                                >
                                  <Radio
                                    className="radio_appt_btn"
                                    value={1}
                                    onChange={checkapt}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Appointment
                                  </Radio>

                                  <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    id="new-app-walkin"
                                  >
                                    Walk-in
                                  </Radio>

                                  <Radio
                                    value={2}
                                    onChange={checkvideovisit}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 1 || !videochck)
                                    }
                                  >
                                    Telehealth
                                  </Radio>

                                  <Radio value={4}>Phone Call</Radio>
                                </Radio.Group>
                                {Appttype === 4 && patientid &&
                                  (!patientDefaultContact.phone ||
                                    patientDefaultContact.phone.trim() ===
                                    "") && (
                                    <Div
                                      style={{
                                        color: "red",
                                        marginLeft: "10px",
                                        marginTop: "5px",
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          fontSize: "14px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      No Phone number found for this patient.
                                      Add an phone number to schedule the
                                      meeting
                                    </Div>
                                  )}
                              </Div>
                            </Div>

                            {emptyEmailWarning && videochck && (
                              <Div>
                                <p
                                  className="errormessage"
                                  style={{
                                    marginTop: "12px",
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Image
                                    src={errorIcon}
                                    alt="Alert"
                                    height="20px"
                                    width="20px"
                                    style={{ flexShrink: 0, marginTop: "2px" }}
                                  />
                                  <span style={{ paddingLeft: "5px" }}>
                                    No email ID found for this patient. Add an
                                    <br />
                                    email address to send the telehealth link.
                                  </span>
                                </p>
                              </Div>
                            )}

                            <Div margin="13px 0 0 0">
                              <Div
                                alignItems="center"
                                className=" alx wholediv new_app_facility"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <RoomOutlined />
                                </Div>
                                <Div className="dropdiv" id="officeId">
                                  <Select
                                    virtual={false}
                                    showSearch
                                    placeholder="Hospital Name"
                                    id="new-app-facility_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      officeError
                                        ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                          "classname",
                                        )}`
                                        : `to-hide-ant-label w-100 ${checkFacility(
                                          "classname",
                                        )}`
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectOffice(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={officeid ? officeid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: 1,
                                        adjustY: 0,
                                      },
                                    }}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sourceoffice.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {checkFacility("spinner")}
                                  {officeError && (
                                    <p className="errormessage">
                                      Please select Office
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="search-pat new_app_select_prov appointment_patient_div"
                            >
                              <Div margin="-2px 0px 0px -2px">
                                <PeopleOutline />
                              </Div>
                              <Div className="appointment_drop_div" id="provId">
                                <Select
                                  // virtual={false}
                                  showSearch
                                  placeholder="Doctor Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  onSelect={clearSelectActiveFocus}
                                  id="new-app-provider new-app-provider_1"
                                  className={
                                    provError
                                      ? "err_mess_border w-100 "
                                      : "w-100"
                                  }
                                  onChange={(e, data) => {
                                    if (storedNames.appt_a1_viewOnly) {
                                      alert("You only have view-only access.");
                                    } else {
                                      handleDropDownSelectProvider(e, data);
                                    }
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.title ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  // value={providerid ? providerid : undefined}
                                  value={
                                    providerid ? String(providerid) : undefined
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentElement
                                  }
                                // getPopupContainer={() =>
                                //   document.getElementById("provId")
                                // }
                                >
                                  {sourceprovider.map((i) => (
                                    <Option
                                      key={i.value}
                                      value={String(i.value)}
                                      title={i.text}
                                      disabled={storedNames.appt_a1_viewOnly}
                                    >
                                      {i.text}
                                    </Option>
                                  ))}
                                </Select>
                                {provError && (
                                  <p className="errormessage">
                                    Please select Provider
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              className="app_repeat_dropdown app_dummy_class"
                              margin=" 0px 0px 10px 40px"
                            >
                              <BsFillCaretDownFill className="down_arrow_doesnt does-not-repeat-icon-new" />

                              <DropdownButton
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                id="arrow-newAppt"
                                className="app-nav-dropdown-for-newApp-repect "
                                title={repvalue ? repvalue : "Does not repeat"}
                                onSelect={handlerepSelect}
                                variant="light"
                              >
                                <Dropdownant.Item eventKey="Does not repeat">
                                  Does not repeat
                                </Dropdownant.Item>
                                <Dropdownant.Item
                                  onClick={handleShowuntildate}
                                  eventKey="Daily"
                                >
                                  Daily
                                </Dropdownant.Item>
                                <Dropdownant.Item
                                  onClick={handleShowuntildate}
                                  eventKey={"Week"}
                                >
                                  Week
                                </Dropdownant.Item>
                              </DropdownButton>
                            </Div>

                            {repvalue === "Week" && (
                              <Div margin="5px 4px 14px 40px">
                                <ToggleButtonGroup
                                  type="checkbox"
                                  value={weekday}
                                  className="appt_repeats but-act app_gap "
                                  onChange={WeekdayChange}
                                  style={
                                    selectdayError
                                      ? {
                                        border: "1px solid red",
                                        borderRadius: "5px",
                                      }
                                      : {}
                                  }
                                >
                                  <ToggleButton
                                    disabled={
                                      WeeklyDisable === "Show only weekdays" ||
                                        WeeklyDisable === "Don't show Sundays"
                                        ? true
                                        : false
                                    }
                                    className={
                                      WeeklyDisable === "Show only weekdays" ||
                                      (WeeklyDisable === "Don't show Sundays" &&
                                        "weekDisableBtn")
                                    }
                                    id="tbg-btn-1"
                                    value={1}
                                  >
                                    S
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-2" value={2}>
                                    M
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={3}>
                                    T
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={4}>
                                    W
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={5}>
                                    T
                                  </ToggleButton>
                                  <ToggleButton id="tbg-btn-3" value={6}>
                                    F
                                  </ToggleButton>
                                  <ToggleButton
                                    disabled={
                                      WeeklyDisable === "Show only weekdays"
                                        ? true
                                        : false
                                    }
                                    id="tbg-btn-3"
                                    value={7}
                                  >
                                    S
                                  </ToggleButton>
                                </ToggleButtonGroup>

                                {selectdayError && (
                                  <p className="errormessage">
                                    Please select atleast a day
                                  </p>
                                )}
                              </Div>
                            )}

                            {repvalue !== "" &&
                              repvalue !== undefined &&
                              repvalue !== null &&
                              repvalue !== "Does not repeat" &&
                              repvalue !== "Does not repeat " && (
                                <Div
                                  margin=" 0px 0px 10px 40px"
                                  dis="flex"
                                  style={{
                                    flexDirection:
                                      repvalue === "Daily" ? "column" : "row",
                                    alignItems:
                                      repvalue === "Daily"
                                        ? "flex-start"
                                        : "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginLeft:
                                        repvalue === "Daily" ? "0px" : "0px",
                                      marginRight: "10px",
                                      color: "#000000",
                                      marginBottom:
                                        repvalue === "Daily" ? "5px" : "0px",
                                      fontFamily: "Inter, sans-serif",
                                    }}
                                  >
                                    Until:
                                  </span>
                                  <Div position="relative">
                                    <DatePicker
                                      getPopupContainer={(triggerNode) =>
                                        (triggerNode &&
                                          triggerNode.closest &&
                                          triggerNode.closest(
                                            ".ant-tabs-content-holder",
                                          )) ||
                                        document.getElementById("new-appts") ||
                                        document.body
                                      }
                                      disabledDate={(current) => {
                                        const oneYearFromNow = moment()
                                          .add(1, "year")
                                          .startOf("day");
                                        return (
                                          current.isBefore(
                                            moment(aptdate, dtFormat),
                                            "day",
                                          ) ||
                                          current.isAfter(oneYearFromNow, "day")
                                        );
                                      }}
                                      onChange={(date) => {
                                        if (date) {
                                          setLastdateApp(
                                            moment(date).format(dtFormat),
                                          );
                                        } else {
                                          setLastdateApp(
                                            moment().format(dtFormat),
                                          );
                                        }
                                      }}
                                      placeholder="From-"
                                      format={dtFormat}
                                      onSelect={clearSelectActiveFocus}
                                      value={
                                        lastdateApp
                                          ? moment(lastdateApp, dtFormat)
                                          : null
                                      }
                                      allowClear={false}
                                    />
                                  </Div>
                                </Div>
                              )}
                          </div>

                          <div>
                            <Div className=" w-100 m_b_12">
                              <Div
                                className="wholediv"
                              // className="alx p-r-20"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <PersonOutline />
                                </Div>
                                <Div className="dropdiv" id="ProfId">
                                  <Select
                                    virtual={false}
                                    className={
                                      profileError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    showSearch
                                    placeholder="Appt Profile"
                                    id="new-app-profile_1 appt-inp-profsrch"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    onChange={(e, data) =>
                                      handleDropDownSelect(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={profileid ? profileid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                  // dropdownStyle={{
                                  //   zIndex: 1050,
                                  // }}
                                  >
                                    {getFilteredAndSortedProfiles(
                                      sourceprofile,
                                      changeTab === "3" ||
                                      props.isGroupAppointment,
                                    ).map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>

                                  {profileError && (
                                    <p className="errormessage">
                                      Please select Appointment Profile
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className="new_app_date">
                              <Div className="access_icon">
                                <AccessTimeIcon className="people" />
                              </Div>
                              <form
                                className={`${classes.container} frm-apoint`}
                                noValidate
                              >
                                <div
                                  id="crt_appt-time-ok"
                                  className="date-pick date-pick-parent app-datepick"
                                >
                                  <DatePicker
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    style={{
                                      width: "102px",
                                      marginLeft: "-7px",
                                    }}
                                    onChange={(date) => {
                                      if (date) {
                                        setaptdate(
                                          moment(date).format(dtFormat),
                                        );
                                      } else {
                                        setaptdate(moment().format(dtFormat));
                                      }
                                    }}
                                    placeholder="Select date"
                                    format={dtFormat}
                                    onSelect={clearSelectActiveFocus}
                                    value={
                                      aptdate ? moment(aptdate, dtFormat) : null
                                    }
                                    allowClear={false}
                                    disabledDate={(current) => {
                                      const oneYearFromNow = moment()
                                        .add(1, "year")
                                        .startOf("day");
                                      if (
                                        repvalue === "Week" ||
                                        repvalue === "Daily"
                                      ) {
                                        const untildateblock = moment(
                                          lastdateApp,
                                          dtFormat,
                                        ).startOf("day");
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          current.isAfter(
                                            untildateblock,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      } else {
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      }
                                    }}
                                  />

                                  <div className="App-time ">
                                    <div
                                      className="showTime"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: "78px",
                                          marginRight: "2px",
                                        }}
                                      >
                                        <input
                                          className="fromTime-toTime-start"
                                          onClick={() => {
                                            handleFromTime();
                                          }}
                                          onMouseLeave={() => {
                                            setTempOpen(false);
                                          }}
                                          style={{
                                            border:
                                              timeMismatch || inTimeErr
                                                ? "1px solid red"
                                                : "",
                                            width: "64px",
                                            fontWeight: "400",
                                            paddingRight: "0px",
                                            paddingLeft: "0px",
                                          }}
                                          value={inTime}
                                          onChange={(e) => {
                                            if (
                                              !regexFirstNum.test(
                                                e.target.value,
                                              )
                                            ) {
                                              setFromShow(false);
                                              setToShow(false);
                                              setInTime(e.target.value);
                                              setTimeMismatch(false);
                                              setTimeout(() => {
                                                setInTime(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                );

                                                onChange(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                  "inTime",
                                                );
                                              }, 4000);
                                            }
                                          }}
                                          onBlur={(e) => {
                                            setTimeMismatch(false);
                                            setInTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );
                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "inTime",
                                            );
                                          }}
                                        />

                                        <FiChevronDown
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleFromTime();
                                          }}
                                          style={{
                                            marginLeft: "2px",
                                            color: "#808080",
                                            fontSize: "12px",
                                            flexShrink: 0,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>

                                      <p
                                        className="time--space"
                                        style={{ margin: "0 2px" }}
                                      >
                                        -
                                      </p>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: "78px",
                                        }}
                                      >
                                        <input
                                          className="fromTime-toTime"
                                          onClick={() => {
                                            handleToTime();
                                          }}
                                          style={{
                                            border:
                                              timeMismatch || inTimeErr
                                                ? "1px solid red"
                                                : "",
                                            width: "64px",
                                            fontWeight: "400",
                                            paddingRight: "0px",
                                            paddingLeft: "0px",
                                          }}
                                          onChange={(e) => {
                                            if (
                                              !regexFirstNum.test(
                                                e.target.value,
                                              )
                                            ) {
                                              setFromShow(false);
                                              setToShow(false);
                                              setOutTime(e.target.value);
                                              setTimeMismatch(false);
                                              setTimeout(() => {
                                                setOutTime(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                );

                                                onChange(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                  "outTime",
                                                );
                                              }, 4000);
                                            }
                                          }}
                                          onMouseLeave={() => {
                                            setTempOpen(false);
                                          }}
                                          onBlur={(e) => {
                                            setTimeMismatch(false);
                                            setOutTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );
                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "outTime",
                                            );
                                          }}
                                          value={outTime}
                                        />

                                        <FiChevronDown
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleToTime();
                                          }}
                                          style={{
                                            marginLeft: "2px",
                                            color: "#808080",
                                            fontSize: "12px",
                                            flexShrink: 0,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div
                                      className={
                                        fromShow
                                          ? "fromArray-toArray"
                                          : "fromArray_hide"
                                      }
                                    >
                                      {frtimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            key={item.id}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            disabled={disabledFromTimes(
                                              item.time,
                                              item.meridiem,
                                              Appttype,
                                            )}
                                            onClick={async (e) => {
                                              setTimeMismatch(false);
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );
                                              await setFromId(item.id);
                                              handleFromButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>

                                    <div
                                      className={
                                        toShow
                                          ? "fromArray-toArray"
                                          : "toArray_hide"
                                      }
                                      style={{ left: 70 }}
                                    >
                                      {totimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            disabled={disabledToTime(
                                              item.time,
                                              item.meridiem,
                                              item.id,
                                              Appttype,
                                            )}
                                            key={index}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            onClick={async (e) => {
                                              setTimeMismatch(false);

                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              handleToButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </Div>
                            {!props.isGroupAppointment &&
                              !props.isEditGroupAppointment &&
                              changeTab !== "3" &&
                              patientTimePreview && (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "-14px",
                                    marginBottom: "8px",
                                    paddingRight: "2px",
                                  }}
                                >
                                  <div
                                    title={
                                      patientTimePreview.patient_timezone || ""
                                    }
                                    style={{
                                      maxWidth: "260px",
                                      textAlign: "right",
                                      color: "#4A5568",
                                      fontSize: "12px",
                                      lineHeight: "18px",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {getPatientTimePreviewText()}
                                  </div>
                                </div>
                              )}
                            {(inTimeErr || timeMismatch) && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red err-m-t p-l-40 m-b-6"
                              >
                                Please Select valid Time
                              </Form.Text>
                            )}
                            {timelimiterrorbox && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red p-l-66 m-t-0-imp m-b-3"
                              >
                                Provider Only Available Between {startErrTime}{" "}
                                to {endErrTime}
                              </Form.Text>
                            )}

                            {/* {emptyEmailWarning && videochck && (
                              <Div>
                                <p
                                  className="errormessage"
                                  style={{
                                    marginBottom: "16px",
                                    marginLeft: "-45px",
                                  }}
                                >
                                  &nbsp;address to send the telehealth link.
                                </p>
                              </Div>
                            )} */}

                            <Div style={{ textAlign: "left" }}>
                              <Popup
                                content={fornormalapp}
                                open={normalappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_normal"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>
                            <Div>
                              <Popup
                                content={forteleapp}
                                open={teleappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_tele"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px" size="20px">
                                  <Image
                                    src={doctorLogo}
                                    alt="speciality"
                                    height="20px"
                                    width="20px"
                                  />
                                </Div>

                                <Div className="dropdiv">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    showSearch
                                    placeholder="Select Speciality"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      specialError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(data) => changeSpeciality(data)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={speciality ? speciality : undefined}
                                    optionLabelProp="label"
                                    dropdownClassName="speciality-option"
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sortSpeciality &&
                                      sortSpeciality
                                        .filter(
                                          (item) =>
                                            (storedNames.appt_a ||
                                              item.specialty ===
                                              notDisabledSpec) &&
                                            item.count > 0,
                                        ) // Filter disabled options
                                        .map((item) => (
                                          <Option
                                            key={item.specialty}
                                            value={item.specialty}
                                            title={item.specialty}
                                            disabled={
                                              (!storedNames.appt_a &&
                                                item.specialty !==
                                                notDisabledSpec) ||
                                              item.count === 0
                                            }
                                            id={
                                              !storedNames.appt_a &&
                                                item.specialty !== notDisabledSpec
                                                ? "clr-disable"
                                                : "" || item.count == 0
                                                  ? "clr-disable"
                                                  : ""
                                            }
                                            className={
                                              (!storedNames.appt_a &&
                                                item.speciality !==
                                                notDisabledSpec) ||
                                              item.count === 0
                                            }
                                          >
                                            {item.speciality}
                                          </Option>
                                        ))}
                                  </Select>
                                  {specialError && (
                                    <p className="errormessage">
                                      Select a speciality
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100" id="border">
                              <Div className="wholediv">
                                <Div
                                  className={
                                    repvalue !== "" &&
                                      repvalue !== undefined &&
                                      repvalue !== null &&
                                      repvalue !== "Does not repeat" &&
                                      repvalue !== "Does not repeat "
                                      ? "status_div_Appt"
                                      : ""
                                  }
                                  margin="-20px 0px 0px -2px"
                                >
                                  <LocalHospitalOutlined />
                                </Div>
                                <Div
                                  className={
                                    videochck
                                      ? "dropdiv downDropDown"
                                      : "dropdiv"
                                  }
                                  id="statId"
                                >
                                  <Select
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    virtual={false}
                                    disabled={
                                      repvalue !== "" &&
                                      repvalue !== undefined &&
                                      repvalue !== null &&
                                      repvalue !== "Does not repeat" &&
                                      repvalue !== "Does not repeat "
                                    }
                                    showSearch
                                    placeholder="Status"
                                    id="new-app-status_1 appt-inp-stas"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      statusError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectStatus(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={statusid ? statusid : undefined}
                                    // getPopupContainer={() =>
                                    //   document.getElementById("statId")
                                    // }

                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                  // dropdownStyle={{
                                  //   zIndex: 1050,
                                  // }}
                                  >
                                    {checking1 ? (
                                      <></>
                                    ) : (
                                      <>
                                        {Number(Appttype) === 4 ? (
                                          <>
                                            {sourcestatusphonecall.map((i) => (
                                              <Option
                                                key={i.value}
                                                value={i.value}
                                                title={i.text}
                                              >
                                                {i.text}
                                              </Option>
                                            ))}
                                          </>
                                        ) : videochck ? (
                                          <>
                                            {sourcestatustele.map((i) => (
                                              <Option
                                                key={i.value}
                                                value={i.value}
                                                title={i.text}
                                              >
                                                {i.text}
                                              </Option>
                                            ))}
                                          </>
                                        ) : (
                                          <>
                                            {sourcestatus.map((i) => (
                                              <Option
                                                key={i.value}
                                                value={i.value}
                                                title={i.text}
                                              >
                                                {i.text}
                                              </Option>
                                            ))}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </Select>
                                  {statusError && (
                                    <p className="errormessage">
                                      Please select Status
                                    </p>
                                  )}
                                  {repvalue !== "" &&
                                    repvalue !== undefined &&
                                    repvalue !== null &&
                                    repvalue !== "Does not repeat" &&
                                    repvalue !== "Does not repeat " && (
                                      <p className="errormessage appt_status_err_msg">
                                        Can't edit status while Daily/Weekly
                                        recurring. Select Does not Repeat
                                      </p>
                                    )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv "></Div>

                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px">
                                  <HomeOutlinedIcon />
                                </Div>
                                <Div className="dropdiv" id="ExaId">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    showSearch
                                    placeholder="Exam Room"
                                    id="new-app-profile_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      examroomError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleRoomVal(data.value)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={roomval ? roomval : undefined}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                  // dropdownStyle={{
                                  //   zIndex: 1050,
                                  // }}
                                  >
                                    {sourceroom.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {examroomError && (
                                    <p className="errormessage">
                                      Please select Exam Room
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>
                            {repvalue !== "" &&
                              repvalue !== undefined &&
                              repvalue !== null &&
                              repvalue !== "Does not repeat" &&
                              repvalue !== "Does not repeat " && (
                                <div
                                  style={{
                                    marginTop: "-10px",
                                    marginLeft: "43px",
                                  }}
                                >
                                  <div style={{ width: "94px" }}>
                                    <p
                                      className="remove-bor-mar"
                                      style={{ marginBottom: "4px" }}
                                    >
                                      Duration
                                    </p>
                                    <input
                                      value={serviceDuration}
                                      style={{
                                        width: "100%",
                                        height: "38px",
                                        lineHeight: "38px",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0 10px",
                                        backgroundColor: "#fff",
                                        outline: "none",
                                        color: "#000",
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>

                        <Div
                          display="flex"
                          flexDirection="column"
                          padding="0px 0px 10px 45px"
                        >
                          {(!repvalue ||
                            repvalue === "Does not repeat" ||
                            repvalue === "Does not repeat ") && (
                              <div
                                style={{
                                  display: "flex",
                                  padding: "0px 0px 15px 0px",
                                  alignItems: "flex-end",
                                  justifyContent: "flex-start",
                                  width: "528px",
                                }}
                              >
                                <div style={{ width: "350px" }}>
                                  <p
                                    className="remove-bor-mar"
                                    style={{ marginBottom: "6px" }}
                                  >
                                    Service Code
                                  </p>
                                  <Select
                                    mode="multiple"
                                    showSearch
                                    showArrow
                                    filterOption={false}
                                    virtual={false}
                                    value={individualServiceCode}
                                    placeholder="Select a Service Code"
                                    style={{
                                      width: "100%",
                                      minHeight: "40px",
                                      height: "auto",
                                    }}
                                    size="large"
                                    listHeight={125}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    suffixIcon={
                                      <BsFillCaretDownFill
                                        size={12}
                                        color="#808080"
                                      />
                                    }
                                    // onChange={(value) => {
                                    //   setGroupServiceCode(value);

                                    //   const selectedCodes =
                                    //     serviceCodeOptions.filter((item) =>
                                    //       value.includes(item.code),
                                    //     );

                                    //   let highestDuration = 0;

                                    //   selectedCodes.forEach((item) => {
                                    //     const duration = Number(
                                    //       item.duration || 0,
                                    //     );

                                    //     if (duration > highestDuration) {
                                    //       highestDuration = duration;
                                    //     }
                                    //   });

                                    //   setGroupDuration(
                                    //     highestDuration
                                    //       ? `${highestDuration} mins`
                                    //       : "",
                                    //   );
                                    // }}
                                    onChange={(value) => {
                                      setIndividualServiceCode(value);
                                      setIndividualSearch("");

                                      const highestServiceCodeDuration =
                                        getHighestSelectedServiceCodeDuration(
                                          value,
                                        );
                                      const defaultDuration =
                                        getBaseAppointmentDuration();
                                      const finalDuration = Math.max(
                                        highestServiceCodeDuration,
                                        defaultDuration,
                                      );

                                      setIndividualDuration(
                                        `${finalDuration} mins`,
                                      );
                                      updateEndTimeFromDuration(finalDuration);
                                    }}
                                    onSearch={(value) => {
                                      setIndividualSearch(value);
                                    }}
                                  >
                                    {serviceCodeOptions.map((item) => (
                                      <Option
                                        key={item.code}
                                        value={item.code}
                                        title={item.title}
                                      >
                                        {item.title}
                                      </Option>
                                    ))}
                                  </Select>
                                </div>

                                <div
                                  style={{ width: "94px", marginLeft: "34px" }}
                                >
                                  <p
                                    className="remove-bor-mar"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    Duration
                                  </p>
                                  <div
                                    onClick={(e) => {
                                      const inp =
                                        e.currentTarget.querySelector("input");
                                      if (inp) inp.focus();
                                    }}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "100%",
                                      height: "38px",
                                      border: "1px solid #d9d9d9",
                                      borderRadius: "4px",
                                      padding: "0 10px",
                                      backgroundColor: "#fff",
                                      cursor: "text",
                                    }}
                                  >
                                    <input
                                      maxLength={3}
                                      value={
                                        individualDuration
                                          ? String(individualDuration).replace(
                                            /\D/g,
                                            "",
                                          )
                                          : ""
                                      }
                                      onChange={(e) => {
                                        const raw = e.target.value.replace(
                                          /\D/g,
                                          "",
                                        );
                                        if (raw.length > 3) return;
                                        setIndividualDuration(
                                          raw ? `${raw} mins` : "",
                                        );

                                        const parsedMinutes = parseInt(raw, 10);
                                        if (
                                          !isNaN(parsedMinutes) &&
                                          parsedMinutes > 0
                                        ) {
                                          updateEndTimeFromDuration(
                                            parsedMinutes,
                                          );
                                        }
                                      }}
                                      style={{
                                        border: "none",
                                        outline: "none",
                                        width: `${Math.max(2, individualDuration ? String(individualDuration).replace(/\D/g, "").length : 0)}ch`,
                                        padding: 0,
                                        color: "inherit",
                                        backgroundColor: "transparent",
                                        fontSize: "inherit",
                                        fontFamily: "inherit",
                                      }}
                                    />
                                    <span
                                      style={{
                                        color: "inherit",
                                        fontSize: "inherit",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      mins
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}

                          <p
                            className="remove-bor-mar"
                            style={{ marginBottom: "6px" }}
                          >
                            Reason
                          </p>
                          {ENABLE_REASON_DROPDOWN ? (
                            <Select
                              value={reason || undefined}
                              onChange={(value) => setReason(value)}
                              style={{
                                width: "528px",
                                minWidth: "528px",
                                maxWidth: "528px",
                              }}
                              placeholder="Select Reason"
                              suffixIcon={
                                <BsFillCaretDownFill
                                  size={12}
                                  color="#808080"
                                />
                              }
                              onSelect={clearSelectActiveFocus}
                              getPopupContainer={(triggerNode) =>
                                (triggerNode &&
                                  triggerNode.closest &&
                                  triggerNode.closest(
                                    ".ant-tabs-content-holder",
                                  )) ||
                                document.getElementById("new-appts") ||
                                document.body
                              }
                            >
                              {reasonOptions.map((item) => (
                                <Option key={item} value={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          ) : (
                            <InputSchedule
                              maxLength={200}
                              width="528px"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          )}

                          {!ENABLE_REASON_DROPDOWN && (
                            <p
                              className="remove-bor-mar-reason"
                              style={{
                                color:
                                  reason && reason.length >= 200
                                    ? "red"
                                    : "inherit",
                                width: "528px",
                                margin: "4px 0 0 0",
                              }}
                            >
                              <div style={{ textAlign: "right" }}>
                                Maximum of 200 characters
                              </div>
                            </p>
                          )}
                        </Div>

                        {renderAppointmentNotification()}
                      </Form.Row>
                    </Div>
                  </TabPane>

                  <TabPane
                    tab="New Group Appointment"
                    key="3"
                    className="appt-dash-hed p_l_10"
                  >
                    <Div className="c-pop-one " margin="20px 0px 0px -20px">
                      <Form.Row className="app-block  antd-select-height1">
                        {accountType > "0" || (accountType === "0" && trial) ? (
                          <>
                            {patFlag.map((item, ind) => (
                              <Div
                                key={ind}
                                className="new_appt_flag pt-fg-app-new"
                                style={{ backgroundColor: item.flag_color }}
                              >
                                {/* <IoFlagOutline className="new_appt_flag_icon" />
                                <span className="new_appt_flag_amt">
                                  {`${item.flag_name} : ${item.description}`} */}
                                <div
                                  className="app_pro_text_wrap new_app_flag"
                                  title={item.flag_name}
                                >
                                  {" "}
                                  <IoFlagOutline
                                    className="new_appt_flag_icon"
                                    style={{ marginRight: "5px" }}
                                  />
                                  {item.flag_name}
                                </div>
                                {/* </span> */}
                              </Div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                        <div className="d_flex">
                          <div className="m_l_10">
                            <Div
                              alignItems="center"
                              className="search-pat  wholediv patient_name_out patient_name_filter"
                            >
                              <Div margin="-20px 0px 0px -2px">
                                <PeopleOutline className="people" />
                              </Div>
                              <Div className="dropdiv" id="GroupPatient">
                                <Select
                                  className={
                                    groupPatError
                                      ? "err_mess_border w-100 b1"
                                      : "w-100"
                                  }
                                  placeholder="Group Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  onSelect={clearSelectActiveFocus}
                                  showSearch
                                  filterOption={false}
                                  loading={loading}
                                  value={groupId}
                                  getPopupContainer={(triggerNode) =>
                                    (triggerNode &&
                                      triggerNode.closest &&
                                      triggerNode.closest(
                                        ".ant-tabs-content-holder",
                                      )) ||
                                    document.getElementById("new-appts") ||
                                    document.body
                                  }
                                  onSearch={handleGroupSearch}
                                  onChange={(value) => {
                                    setGroupPatError(false);
                                    setGroupId(value);
                                  }}
                                  notFoundContent={
                                    loading ? "Loading..." : "No Group Found"
                                  }
                                  dropdownRender={(menu) => (
                                    <>
                                      {menu}
                                      <div
                                        style={{
                                          borderTop: "1px solid #eaeaea",
                                          padding: "8px 12px",
                                          cursor: "pointer",
                                          color: "#1677ff",
                                          fontWeight: 500,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => handleOpenGroupModal()}
                                      >
                                        + Add Patient Group
                                      </div>
                                    </>
                                  )}
                                >
                                  {groupPatients.map((group) => (
                                    <Select.Option
                                      key={group.value}
                                      value={group.value}
                                    >
                                      {group.label}
                                    </Select.Option>
                                  ))}
                                </Select>
                                {groupPatError && (
                                  <p className="errormessage">
                                    Please Select Group
                                  </p>
                                )}
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="appointment_poup_div appointment_poup_div_w"
                            >
                              <Div
                                id="new_appt_radio"
                                className="appt-spn-vdovis new_app_radio_group"
                              >
                                <Radio.Group
                                  onChange={
                                    accountType === "-1" ||
                                      (accountType === "1" && teleFlag === "0")
                                      ? (e) => {
                                        if (Number(e.target.value) === 2) {
                                          setUpgrade(true);
                                        } else {
                                          onChangeRadio(e);
                                        }
                                      }
                                      : onChangeRadio
                                  }
                                  value={
                                    walkincheck
                                      ? 3
                                      : forteleornor === 2
                                        ? forteleornor
                                        : Appttype
                                  }
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    rowGap: "10px",
                                  }}
                                >
                                  <Radio
                                    className="radio_appt_btn"
                                    value={1}
                                    onChange={checkapt}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 2 || videochck)
                                    }
                                  >
                                    Appointment
                                  </Radio>

                                  <Radio
                                    className="app-dashboard-radioBut m-0"
                                    onClick={walkinclick}
                                    value={3}
                                    // disabled={videochck}
                                    id="new-app-walkin"
                                  >
                                    Walk-in
                                  </Radio>

                                  <Radio
                                    value={2}
                                    onChange={checkvideovisit}
                                    disabled={
                                      allowAppt !== 3 &&
                                      (allowAppt === 1 || !videochck)
                                    }
                                  >
                                    Telehealth
                                  </Radio>

                                </Radio.Group>
                              </Div>
                            </Div>

                            <Div margin="13px 0 0 0">
                              <Div
                                alignItems="center"
                                className=" alx wholediv new_app_facility"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <RoomOutlined />
                                </Div>
                                <Div className="dropdiv" id="officeId">
                                  <Select
                                    virtual={false}
                                    showSearch
                                    placeholder="Hospital Name"
                                    id="new-app-facility_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      officeError
                                        ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                          "classname",
                                        )}`
                                        : `to-hide-ant-label w-100 ${checkFacility(
                                          "classname",
                                        )}`
                                    }
                                    onChange={(e, data) =>
                                      handleDropDownSelectOffice(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={officeid ? officeid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: 1,
                                        adjustY: 0,
                                      },
                                    }}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sourceoffice.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {checkFacility("spinner")}
                                  {officeError && (
                                    <p className="errormessage">
                                      Please select Office
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div
                              alignItems="center"
                              className="search-pat new_app_select_prov appointment_patient_div"
                            >
                              <Div margin="-2px 0px 0px -2px">
                                <PeopleOutline />
                              </Div>
                              <Div className="appointment_drop_div" id="provId">
                                <Select
                                  // virtual={false}
                                  showSearch
                                  placeholder="Doctor Name"
                                  suffixIcon={<BsFillCaretDownFill />}
                                  onSelect={clearSelectActiveFocus}
                                  id="new-app-provider new-app-provider_1"
                                  className={
                                    provError
                                      ? "err_mess_border w-100 "
                                      : "w-100"
                                  }
                                  onChange={(e, data) => {
                                    if (storedNames.appt_a1_viewOnly) {
                                      alert("You only have view-only access.");
                                    } else {
                                      handleDropDownSelectProvider(e, data);
                                    }
                                  }}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.title ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  value={providerid ? providerid : undefined}
                                  getPopupContainer={(triggerNode) =>
                                    (triggerNode &&
                                      triggerNode.closest &&
                                      triggerNode.closest(
                                        ".ant-tabs-content-holder",
                                      )) ||
                                    document.getElementById("new-appts") ||
                                    document.body
                                  }
                                // getPopupContainer={() =>
                                //   document.getElementById("provId")
                                // }
                                >
                                  {sourceprovider.map((i) => (
                                    <Option
                                      key={i.value}
                                      value={String(i.value)}
                                      title={i.text}
                                      disabled={storedNames.appt_a1_viewOnly}
                                    >
                                      {i.text}
                                    </Option>
                                  ))}
                                </Select>
                                {provError && (
                                  <p className="errormessage">
                                    Please select Provider
                                  </p>
                                )}
                              </Div>
                            </Div>
                          </div>

                          <div>
                            <Div className=" w-100 m_b_12">
                              <Div
                                className="wholediv"
                              // className="alx p-r-20"
                              >
                                <Div margin="-20px 0px 0px -2px">
                                  <PersonOutline />
                                </Div>
                                <Div className="dropdiv" id="ProfId">
                                  <Select
                                    virtual={false}
                                    className={
                                      profileError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    showSearch
                                    placeholder="Appt Profile"
                                    id="new-app-profile_1 appt-inp-profsrch"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    onChange={(e, data) =>
                                      handleDropDownSelect(e, data)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={profileid ? profileid : undefined}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                  // dropdownStyle={{
                                  //   zIndex: 1050,
                                  // }}
                                  >
                                    {getFilteredAndSortedProfiles(
                                      sourceprofile,
                                      changeTab === "3" ||
                                      props.isGroupAppointment,
                                    ).map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>

                                  {profileError && (
                                    <p className="errormessage">
                                      Please select Appointment Profile
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className="new_app_date">
                              <Div className="access_icon">
                                <AccessTimeIcon className="people" />
                              </Div>
                              <form
                                className={`${classes.container} frm-apoint`}
                                noValidate
                              >
                                <div
                                  id="crt_appt-time-ok"
                                  className="date-pick date-pick-parent app-datepick"
                                >
                                  <DatePicker
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    style={{
                                      width: "102px",
                                      marginLeft: "-7px",
                                    }}
                                    onChange={(date) => {
                                      if (date) {
                                        setaptdate(
                                          moment(date).format(dtFormat),
                                        );
                                      } else {
                                        setaptdate(moment().format(dtFormat));
                                      }
                                    }}
                                    placeholder="Select date"
                                    format={dtFormat}
                                    onSelect={clearSelectActiveFocus}
                                    value={
                                      aptdate ? moment(aptdate, dtFormat) : null
                                    }
                                    allowClear={false}
                                    disabledDate={(current) => {
                                      const oneYearFromNow = moment()
                                        .add(1, "year")
                                        .startOf("day");
                                      if (
                                        repvalue === "Week" ||
                                        repvalue === "Daily"
                                      ) {
                                        const untildateblock = moment(
                                          lastdateApp,
                                          dtFormat,
                                        ).startOf("day");
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          current.isAfter(
                                            untildateblock,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      } else {
                                        return (
                                          current.isAfter(
                                            oneYearFromNow,
                                            "day",
                                          ) ||
                                          (Appttype == 2 &&
                                            current < moment().startOf("day"))
                                        );
                                      }
                                    }}
                                  />

                                  <div className="App-time ">
                                    <div
                                      className="showTime"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: "78px",
                                          marginRight: "2px",
                                        }}
                                      >
                                        <input
                                          className="fromTime-toTime-start"
                                          onClick={() => {
                                            handleFromTime();
                                          }}
                                          onMouseLeave={() => {
                                            setTempOpen(false);
                                          }}
                                          style={{
                                            border:
                                              timeMismatch || inTimeErr
                                                ? "1px solid red"
                                                : "",
                                            width: "64px",
                                            fontWeight: "400",
                                            paddingRight: "0px",
                                            paddingLeft: "0px",
                                          }}
                                          value={inTime}
                                          onChange={(e) => {
                                            if (
                                              !regexFirstNum.test(
                                                e.target.value,
                                              )
                                            ) {
                                              setFromShow(false);
                                              setToShow(false);
                                              setInTime(e.target.value);
                                              setTimeMismatch(false);
                                              setTimeout(() => {
                                                setInTime(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                );

                                                onChange(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                  "inTime",
                                                );
                                              }, 4000);
                                            }
                                          }}
                                          onBlur={(e) => {
                                            setTimeMismatch(false);
                                            setInTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );
                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "inTime",
                                            );
                                          }}
                                        />

                                        <FiChevronDown
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleFromTime();
                                          }}
                                          style={{
                                            marginLeft: "2px",
                                            color: "#808080",
                                            fontSize: "12px",
                                            flexShrink: 0,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>

                                      <p
                                        className="time--space"
                                        style={{ margin: "0 2px" }}
                                      >
                                        -
                                      </p>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          width: "78px",
                                        }}
                                      >
                                        <input
                                          className="fromTime-toTime"
                                          onClick={() => {
                                            handleToTime();
                                          }}
                                          style={{
                                            border:
                                              timeMismatch || inTimeErr
                                                ? "1px solid red"
                                                : "",
                                            width: "64px",
                                            fontWeight: "400",
                                            paddingRight: "0px",
                                            paddingLeft: "0px",
                                          }}
                                          onChange={(e) => {
                                            if (
                                              !regexFirstNum.test(
                                                e.target.value,
                                              )
                                            ) {
                                              setFromShow(false);
                                              setToShow(false);
                                              setOutTime(e.target.value);
                                              setTimeMismatch(false);
                                              setTimeout(() => {
                                                setOutTime(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                );

                                                onChange(
                                                  moment(
                                                    e.target.value,
                                                    "h:mm A",
                                                  ).format("h:mm A"),
                                                  "outTime",
                                                );
                                              }, 4000);
                                            }
                                          }}
                                          onMouseLeave={() => {
                                            setTempOpen(false);
                                          }}
                                          onBlur={(e) => {
                                            setTimeMismatch(false);
                                            setOutTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );
                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "outTime",
                                            );
                                          }}
                                          value={outTime}
                                        />

                                        <FiChevronDown
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleToTime();
                                          }}
                                          style={{
                                            marginLeft: "2px",
                                            color: "#808080",
                                            fontSize: "12px",
                                            flexShrink: 0,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div
                                      className={
                                        fromShow
                                          ? "fromArray-toArray"
                                          : "fromArray_hide"
                                      }
                                    >
                                      {frtimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            key={item.id}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            disabled={disabledFromTimes(
                                              item.time,
                                              item.meridiem,
                                              Appttype,
                                            )}
                                            onClick={async (e) => {
                                              setTimeMismatch(false);
                                              setInTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );
                                              await setFromId(item.id);
                                              handleFromButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "inTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>

                                    <div
                                      className={
                                        toShow
                                          ? "fromArray-toArray"
                                          : "toArray_hide"
                                      }
                                      style={{ left: 70 }}
                                    >
                                      {totimeSlots.map((item, index) => {
                                        return (
                                          <button
                                            disabled={disabledToTime(
                                              item.time,
                                              item.meridiem,
                                              item.id,
                                              Appttype,
                                            )}
                                            key={index}
                                            value={
                                              item.time + " " + item.meridiem
                                            }
                                            onClick={async (e) => {
                                              setTimeMismatch(false);

                                              setOutTime(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                              );

                                              handleToButton(e);
                                              onChange(
                                                moment(
                                                  e.target.value,
                                                  "h:mm A",
                                                ).format("h:mm A"),
                                                "outTime",
                                              );
                                            }}
                                          >
                                            {item.time + " " + item.meridiem}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </Div>
                            {(inTimeErr || timeMismatch) && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red err-m-t p-l-40 m-b-6"
                              >
                                Please Select valid Time
                              </Form.Text>
                            )}
                            {timelimiterrorbox && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                className="colour-red p-l-66 m-t-0-imp m-b-3"
                              >
                                Provider Only Available Between {startErrTime}{" "}
                                to {endErrTime}
                              </Form.Text>
                            )}

                            <Div style={{ textAlign: "left" }}>
                              <Popup
                                content={fornormalapp}
                                open={normalappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_normal"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>
                            <Div>
                              <Popup
                                content={forteleapp}
                                open={teleappointment}
                                trigger={
                                  <Button
                                    id="click_event_app_tele"
                                    content="Button"
                                  />
                                }
                                position="left center"
                              />
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px" size="20px">
                                  <Image
                                    src={doctorLogo}
                                    alt="speciality"
                                    height="20px"
                                    width="20px"
                                  />
                                </Div>

                                <Div className="dropdiv">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    showSearch
                                    placeholder="Select Speciality"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      specialError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(data) => changeSpeciality(data)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={speciality ? speciality : undefined}
                                    optionLabelProp="label"
                                    dropdownClassName="speciality-option"
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                  >
                                    {sortSpeciality &&
                                      sortSpeciality
                                        .filter(
                                          (item) =>
                                            (storedNames.appt_a ||
                                              item.specialty ===
                                              notDisabledSpec) &&
                                            item.count > 0,
                                        )
                                        .map((item) => (
                                          <Option
                                            key={item.specialty}
                                            value={item.specialty}
                                            title={item.specialty}
                                            disabled={
                                              (!storedNames.appt_a &&
                                                item.specialty !==
                                                notDisabledSpec) ||
                                              item.count === 0
                                            }
                                            id={
                                              !storedNames.appt_a &&
                                                item.specialty !== notDisabledSpec
                                                ? "clr-disable"
                                                : "" || item.count == 0
                                                  ? "clr-disable"
                                                  : ""
                                            }
                                            className={
                                              (!storedNames.appt_a &&
                                                item.speciality !==
                                                notDisabledSpec) ||
                                              item.count === 0
                                            }
                                          >
                                            {item.speciality}
                                          </Option>
                                        ))}
                                  </Select>
                                  {specialError && (
                                    <p className="errormessage">
                                      Select a speciality
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>

                            <Div className=" w-100">
                              <Div className="wholediv "></Div>

                              <Div className="wholediv">
                                <Div margin="-20px 0px 0px -2px">
                                  <HomeOutlinedIcon />
                                </Div>
                                <Div className="dropdiv" id="ExaId">
                                  <Select
                                    virtual={false}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    showSearch
                                    placeholder="Exam Room"
                                    id="new-app-profile_1"
                                    suffixIcon={<BsFillCaretDownFill />}
                                    onSelect={clearSelectActiveFocus}
                                    className={
                                      examroomError
                                        ? "err_mess_border w-100"
                                        : "w-100"
                                    }
                                    onChange={(e, data) =>
                                      handleRoomVal(data.value)
                                    }
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.title ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    value={roomval ? roomval : undefined}
                                    dropdownStyle={{
                                      maxHeight: "200px",
                                    }}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                  // dropdownStyle={{
                                  //   zIndex: 1050,
                                  // }}
                                  >
                                    {sourceroom.map((i) => (
                                      <Option
                                        key={i.value}
                                        value={i.value}
                                        title={i.text}
                                      >
                                        {i.text}
                                      </Option>
                                    ))}
                                  </Select>
                                  {examroomError && (
                                    <p className="errormessage">
                                      Please select Exam Room
                                    </p>
                                  )}
                                </Div>
                              </Div>
                            </Div>
                            {repvalue !== "" &&
                              repvalue !== undefined &&
                              repvalue !== null &&
                              repvalue !== "Does not repeat" &&
                              repvalue !== "Does not repeat " && (
                                <div
                                  style={{
                                    marginTop: "10px",
                                    marginLeft: "43px",
                                  }}
                                >
                                  <div style={{ width: "94px" }}>
                                    <p
                                      className="remove-bor-mar"
                                      style={{ marginBottom: "4px" }}
                                    >
                                      Duration
                                    </p>
                                    <input
                                      value={serviceDuration}
                                      style={{
                                        width: "100%",
                                        height: "38px",
                                        lineHeight: "38px",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "4px",
                                        padding: "0 10px",
                                        backgroundColor: "#fff",
                                        outline: "none",
                                        color: "#000",
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                        {/* <Div display="flex" padding="0px 0px 10px 45px">
                          <p className="remove-bor-mar">Reason</p>
                          {ENABLE_REASON_DROPDOWN ? (
                            <Select
                              value={reason || undefined}
                              onChange={(value) => setReason(value)}
                              style={{
                                width: "528px",
                                minWidth: "528px",
                                maxWidth: "528px",
                              }}
                              placeholder="Select Reason"
                              suffixIcon={
                                <BsFillCaretDownFill
                                  size={12}
                                  color="#808080"
                                />
                              }
                              onSelect={clearSelectActiveFocus}
                              getPopupContainer={(triggerNode) => (triggerNode && triggerNode.closest && triggerNode.closest(".ant-tabs-content-holder")) || document.getElementById("new-appts") || document.body}
                            >
                              {reasonOptions.map((item) => (
                                <Option key={item} value={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          ) : (
                            <InputSchedule
                              maxLength={200}
                              width="528px"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          )}
                          {!ENABLE_REASON_DROPDOWN && (
                            <p
                              className="remove-bor-mar-reason"
                              style={{
                                color:
                                  reason && reason.length >= 200
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              Maximum of 200 characters
                            </p>
                          )}
                        </Div> */}

                        <Div
                          display="flex"
                          flexDirection="column"
                          padding="0px 0px 10px 45px"
                        >
                          {(!repvalue ||
                            repvalue === "Does not repeat" ||
                            repvalue === "Does not repeat ") && (
                              <div
                                style={{
                                  display: "flex",
                                  padding: "0px 0px 15px 0px",
                                  alignItems: "flex-end",
                                  justifyContent: "flex-start",
                                  width: "528px",
                                }}
                              >
                                <div style={{ width: "350px" }}>
                                  <p
                                    className="remove-bor-mar"
                                    style={{ marginBottom: "6px" }}
                                  >
                                    Service Code
                                  </p>
                                  <Select
                                    mode="multiple"
                                    showSearch
                                    showArrow
                                    filterOption={false}
                                    virtual={false}
                                    value={groupServiceCode}
                                    placeholder="Select a Service Code"
                                    style={{
                                      width: "100%",
                                      minHeight: "40px",
                                      height: "auto",
                                    }}
                                    size="large"
                                    listHeight={125}
                                    dropdownAlign={{
                                      points: ["tl", "bl"],
                                      offset: [0, 4],
                                      overflow: {
                                        adjustX: true,
                                        adjustY: false,
                                      },
                                    }}
                                    getPopupContainer={(triggerNode) =>
                                      (triggerNode &&
                                        triggerNode.closest &&
                                        triggerNode.closest(
                                          ".ant-tabs-content-holder",
                                        )) ||
                                      document.getElementById("new-appts") ||
                                      document.body
                                    }
                                    suffixIcon={
                                      <BsFillCaretDownFill
                                        size={12}
                                        color="#808080"
                                      />
                                    }
                                    // onChange={(value) => {
                                    //   setGroupServiceCode(value);

                                    //   const selectedCodes =
                                    //     serviceCodeOptions.filter((item) =>
                                    //       value.includes(item.code),
                                    //     );

                                    //   let highestDuration = 0;

                                    //   selectedCodes.forEach((item) => {
                                    //     const duration = Number(
                                    //       item.duration || 0,
                                    //     );

                                    //     if (duration > highestDuration) {
                                    //       highestDuration = duration;
                                    //     }
                                    //   });

                                    //   setGroupDuration(
                                    //     highestDuration
                                    //       ? `${highestDuration} mins`
                                    //       : "",
                                    //   );
                                    // }}
                                    onChange={(value) => {
                                      setGroupServiceCode(value);
                                      setGroupSearch("");

                                      const highestServiceCodeDuration =
                                        getHighestSelectedServiceCodeDuration(
                                          value,
                                        );
                                      const defaultDuration =
                                        getBaseAppointmentDuration();
                                      const finalDuration = Math.max(
                                        highestServiceCodeDuration,
                                        defaultDuration,
                                      );

                                      setGroupDuration(`${finalDuration} mins`);
                                      updateEndTimeFromDuration(finalDuration);
                                    }}
                                    onSearch={(value) => {
                                      setGroupSearch(value);
                                    }}
                                  >
                                    {serviceCodeOptions.map((item) => (
                                      <Option
                                        key={item.code}
                                        value={item.code}
                                        title={item.title}
                                      >
                                        {item.title}
                                      </Option>
                                    ))}
                                  </Select>
                                </div>

                                <div
                                  style={{ width: "94px", marginLeft: "34px" }}
                                >
                                  <p
                                    className="remove-bor-mar"
                                    style={{ marginBottom: "10px" }}
                                  >
                                    Duration
                                  </p>
                                  <div
                                    onClick={(e) => {
                                      const inp =
                                        e.currentTarget.querySelector("input");
                                      if (inp) inp.focus();
                                    }}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "100%",
                                      height: "38px",
                                      border: "1px solid #d9d9d9",
                                      borderRadius: "4px",
                                      padding: "0 10px",
                                      backgroundColor: "#fff",
                                      cursor: "text",
                                    }}
                                  >
                                    <input
                                      maxLength={3}
                                      value={
                                        groupDuration
                                          ? String(groupDuration).replace(
                                            /\D/g,
                                            "",
                                          )
                                          : ""
                                      }
                                      onChange={(e) => {
                                        const raw = e.target.value.replace(
                                          /\D/g,
                                          "",
                                        );
                                        if (raw.length > 3) return;
                                        setGroupDuration(
                                          raw ? `${raw} mins` : "",
                                        );

                                        const parsedMinutes = parseInt(raw, 10);
                                        if (
                                          !isNaN(parsedMinutes) &&
                                          parsedMinutes > 0
                                        ) {
                                          updateEndTimeFromDuration(
                                            parsedMinutes,
                                          );
                                        }
                                      }}
                                      style={{
                                        border: "none",
                                        outline: "none",
                                        width: `${Math.max(2, groupDuration ? String(groupDuration).replace(/\D/g, "").length : 0)}ch`,
                                        padding: 0,
                                        color: "inherit",
                                        backgroundColor: "transparent",
                                        fontSize: "inherit",
                                        fontFamily: "inherit",
                                      }}
                                    />
                                    <span
                                      style={{
                                        color: "inherit",
                                        fontSize: "inherit",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      mins
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}

                          <p
                            className="remove-bor-mar"
                            style={{ marginBottom: "6px" }}
                          >
                            Reason
                          </p>
                          {ENABLE_REASON_DROPDOWN ? (
                            <Select
                              value={reason || undefined}
                              onChange={(value) => setReason(value)}
                              style={{
                                width: "528px",
                                minWidth: "528px",
                                maxWidth: "528px",
                              }}
                              placeholder="Select Reason"
                              suffixIcon={
                                <BsFillCaretDownFill
                                  size={12}
                                  color="#808080"
                                />
                              }
                              onSelect={clearSelectActiveFocus}
                              getPopupContainer={(triggerNode) =>
                                (triggerNode &&
                                  triggerNode.closest &&
                                  triggerNode.closest(
                                    ".ant-tabs-content-holder",
                                  )) ||
                                document.getElementById("new-appts") ||
                                document.body
                              }
                            >
                              {reasonOptions.map((item) => (
                                <Option key={item} value={item}>
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          ) : (
                            <InputSchedule
                              maxLength={200}
                              width="528px"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          )}

                          {!ENABLE_REASON_DROPDOWN && (
                            <p
                              className="remove-bor-mar-reason"
                              style={{
                                color:
                                  reason && reason.length >= 200
                                    ? "red"
                                    : "inherit",
                                width: "528px",
                                margin: "4px 0 0 0",
                              }}
                            >
                              <div style={{ textAlign: "right" }}>
                                Maximum of 200 characters
                              </div>
                            </p>
                          )}
                        </Div>
                      </Form.Row>
                    </Div>
                  </TabPane>

                  <TabPane
                    tab="Add Availability"
                    key="2"
                    className="appt-dash-hed"
                  >
                    <Div padding="10px 0px" className="avl">
                      <Div>
                        <p>
                          By default, provider availability is set to "In
                          Office," allowing appointments to be scheduled anytime
                          based on calendar hours. To mark unavailable times,
                          enable provider availability and click "Add Provider
                          Availability" to input those periods.
                        </p>
                      </Div>
                      <Div>
                        <div className="Provider_availability_switch_box m_10">
                          <span className="enable_pro_avail">
                            Enable Provider Availability
                          </span>

                          <Switch
                            size="small"
                            className="switch-align-pro"
                            onChange={(checked) => {
                              if (
                                !storedNames.setProviderAvailability_viewOnly
                              ) {
                                enableSwitch(checked);
                              } else {
                                alert("You only have view-only access.");
                              }
                            }}
                            checked={switchvalue}
                            id="setting_email_switch"
                          />
                        </div>
                      </Div>
                      {switchvalue && (
                        <Div margin="10px 0px 5px 0px">
                          <AddAppTemplate
                            newsetBtnDis={setBtnDis}
                            curDate={aptdate}
                            closepopup={handleRefresh}
                            clientShow={() => AddTemplate()}
                            dataFetch={handleRefresh}
                            providerList={sourceprovider}
                            id={
                              props.start?.Id !== "" && props.ApptTab === "2"
                                ? props.start?.Id
                                : id
                            }
                            setEid={() => setEid("")}
                            row={singleRow}
                            from={"new_appointment"}
                            where={props.where}
                          />
                        </Div>
                      )}
                    </Div>
                  </TabPane>
                </Tabs>
              ) : (
                <Div
                  className="c-pop-one "
                  margin={
                    props.type !== "book again"
                      ? "20px 0px 0px -20px"
                      : "20px 0px 0px 0px"
                  }
                >
                  <Form.Row className="app-block  antd-select-height1">
                    {accountType > "0" || (accountType === "0" && trial) ? (
                      <>
                        {patFlag.map((item, ind) => (
                          <Div
                            key={ind}
                            className="new_appt_flag pt-fg-app-new"
                            style={{ backgroundColor: item.flag_color }}
                          >
                            <IoFlagOutline className="new_appt_flag_icon" />
                            <span className="new_appt_flag_amt">{`${item.flag_name} : ${item.description}`}</span>
                          </Div>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                    <div className="d_flex">
                      <div className="m_l_10">
                        <Div
                          alignItems="center"
                          className="search-pat  wholediv patient_name_out"
                        >
                          <Div margin="-20px 0px 0px -2px">
                            <PeopleOutline className="people" />
                          </Div>
                          {/* <Div className="dropdiv " id="PatId">
                            <Select
                              virtual={false}
                              getPopupContainer={(triggerNode) => (triggerNode && triggerNode.closest && triggerNode.closest(".ant-tabs-content-holder")) || document.getElementById("new-appts") || document.body} */}
                          <Div
                            ref={patientNameSelectRef}
                            className={`dropdiv ${isWaitlist && popupStep === "waitlist7" ? "waitlist-step7-active-patient-field" : ""}`}
                            id="PatId"
                          >
                            <Select
                              ref={patientSearchSelectRef}
                              virtual={false}
                              getPopupContainer={(triggerNode) =>
                                (triggerNode &&
                                  triggerNode.closest &&
                                  triggerNode.closest(
                                    ".ant-tabs-content-holder",
                                  )) ||
                                document.getElementById("new-appts") ||
                                document.body
                              }
                              open={isWaitlistStepFive ? true : undefined}
                              showSearch
                              allowClear
                              placeholder="Patient Name"
                              id="new-app-patient_1 appt-inp-patsrch "
                              suffixIcon={<BsFillCaretDownFill />}
                              className={
                                patError ? "err_mess_border w-100 b1" : "w-100"
                              }
                              // value={
                              //   patientid || searchInput
                              //     ? search1
                              //     : undefined
                              // } // control value
                              value={
                                searchInputValue || patientid
                                  ? searchInputValue
                                  : undefined
                              }
                              searchValue={searchInput}
                              onSearch={(value) => {
                                setSearchInput(value);
                                setpatsrchvalue(value);
                                setFetchingOptions(true);
                              }}
                              onSelect={(value, option) => {
                                handleDropDownSelectPatient(value, option);
                                // setSearchInput(option.title);
                                clearPatientSearchFocus();
                              }}
                              onChange={async (value, option) => {
                                if (!value) {
                                  setSearchInput("");
                                  setSearchInputValue("");
                                  setpatientid(null);
                                  setpatsrchvalue("");

                                  setAppointmentNotifyPatientWarning(false);
                                  setAppointmentNotifyChecked(false);
                                  setAppointmentNotifyExpanded(false);
                                  resetPatientDefaultContact();

                                  return;
                                }

                                const selectedTitle = option?.title || "";

                                setSearchInputValue(selectedTitle);
                                // setSearchInput(selectedTitle);
                                clearPatientSearchFocus();
                                setpatientid(value);
                                setAppointmentNotifyPatientWarning(false);
                                setAppointmentNotifyChecked(false);
                                setAppointmentNotifyExpanded(false);
                                handleDropDownSelectPatient(value, option);
                                await fetchPatientDefaultContact(
                                  value,
                                  false,
                                  true,
                                );
                              }}
                              filterOption={false}
                              notFoundContent={
                                fetchingOptions ? "Loading..." : "No Data found"
                              }
                              dropdownAlign={{
                                points: ["tl", "bl"],
                                offset: [0, 4],
                                overflow: {
                                  adjustX: true,
                                  adjustY: false,
                                },
                              }}
                              dropdownStyle={{ zIndex: 1050 }}
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <StyledDiv>
                                    <StyledButton
                                      disabled={
                                        storedNames.demo1_viewOnly ||
                                        storedNames.demo_v
                                      }
                                      onClick={() => {
                                        if (!storedNames.demo) {
                                          alert(
                                            "You don’t have access to add patients",
                                          );
                                        } else {
                                          setTemShow(false);
                                          setShow(true);
                                        }
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      <StyledSvg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                      >
                                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                                      </StyledSvg>
                                      <span
                                        onClick={() => {
                                          if (
                                            storedNames.demo1_viewOnly ||
                                            storedNames.demo_v
                                          ) {
                                            alert(
                                              "You only have view-only access.",
                                            );
                                          } else {
                                            handleAddPatient();
                                          }
                                        }}
                                      >
                                        Add Patient
                                      </span>
                                    </StyledButton>
                                  </StyledDiv>
                                  <StyledDiv ref={selectFromWaitlistRef}>
                                    <StyledButton
                                      id="select-from-waitlist-btn"
                                      onClick={handleSelectFromWaitlistClick}
                                    >
                                      <Image
                                        height="16px"
                                        width="16px"
                                        src={waitListIcon}
                                      // className="spin-img center-loading-image"
                                      />{" "}
                                      Select From Waitlist
                                    </StyledButton>
                                  </StyledDiv>
                                </>
                              )}
                            >
                              {source.map((i) => {
                                const titleLength = i.text.length;

                                return (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                    phone_cell={i.phone_cell}
                                    dob={i.dob}
                                    ss={i.ss}
                                    email={i.email}
                                  >
                                    <div>
                                      {titleLength < 15 ? (
                                        <>
                                          {i.text} -{" "}
                                          {i.dob
                                            ? moment(i.dob).format(dtFormat)
                                            : " "}
                                        </>
                                      ) : (
                                        <>
                                          <div>{i.text} -</div>
                                          <div>
                                            {i.dob
                                              ? moment(i.dob).format(dtFormat)
                                              : " "}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    <div>{i.phone_cell}</div>
                                  </Option>
                                );
                              })}
                            </Select>

                            {patError && (
                              <p className="errormessage">
                                Please select Patient
                              </p>
                            )}

                            {appointmentNotifyPatientWarning && (
                              <p className="appt-notify-patient-warning">
                                <FiAlertCircle className="appt-notify-warning-icon" />
                                Select a patient first
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="appointment_poup_div appointment_poup_div_w"
                        >
                          <Div
                            id="new_appt_radio"
                            className="appt-spn-vdovis new_app_radio_group"
                          >
                            <Radio.Group
                              onChange={
                                accountType === "-1" ||
                                  (accountType === "1" && teleFlag === "0")
                                  ? (e) => {
                                    if (Number(e.target.value) === 2) {
                                      setUpgrade(true);
                                    } else {
                                      onChangeRadio(e);
                                    }
                                  }
                                  : onChangeRadio
                              }
                              value={
                                walkincheck
                                  ? 3
                                  : forteleornor === 2
                                    ? forteleornor
                                    : Appttype
                              }
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                rowGap: "10px",
                              }}
                            >
                              <Radio
                                className="radio_appt_btn"
                                value={1}
                                onChange={checkapt}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 2 || videochck)
                                }
                              >
                                Appointment
                              </Radio>

                              <Radio
                                className="app-dashboard-radioBut m-0"
                                onClick={walkinclick}
                                value={3}
                                // disabled={videochck}
                                id="new-app-walkin"
                              >
                                Walk-in
                              </Radio>

                              <Radio
                                value={2}
                                onChange={checkvideovisit}
                                disabled={
                                  allowAppt !== 3 &&
                                  (allowAppt === 1 || !videochck)
                                }
                              >
                                Telehealth
                              </Radio>

                              <Radio value={4}>Phone Call</Radio>
                            </Radio.Group>
                            {Appttype === 4 && patientid &&
                              (!patientDefaultContact.phone ||
                                patientDefaultContact.phone.trim() === "") && (
                                <Div
                                  style={{
                                    color: "red",
                                    marginLeft: "10px",
                                    marginTop: "5px",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ErrorOutlineIcon
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "5px",
                                    }}
                                  />
                                  No Phone number found for this patient. Add an
                                  phone number to schedule the meeting
                                </Div>
                              )}
                          </Div>
                        </Div>

                        <Div margin="13px 0 0 0">
                          <Div
                            alignItems="center"
                            className=" alx wholediv new_app_facility"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <RoomOutlined />
                            </Div>
                            <Div className="dropdiv" id="officeId">
                              <Select
                                virtual={false}
                                showSearch
                                placeholder="Hospital Name"
                                id="new-app-facility_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  officeError
                                    ? `err_mess_border w-100 to-hide-ant-label ${checkFacility(
                                      "classname",
                                    )}`
                                    : `to-hide-ant-label w-100 ${checkFacility(
                                      "classname",
                                    )}`
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectOffice(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={officeid ? officeid : null}
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                }
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: 1,
                                    adjustY: 0,
                                  },
                                }}
                              >
                                {sourceoffice.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {checkFacility("spinner")}
                              {officeError && (
                                <p className="errormessage">
                                  Please select Office
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div
                          alignItems="center"
                          className="search-pat new_app_select_prov appointment_patient_div"
                        >
                          <Div margin="-2px 0px 0px -2px">
                            <PeopleOutline />
                          </Div>
                          <Div className="appointment_drop_div" id="provId">
                            <Select
                              // virtual={false}
                              showSearch
                              placeholder="Doctor Name"
                              suffixIcon={<BsFillCaretDownFill />}
                              onSelect={clearSelectActiveFocus}
                              id="new-app-provider new-app-provider_1"
                              className={
                                provError ? "err_mess_border w-100 " : "w-100"
                              }
                              onChange={(e, data) =>
                                handleDropDownSelectProvider(e, data)
                              }
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.title ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              // value={providerid ? providerid : undefined}
                              value={
                                providerid ? String(providerid) : undefined
                              }
                            // getPopupContainer={() =>
                            //   document.getElementById("provId")
                            // }
                            >
                              {sourceprovider.map((i) => (
                                <Option
                                  key={i.value}
                                  value={String(i.value)}
                                  title={i.text}
                                >
                                  {i.text}
                                </Option>
                              ))}
                            </Select>
                            {provError && (
                              <p className="errormessage">
                                Please select Provider
                              </p>
                            )}
                          </Div>
                        </Div>

                        <Div
                          className="app_repeat_dropdown position-relative app_dummy_class"
                          margin=" 0px 0px 10px 40px"
                        >
                          <BsFillCaretDownFill className="down_arrow_doesnt does-not-repeat-icon" />

                          <DropdownButton
                            id="arrow-newAppt"
                            className="app-nav-dropdown-for-newApp-repect "
                            title={repvalue ? repvalue : "Does not repeat"}
                            // title=""
                            onSelect={handlerepSelect}
                            variant="light"
                          >
                            <Dropdownant.Item eventKey="Does not repeat">
                              Does not repeat
                            </Dropdownant.Item>
                            <Dropdownant.Item
                              onClick={handleShowuntildate}
                              eventKey="Daily"
                            >
                              Daily
                            </Dropdownant.Item>
                            <Dropdownant.Item
                              onClick={handleShowuntildate}
                              eventKey={"Week"}
                            >
                              Week
                            </Dropdownant.Item>
                          </DropdownButton>
                        </Div>

                        {repvalue === "Week" && (
                          <Div margin="5px 4px 14px 40px">
                            <ToggleButtonGroup
                              type="checkbox"
                              value={weekday}
                              className="appt_repeats but-act app_gap "
                              onChange={WeekdayChange}
                              style={
                                selectdayError
                                  ? {
                                    border: "1px solid red",
                                    borderRadius: "5px",
                                  }
                                  : {}
                              }
                            >
                              <ToggleButton
                                disabled={
                                  WeeklyDisable === "Show only weekdays" ||
                                    WeeklyDisable === "Don't show Sundays"
                                    ? true
                                    : false
                                }
                                className={
                                  WeeklyDisable === "Show only weekdays" ||
                                  (WeeklyDisable === "Don't show Sundays" &&
                                    "weekDisableBtn")
                                }
                                id="tbg-btn-1"
                                value={1}
                              >
                                S
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-2" value={2}>
                                M
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={3}>
                                T
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={4}>
                                W
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={5}>
                                T
                              </ToggleButton>
                              <ToggleButton id="tbg-btn-3" value={6}>
                                F
                              </ToggleButton>
                              <ToggleButton
                                disabled={
                                  WeeklyDisable === "Show only weekdays"
                                    ? true
                                    : false
                                }
                                id="tbg-btn-3"
                                value={7}
                              >
                                S
                              </ToggleButton>
                            </ToggleButtonGroup>

                            {selectdayError && (
                              <p className="errormessage">
                                Please select atleast a day
                              </p>
                            )}
                          </Div>
                        )}

                        {repvalue !== "" &&
                          repvalue !== undefined &&
                          repvalue !== null &&
                          repvalue !== "Does not repeat" &&
                          repvalue !== "Does not repeat " && (
                            <Div
                              margin="0px 0px 10px 40px"
                              dis="flex"
                              style={{
                                flexDirection:
                                  repvalue === "Daily" ? "column" : "row",
                                alignItems:
                                  repvalue === "Daily"
                                    ? "flex-start"
                                    : "center",
                              }}
                            >
                              <Span
                                marginRight="10px"
                                color="#000000 !important"
                                style={{
                                  marginBottom:
                                    repvalue === "Daily" ? "5px" : "0px",
                                }}
                              >
                                Until:
                              </Span>
                              <Div position="relative">
                                <DatePicker
                                  getPopupContainer={(triggerNode) =>
                                    (triggerNode &&
                                      triggerNode.closest &&
                                      triggerNode.closest(
                                        ".ant-tabs-content-holder",
                                      )) ||
                                    document.getElementById("new-appts") ||
                                    document.body
                                  }
                                  disabledDate={(current) => {
                                    const oneYearFromNow = moment()
                                      .add(1, "year")
                                      .startOf("day");
                                    return (
                                      current.isBefore(
                                        moment(aptdate, dtFormat),
                                        "day",
                                      ) ||
                                      current.isAfter(oneYearFromNow, "day")
                                    );
                                  }}
                                  onChange={(date) => {
                                    if (date) {
                                      setLastdateApp(
                                        moment(date).format(dtFormat),
                                      );
                                    } else {
                                      setLastdateApp(moment().format(dtFormat));
                                    }
                                  }}
                                  placeholder="From-"
                                  format={dtFormat}
                                  onSelect={clearSelectActiveFocus}
                                  value={
                                    lastdateApp
                                      ? moment(lastdateApp, dtFormat)
                                      : null
                                  }
                                  allowClear={false}
                                />
                              </Div>
                            </Div>
                          )}
                      </div>

                      <div>
                        <Div className=" w-100 m_b_12">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px">
                              <PersonOutline />
                            </Div>
                            <Div className="dropdiv" id="ProfId">
                              <Select
                                virtual={false}
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                className={
                                  profileError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                showSearch
                                placeholder="Appt Profile"
                                id="new-app-profile_1 appt-inp-profsrch"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                onChange={(e, data) =>
                                  handleDropDownSelect(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={profileid ? profileid : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {getFilteredAndSortedProfiles(
                                  sourceprofile,
                                  changeTab === "3" || props.isGroupAppointment,
                                ).map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>

                              {profileError && (
                                <p className="errormessage">
                                  Please select Appointment Profile
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className="new_app_date_bookAgain">
                          <Div className="access_icon">
                            <AccessTimeIcon className="people" />
                          </Div>
                          <form
                            className={`${classes.container} frm-apoint`}
                            noValidate
                          >
                            <div
                              id="crt_appt-time-ok"
                              className="date-pick date-pick-parent app-datepick_bookAgain"
                            >
                              <DatePicker
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                style={{ width: "102px" }}
                                onChange={(date) => {
                                  if (date) {
                                    setaptdate(moment(date).format(dtFormat));

                                    setDateErr(false);

                                    if (appointmentNotifySchedule.customDate) {
                                      setAppointmentNotifyCustomDateWarning(
                                        false,
                                      );
                                    }

                                    return;
                                  }

                                  setaptdate("");

                                  if (props.type === "book again") {
                                    setDateErr(true);
                                  }

                                  if (
                                    props.type === "book again" &&
                                    appointmentNotifySchedule.customDate
                                  ) {
                                    setAppointmentNotifyCustomDateWarning(true);
                                  }
                                }}
                                className={dateErr ? "err-bdr-date" : ""}
                                placeholder="Select date"
                                format={dtFormat}
                                onSelect={clearSelectActiveFocus}
                                value={
                                  aptdate ? moment(aptdate, dtFormat) : null
                                }
                                allowClear={false}
                                disabledDate={
                                  Appttype == 2 &&
                                  ((current) => {
                                    return (
                                      current &&
                                      current < moment().startOf("day")
                                    );
                                  })
                                }
                              />

                              <div className="App-time ">
                                <div
                                  className="showTime"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      className="fromTime-toTime-start"
                                      onClick={() => {
                                        handleFromTime();
                                      }}
                                      onMouseLeave={() => {
                                        setTempOpen(false);
                                      }}
                                      style={{
                                        border:
                                          timeMismatch || inTimeErr
                                            ? "1px solid red"
                                            : "",
                                        width: "72px",
                                        paddingRight: "5px",
                                        paddingLeft: "4px",
                                      }}
                                      value={inTime}
                                      onChange={(e) => {
                                        if (
                                          !regexFirstNum.test(e.target.value)
                                        ) {
                                          setFromShow(false);
                                          setToShow(false);
                                          setInTime(e.target.value);
                                          setTimeMismatch(false);
                                          setTimeout(() => {
                                            setInTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );

                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "inTime",
                                            );
                                          }, 4000);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        setTimeMismatch(false);
                                        setInTime(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                        );
                                        onChange(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                          "inTime",
                                        );
                                      }}
                                    />

                                    {/* <FiChevronDown
                                      style={{
                                        position: "absolute",
                                        right: "8px",
                                        pointerEvents: "none",
                                        color: "#808080",
                                        fontSize: "14px",
                                      }}
                                    /> */}
                                  </div>

                                  <p
                                    className="time--space"
                                    style={{ margin: "0 2px" }}
                                  >
                                    -
                                  </p>

                                  <div
                                    style={{
                                      position: "relative",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      className="fromTime-toTime"
                                      onClick={() => {
                                        handleToTime();
                                      }}
                                      style={{
                                        border:
                                          timeMismatch || inTimeErr
                                            ? "1px solid red"
                                            : "",
                                        width: "72px",
                                        paddingRight: "5px",
                                        paddingLeft: "4px",
                                      }}
                                      onChange={(e) => {
                                        if (
                                          !regexFirstNum.test(e.target.value)
                                        ) {
                                          setFromShow(false);
                                          setToShow(false);
                                          setOutTime(e.target.value);
                                          setTimeMismatch(false);
                                          setTimeout(() => {
                                            setOutTime(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                            );

                                            onChange(
                                              moment(
                                                e.target.value,
                                                "h:mm A",
                                              ).format("h:mm A"),
                                              "outTime",
                                            );
                                          }, 4000);
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        setTempOpen(false);
                                      }}
                                      onBlur={(e) => {
                                        setTimeMismatch(false);
                                        setOutTime(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                        );
                                        onChange(
                                          moment(
                                            e.target.value,
                                            "h:mm A",
                                          ).format("h:mm A"),
                                          "outTime",
                                        );
                                      }}
                                      value={outTime}
                                    />
                                    {/* Inside Input Dropdown Arrow Icon */}
                                    {/* <FiChevronDown
                                      style={{
                                        position: "absolute",
                                        right: "8px",
                                        pointerEvents: "none",
                                        color: "#808080",
                                        fontSize: "14px",
                                      }}
                                    /> */}
                                  </div>
                                </div>

                                <div
                                  className={
                                    fromShow
                                      ? "fromArray-toArray availability-time-dropdown"
                                      : "fromArray_hide"
                                  }
                                >
                                  {frtimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        key={item.id}
                                        value={item.time + " " + item.meridiem}
                                        disabled={disabledFromTimes(
                                          item.time,
                                          item.meridiem,
                                          Appttype,
                                        )}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setInTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );
                                          await setFromId(item.id);
                                          handleFromButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "inTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>

                                <div
                                  className={
                                    toShow
                                      ? "fromArray-toArray availability-time-dropdown"
                                      : "toArray_hide"
                                  }
                                  style={{ left: 70 }}
                                >
                                  {totimeSlots.map((item, index) => {
                                    return (
                                      <button
                                        disabled={disabledToTime(
                                          item.time,
                                          item.meridiem,
                                          item.id,
                                          Appttype,
                                        )}
                                        key={index}
                                        value={item.time + " " + item.meridiem}
                                        onClick={async (e) => {
                                          setTimeMismatch(false);
                                          setOutTime(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                          );

                                          handleToButton(e);
                                          onChange(
                                            moment(
                                              e.target.value,
                                              "h:mm A",
                                            ).format("h:mm A"),
                                            "outTime",
                                          );
                                        }}
                                      >
                                        {item.time + " " + item.meridiem}
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            {dateErr && (
                              <Form.Text
                                id="new-app-time-codetext appt-warn-time"
                                // className="colour-red m-t-0-imp_editAppointment "
                                className="colour-red book-again-date-warning-gap"
                              >
                                Please Select valid date
                              </Form.Text>
                            )}
                          </form>
                        </Div>
                        {!props.isGroupAppointment &&
                          !props.isEditGroupAppointment &&
                          patientTimePreview && (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "-10px",
                                marginBottom: "8px",
                                paddingRight: "2px",
                              }}
                            >
                              <div
                                title={
                                  patientTimePreview.patient_timezone || ""
                                }
                                style={{
                                  maxWidth: "260px",
                                  textAlign: "right",
                                  color: "#4A5568",
                                  fontSize: "12px",
                                  lineHeight: "18px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                {getPatientTimePreviewText()}
                              </div>
                            </div>
                          )}
                        {(inTimeErr || timeMismatch) && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Please Select valid Time
                          </Form.Text>
                        )}
                        {timelimiterrorbox && (
                          <Form.Text
                            id="new-app-time-codetext appt-warn-time"
                            className="colour-red p-l-66 m-t-0-imp m-b-3"
                          >
                            Provider Only Available Between {startErrTime} to{" "}
                            {endErrTime}
                          </Form.Text>
                        )}

                        <Div style={{ textAlign: "left" }}>
                          <Popup
                            content={fornormalapp}
                            open={normalappointment}
                            trigger={
                              <Button
                                id="click_event_app_normal"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>
                        <Div>
                          <Popup
                            content={forteleapp}
                            open={teleappointment}
                            trigger={
                              <Button
                                id="click_event_app_tele"
                                content="Button"
                              />
                            }
                            position="left center"
                          />
                        </Div>

                        <Div className=" w-100">
                          <Div className="wholediv">
                            <Div margin="-20px 0px 0px -2px" size="20px">
                              <Image
                                src={doctorLogo}
                                alt="speciality"
                                height="20px"
                                width="20px"
                              />
                            </Div>

                            <Div className="dropdiv">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                virtual={false}
                                showSearch
                                placeholder="Select Speciality"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  specialError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(data) => changeSpeciality(data)}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={speciality ? speciality : null}
                                optionLabelProp="label"
                                dropdownClassName="speciality-option"
                              >
                                {sortSpeciality &&
                                  sortSpeciality
                                    .filter(
                                      (item) =>
                                        (storedNames.appt_a ||
                                          item.specialty === notDisabledSpec) &&
                                        item.count > 0,
                                    ) // Filter disabled options
                                    .map((item) => (
                                      <Option
                                        key={item.specialty}
                                        value={item.specialty}
                                        title={item.specialty}
                                        disabled={
                                          (!storedNames.appt_a &&
                                            item.specialty !==
                                            notDisabledSpec) ||
                                          item.count === 0
                                        }
                                        id={
                                          !storedNames.appt_a &&
                                            item.specialty !== notDisabledSpec
                                            ? "clr-disable"
                                            : "" || item.count == 0
                                              ? "clr-disable"
                                              : ""
                                        }
                                        className={
                                          (!storedNames.appt_a &&
                                            item.speciality !==
                                            notDisabledSpec) ||
                                          item.count === 0
                                        }
                                      >
                                        {item.speciality}
                                      </Option>
                                    ))}
                              </Select>
                              {specialError && (
                                <p className="errormessage">
                                  Select a speciality
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100" id="border">
                          <Div
                            className="wholediv"
                          // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <LocalHospitalOutlined />
                            </Div>
                            <Div
                              className={
                                videochck ? "dropdiv downDropDown" : "dropdiv"
                              }
                              id="statId"
                            >
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                virtual={false}
                                showSearch
                                placeholder="Status"
                                id="new-app-status_1 appt-inp-stas"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                // onClick={changeborder}
                                // className="form-control "
                                className={
                                  statusError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleDropDownSelectStatus(e, data)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={statusid ? statusid : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                }}
                              >
                                {checking1 ? (
                                  <></>
                                ) : (
                                  <>
                                    {Number(Appttype) === 4 ? (
                                      <>
                                        {sourcestatusphonecall.map((i) => (
                                          <Option
                                            key={i.value}
                                            value={i.value}
                                            title={i.text}
                                          >
                                            {i.text}
                                          </Option>
                                        ))}
                                      </>
                                    ) : videochck ? (
                                      <>
                                        {sourcestatustele.map((i) => (
                                          <Option
                                            key={i.value}
                                            value={i.value}
                                            title={i.text}
                                          >
                                            {i.text}
                                          </Option>
                                        ))}
                                      </>
                                    ) : (
                                      <>
                                        {sourcestatus.map((i) => (
                                          <Option
                                            key={i.value}
                                            value={i.value}
                                            title={i.text}
                                          >
                                            {i.text}
                                          </Option>
                                        ))}
                                      </>
                                    )}
                                  </>
                                )}
                              </Select>
                              {statusError && (
                                <p className="errormessage">
                                  Please select Status
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>

                        <Div className=" w-100">
                          <Div
                            className="wholediv"
                          // className="alx p-r-20"
                          >
                            <Div margin="-20px 0px 0px -2px">
                              <HomeOutlinedIcon />
                            </Div>
                            <Div className="dropdiv" id="ExaId">
                              <Select
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                virtual={false}
                                showSearch
                                placeholder="Exam Room"
                                id="new-app-profile_1"
                                suffixIcon={<BsFillCaretDownFill />}
                                onSelect={clearSelectActiveFocus}
                                className={
                                  examroomError
                                    ? "err_mess_border w-100"
                                    : "w-100"
                                }
                                onChange={(e, data) =>
                                  handleRoomVal(data.value)
                                }
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.title ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                value={roomval ? roomval : null}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                dropdownStyle={{
                                  zIndex: 1050,
                                  maxHeight: "200px",
                                }}
                              >
                                {sourceroom.map((i) => (
                                  <Option
                                    key={i.value}
                                    value={i.value}
                                    title={i.text}
                                  >
                                    {i.text}
                                  </Option>
                                ))}
                              </Select>
                              {examroomError && (
                                <p className="errormessage">
                                  Please select Exam Room
                                </p>
                              )}
                            </Div>
                          </Div>
                        </Div>
                        {repvalue !== "" &&
                          repvalue !== undefined &&
                          repvalue !== null &&
                          repvalue !== "Does not repeat" &&
                          repvalue !== "Does not repeat " && (
                            <div
                              style={{ marginTop: "10px", marginLeft: "43px" }}
                            >
                              <div style={{ width: "94px" }}>
                                <p
                                  className="remove-bor-mar"
                                  style={{ marginBottom: "4px" }}
                                >
                                  Duration
                                </p>
                                <input
                                  value={serviceDuration}
                                  style={{
                                    width: "100%",
                                    height: "38px",
                                    lineHeight: "38px",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    backgroundColor: "#fff",
                                    outline: "none",
                                    color: "#000",
                                  }}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {/* <Div display="flex" padding="0px 0px 10px 45px">
                      <p className="remove-bor-mar">Reason</p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          onSelect={clearSelectActiveFocus}
                          getPopupContainer={(triggerNode) => (triggerNode && triggerNode.closest && triggerNode.closest(".ant-tabs-content-holder")) || document.getElementById("new-appts") || document.body}
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}

                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                          }}
                        >
                          Maximum of 200 characters
                        </p>
                      )}
                    </Div> */}

                    <Div
                      display="flex"
                      flexDirection="column"
                      padding="0px 0px 10px 45px"
                    >
                      {(!repvalue ||
                        repvalue === "Does not repeat" ||
                        repvalue === "Does not repeat ") && (
                          <div
                            style={{
                              display: "flex",
                              padding: "0px 0px 15px 0px",
                              alignItems: "flex-end",
                              justifyContent: "flex-start",
                              width: "528px",
                            }}
                          >
                            {/* Service Code Dropdown */}
                            <div style={{ width: "350px" }}>
                              <p
                                className="remove-bor-mar"
                                style={{ marginBottom: "6px" }}
                              >
                                Service Code
                              </p>
                              <Select
                                mode="multiple"
                                showArrow
                                showSearch
                                filterOption={false}
                                virtual={false}
                                value={individualServiceCode}
                                placeholder="Select a Service Code"
                                style={{
                                  width: "100%",
                                  minHeight: "40px",
                                  height: "auto",
                                }}
                                size="large"
                                listHeight={125}
                                dropdownAlign={{
                                  points: ["tl", "bl"],
                                  offset: [0, 4],
                                  overflow: {
                                    adjustX: true,
                                    adjustY: false,
                                  },
                                }}
                                getPopupContainer={(triggerNode) =>
                                  (triggerNode &&
                                    triggerNode.closest &&
                                    triggerNode.closest(
                                      ".ant-tabs-content-holder",
                                    )) ||
                                  document.getElementById("new-appts") ||
                                  document.body
                                }
                                suffixIcon={
                                  <BsFillCaretDownFill
                                    size={12}
                                    color="#808080"
                                  />
                                }
                                onChange={(value) => {
                                  setIndividualServiceCode(value);
                                  setIndividualSearch("");

                                  const highestServiceCodeDuration =
                                    getHighestSelectedServiceCodeDuration(value);
                                  const defaultDuration =
                                    getBaseAppointmentDuration();
                                  const finalDuration = Math.max(
                                    highestServiceCodeDuration,
                                    defaultDuration,
                                  );

                                  setIndividualDuration(`${finalDuration} mins`);
                                  updateEndTimeFromDuration(finalDuration);
                                }}
                                onSearch={(value) => {
                                  setIndividualSearch(value);
                                }}
                              >
                                {serviceCodeOptions.map((item) => (
                                  <Option
                                    key={item.code}
                                    value={item.code}
                                    title={item.title}
                                  >
                                    {item.title}
                                  </Option>
                                ))}
                              </Select>
                            </div>

                            <div style={{ width: "94px", marginLeft: "34px" }}>
                              <p
                                className="remove-bor-mar"
                                style={{ marginBottom: "10px" }}
                              >
                                Duration
                              </p>
                              <div
                                onClick={(e) => {
                                  const inp =
                                    e.currentTarget.querySelector("input");
                                  if (inp) inp.focus();
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "38px",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: "4px",
                                  padding: "0 10px",
                                  backgroundColor: "#fff",
                                  cursor: "text",
                                }}
                              >
                                <input
                                  maxLength={3}
                                  value={
                                    individualDuration
                                      ? String(individualDuration).replace(
                                        /\D/g,
                                        "",
                                      )
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const raw = e.target.value.replace(/\D/g, "");
                                    if (raw.length > 3) return;
                                    setIndividualDuration(
                                      raw ? `${raw} mins` : "",
                                    );

                                    const parsedMinutes = parseInt(raw, 10);
                                    if (
                                      !isNaN(parsedMinutes) &&
                                      parsedMinutes > 0
                                    ) {
                                      updateEndTimeFromDuration(parsedMinutes); // 🔹 NEW
                                    }
                                  }}
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    width: `${Math.max(2, individualDuration ? String(individualDuration).replace(/\D/g, "").length : 0)}ch`,
                                    padding: 0,
                                    color: "inherit",
                                    backgroundColor: "transparent",
                                    fontSize: "inherit",
                                    fontFamily: "inherit",
                                  }}
                                />
                                <span
                                  style={{
                                    color: "inherit",
                                    fontSize: "inherit",
                                    marginLeft: "4px",
                                  }}
                                >
                                  mins
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                      <p
                        className="remove-bor-mar"
                        style={{ marginBottom: "6px" }}
                      >
                        Reason
                      </p>
                      {ENABLE_REASON_DROPDOWN ? (
                        <Select
                          value={reason || undefined}
                          onChange={(value) => setReason(value)}
                          style={{
                            width: "528px",
                            minWidth: "528px",
                            maxWidth: "528px",
                          }}
                          placeholder="Select Reason"
                          suffixIcon={
                            <BsFillCaretDownFill size={12} color="#808080" />
                          }
                          onSelect={clearSelectActiveFocus}
                          getPopupContainer={(triggerNode) =>
                            (triggerNode &&
                              triggerNode.closest &&
                              triggerNode.closest(
                                ".ant-tabs-content-holder",
                              )) ||
                            document.getElementById("new-appts") ||
                            document.body
                          }
                        >
                          {reasonOptions.map((item) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <InputSchedule
                          maxLength={200}
                          width="528px"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      )}

                      {!ENABLE_REASON_DROPDOWN && (
                        <p
                          className="remove-bor-mar-reason"
                          style={{
                            color:
                              reason && reason.length >= 200
                                ? "red"
                                : "inherit",
                            width: "528px",
                            margin: "4px 0 0 0",
                          }}
                        >
                          <div style={{ textAlign: "right" }}>
                            Maximum of 200 characters
                          </div>
                        </p>
                      )}
                    </Div>
                  </Form.Row>
                </Div>
              )}
              {!props.isGroupAppointment &&
                !props.isEditGroupAppointment &&
                props.type === "book again" &&
                renderAppointmentNotification()}
              <div className="new-appointment-footer-divider" />
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="client-app new_appt_btn_alt">
          <Button
            className="close_active close_active2 "
            variant="light"
            onClick={props.closepopup}
            disabled={isAccountSetupReminderIntroOpen}
          >
            Cancel
          </Button>
          {/* <Popup
            open={isWaitlist && popupStep === "waitlist8"}
            position="top right"
            className="appointment-waitlist-step-five-popup"
            content={
              <GetStartedPopup
                title="Accept Waitlisted Appointments"
                bullets={["Click Save to save your appointment and complete the checklist setup."]}
                currentStep={8}
                totalSteps={8}
                onBack={() => {
                  history.push({ search: "?step=waitlist7&accountSetupWaitlist=true" });
                }}
                onGotIt={async () => {
                  await axiosInstance.post(
                    `/vozo/account-setup/complete-step?patient_id=${userid}&step_id=${"24"}`
                  );
                  dispatch(clearReturnPath());
                  history.push("/settings/accountsetup");
                }}
                onClose={() => history.push({ search: "" })}
              />
            }
            trigger={
              <Button
                id="appt-btn-sve"
                className="save_active save-btn"
                variant="primary"
                type="submit"
                onClick={
                  switchvalue === false && changeTab === "2"
                    ? () => handleRefresh()
                    : (e) => handleSubmit(e)
                }
                disabled={
                  btnDis || storedNames.demo1_viewOnly || storedNames.demo_v
                }
              >
                Save
              </Button>
            }
          /> */}
          {/* </Modal.Footer> */}
          {/* } */}

          <Button
            ref={saveButtonRef}
            id="appt-btn-sve"
            className="save_active save-btn"
            variant="primary"
            type="submit"
            onClick={
              switchvalue === false && changeTab === "2"
                ? () => handleRefresh()
                : (e) => handleSubmit(e)
            }
            disabled={
              btnDis ||
              storedNames.demo1_viewOnly ||
              storedNames.demo_v ||
              isAccountSetupReminderIntroOpen ||
              isWaitlistStepFive ||
              (isWaitlist && popupStep === "waitlist7")
            }
          >
            Save
          </Button>
        </Modal.Footer>
      </div>
      {/* <Modal
        className="alert-popup-message eramsg"
        show={ModalAlerShow1}
        onHide={modalhide}
      >
        <div role="alert" className="alert-danger erapad"> */}
      {/* <BsExclamationOctagon className="icons-bs alert-icons-bts" /> */}
      {/* <FiAlertCircle className="alert-icons-bts" />
          <span>{ModalMsg1}</span>
        </div>
      </Modal> */}

      <Modal
        className={`alert-popup-message eramsg ${
          ModalMsg1?.startsWith("Time slot already booked from") ||
          isProviderUnavailableMessage(ModalMsg1)
          ? "appointment-conflict-modal"
          : ""
          }`}
        show={ModalAlerShow1}
        onHide={modalhide}
        centered
        backdrop="static"
        keyboard={false}
      >
        {ModalMsg1?.startsWith("Time slot already booked from") ? (
          <div role="alert" className="appointment-conflict-alert">
            <div className="appointment-conflict-title">
              <FiAlertTriangle className="appointment-conflict-icon" />
              <span>Appointment Conflict</span>
            </div>

            <div className="appointment-conflict-message">{ModalMsg1}</div>
          </div>
        ) : isProviderUnavailableMessage(ModalMsg1) ? (
          <div role="alert" className="appointment-conflict-alert">
            <div className="appointment-conflict-title">
              <FiAlertTriangle className="appointment-conflict-icon" />
              <span>Provider Unavailable</span>
            </div>

            <div className="appointment-conflict-message">
              {formatProviderUnavailableMessage()}
            </div>
          </div>
        ) : (
          <div role="alert" className="alert-danger erapad">
            <FiAlertCircle className="alert-icons-bts" />
            <span>{ModalMsg1}</span>
          </div>
        )}
      </Modal>

      <Modal className="alert-popup-message" show={clientFail1}>
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs" /> This email is already used for
          an existing patient. Please use a different email.
        </div>
      </Modal>

      <Modal
        className="app-popup repeat-popup rept-modal popup_centre for_weekendAppt"
        centered
        backdrop="static"
        keyboard={false}
        show={showPopup}
      >
        <RepeatPopupBlock width="640px">
          <RepeatPopupHeader>
            Recurring appointments will include weekends. Remove unwanted dates
            manually
          </RepeatPopupHeader>

          <RepeatFooter>
            <RepeatBtnConfirm
              confirm={true}
              onClick={() => {
                setShowPopup(false);
              }}
            >
              Cancel
            </RepeatBtnConfirm>
            <RepeatBtnConfirm
              confirm={true}
              onClick={() => {
                setShowPopup(false);
                if (onConfirm) onConfirm();
              }}
            >
              Ok
            </RepeatBtnConfirm>
          </RepeatFooter>
        </RepeatPopupBlock>
      </Modal>

      <Modal
        className="client-popup create-client create_modaltop wid_562"
        centered
        show={showGroupModal}
        onHide={() => {
          setShowGroupModal(false);
          // setEditData(null);
        }}
      >
        <CreateGroupClients
          onClose={() => {
            setShowGroupModal(false);
            // setEditData(null);
          }}
          editData={null}
          onSuccess={(msg) => {
            setSuccessMsg(msg);
            setShowSuccess(true);
            setTimeout(() => {
              setShowSuccess(false);
              setSuccessMsg("");
            }, 2000);
          }}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successMsg}
        </div>
      </Modal>
      {upgrade && (
        <UpgradeRequired
          title="Enable Remote Consultation"
          description="Consult patients through video visit remotely conserving resources and improving the care."
          boxContent={
            <span>
              Available in
              <span className="upgradFont"> Premium</span> plan
            </span>
          }
          handlecloseUpgrade={handlecloseUpgrade}
        />
      )}
      {showTwilioModal && (
        <TwilioRingIntegrationModal
          vendor="Twilio"
          onClose={() => {
            setShowTwilioModal(false);
            if (props.showReminderIntro4) {
              props.setShowReminderIntro4(false);
            }
          }}
          setConnected={() => {}}
          showReminderIntro4={props.showReminderIntro4}
          onReminderBack={handleReminderIntro4Back}
          onReminderNext={handleReminderIntro4Next}
          onReminderClose={() => {
            props.setShowReminderIntro4(false);
            setShowTwilioModal(false);
          }}
        />
      )}
      {showEmailModal && (
        <EmailIntegrationModal
          onClose={() => {
            setShowEmailModal(false);
            if (props.showReminderIntro5) {
              props.setShowReminderIntro5(false);
            }
          }}
          showReminderIntro5={props.showReminderIntro5}
          onReminderBack={handleReminderIntro5Back}
          onReminderNext={handleReminderIntro5Next}
          onReminderClose={() => {
            props.setShowReminderIntro5(false);
            setShowEmailModal(false);
          }}
        />
      )}
    </>
  );
};
export default memo(NewAppointment);
